<template>

    <Toast/>

    <MenuFinancialCompact v-if="userStore.user?.roles?.includes('ROLE_ISORISE')" />
    <MenuHealthCompact v-else />

    <div class="px-6 surface-overlay relative">

        <div v-show="activeTab === 1" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <ul class="list-none py-2 px-0 m-0 flex align-items-center font-medium overflow-x-auto w-full">
                        <li class="pr-3"><a class="cursor-pointer">Account</a></li>
                        <li class="px-2"><i class="pi pi-angle-right text-900"></i></li>
                        <li class="px-2"><a class="cursor-pointer text-900 white-space-nowrap">Application Store</a>
                        </li>
                        <li class="px-2"><i class="pi pi-angle-right text-900"></i></li>
                        <li class="px-2"><a class="cursor-pointer text-900 white-space-nowrap">IsoEvolve CPD Application
                            #1</a></li>
                    </ul>

                    <h3>IsoEvolve CPD Application #1</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callReset" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Application Store</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div style="height: 8px;"></div>

                    <div class="font-bold text-900 text-3xl mb-3 text-center">Four Courses</div>
                    <div class="text-700 text-center mb-3">31 CPD Points (25 Clinical CEUs, 6 Ethical CEUs)</div>

                    <div class="flex flex-wrap">
                        <div class="w-full lg:w-6 xl:w-3 p-5">
                            <img src="images/blocks/feature/feature-illustration-1.svg" alt="Image" class="w-full"/>
                            <div class="mt-3 mb-2 font-medium text-900 text-xl">Modalities of Therapy (Modules 1 to 8)
                            </div>
                            <span class="text-700 line-height-3">8 x Clinical CEUs (HPCSA Level 1), 1 x Ethical CEU (HPCSA Level 1)</span>
                            <a @click="callCourse1" tabindex="0"
                               class="text-blue-500 font-medium flex align-items-center mt-2">
                                <span>Complete</span>
                                <i class="pi pi-arrow-right ml-3"></i>
                            </a>
                        </div>

                        <div class="w-full lg:w-6 xl:w-3 p-5">
                            <img src="images/blocks/feature/feature-illustration-2.svg" alt="Image" class="w-full"/>
                            <div class="mt-3 mb-2 font-medium text-900 text-xl">Special Interest Series :: ADHD (Modules
                                1
                                to 3)
                            </div>
                            <span class="text-700 line-height-3">3 x Clinical CEUs (HPCSA Level 1)</span>
                            <a @click="callCourse2" tabindex="0"
                               class="text-blue-500 font-medium flex align-items-center mt-2">
                                <span>Complete</span>
                                <i class="pi pi-arrow-right ml-3"></i>
                            </a>
                        </div>

                        <div class="w-full lg:w-6 xl:w-3 p-5">
                            <img src="images/blocks/feature/feature-illustration-3.svg" alt="Image" class="w-full"/>
                            <div class="mt-3 mb-2 font-medium text-900 text-xl">Special Interest Series :: Disorders
                                (Modules 1
                                to 14)
                            </div>
                            <span class="text-700 line-height-3">14 x Clinical CEUs (HPCSA Level 1)</span>
                            <a @click="callCourse3" tabindex="0"
                               class="text-blue-500 font-medium flex align-items-center mt-2">
                                <span>Complete</span>
                                <i class="pi pi-arrow-right ml-3"></i>
                            </a>
                        </div>

                        <div class="w-full lg:w-6 xl:w-3 p-5">
                            <img src="images/blocks/feature/feature-illustration-4.svg" alt="Image" class="w-full"/>
                            <div class="mt-3 mb-2 font-medium text-900 text-xl">Private Practice Management</div>
                            <span class="text-700 line-height-3">5 x Ethical CEUs (HPCSA Level 1)</span>
                            <a @click="callCourse4" tabindex="0"
                               class="text-blue-500 font-medium flex align-items-center mt-2">
                                <span>Complete</span>
                                <i class="pi pi-arrow-right ml-3"></i>
                            </a>
                        </div>
                    </div>

                </div>
            </div>
        </div>


        <div v-show="activeTab === 2" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Course #1 :: Modalities of Therapy (Modules 1 to 8)</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callHome" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Home</span>
                                </a>
                            </li>
                            <li>
                                <a @click="callReset" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Application Store</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <Accordion>
                        <AccordionTab header="Course #1 :: Module #1 :: BrainWorking® Recursive Therapy (BWRT)">

                            <div class="grid">
                                <div class="col-12 md:col-12">
                                    <div class="card p-fluid">
                                        <h2>Course #1 :: Module #1 :: BrainWorking® Recursive Therapy (BWRT)</h2>

                                        <h3>Accreditation number : AOCP001/6265/12/2026</h3>

                                        <h4>1 Clinical CEUs, HPCSA Level 1</h4>
                                        <h4>1 Ethics CEUs, HPCSA Level 1</h4>

                                        <br><br>
                                        BWRT is an innovative and exciting way of treating a variety of conditions with
                                        long lasting
                                        effects.
                                        <br><br>
                                        <h3>The History of BrainWorking® Recursive Therapy</h3>
                                        This modality of therapy is based on the experimental research of
                                        neuroscientist, Libet. He
                                        discovered
                                        that our brains start to react to a stimulus even before we become aware of that
                                        particular
                                        stimulus. As
                                        a result, he thought that there is an opportunity to be able to change our
                                        reactions to the
                                        perceived
                                        stimulus by deciding how we would like to react, intervening before the brain
                                        takes over and
                                        therefore
                                        significantly changing the outcome called reaction.

                                        <br><br>
                                        Our Presenter, Mrs Shelley Hall will be introducing the concept of BWRT as well
                                        as discussing the
                                        applications of said therapeutic modality.

                                        <br><br>
                                        <h3>Aims of the Module</h3>
                                        1. An introduction to an new and exciting way of conducting therapy for patients
                                        who need quick
                                        relief
                                        from
                                        symptoms.<br>
                                        2. Understanding the applications of BWRT.<br>
                                        3. Understanding the training requirements of different practitioners.<br>
                                        4. Understanding the different levels of training that are specific to different
                                        clinical
                                        conditions.<br>
                                        5. The set up and running of an ethical BWRT private practice.<br>
                                        6. Understanding how scope of practice is crucial to running a BWRT
                                        practice.<br>
                                        7. Application of BWRT to adults and children.
                                        <br><br>
                                        The assessment of the understanding of the module is followed by a questionnaire
                                        (10 items).
                                        Based on the answers to the assessment, a certificate will be issued for your
                                        records
                                        confirming the CPD points.

                                        <br><br><br><br>

                                        <h3>Biography of Mrs. Shelley Hall</h3>
                                        Clinical Psychologist and BWRT specialist<br>
                                        MA Clinical Psychology- University of Zululand (2003)<br>
                                        BWRT-Advanced Level (2018)

                                        <br><br>
                                        Shelley Hall is an experienced Clinical Psychologist with an enduring interest
                                        in neuroscience. She
                                        regularly works to help adults and children cope with trauma, abuse, self-harm
                                        and emotional
                                        regulation
                                        issues, including anger and depression. She is an extensively qualified Brain
                                        Working Recursive
                                        Therapy
                                        (BWRT) and well experienced practitioner who believes in BWRT's ability to
                                        provide fast, efficient,
                                        client-centred solutions to multiple and often long-standing psychological
                                        issues.
                                        <br><br>
                                        Shelley’s private practice also includes working with children of all ages. She
                                        works with
                                        pre-school
                                        age children and their parents, particularly in the fields of play therapy,
                                        enuresis and separation
                                        anxiety. She works with the WISC-V and other psychometric measures to provide
                                        comprehensive
                                        assessments.
                                        Her work with psycho-legal cases, including family and criminal matters, is a
                                        responsibility that
                                        she
                                        takes seriously in order to ensure that her clients receive a fair and balanced
                                        legal process.
                                        <br><br>
                                        Shelley is also experienced in individual adult and group therapy. She applies a
                                        holistic approach
                                        to
                                        mental wellbeing and works with her clients to build resilience. Her work
                                        experience includes
                                        hospital
                                        work in general and psychiatric government and private hospitals, large
                                        companies and private
                                        practice
                                        in 3 towns. Shelley’s area of research, at Honors and Masters level, focused on
                                        HIV/AIDS. She is
                                        intrigued with trauma and enjoys working to provide preventative education and
                                        treating resulting
                                        conditions such as PTSD.
                                        <br><br>
                                        Shelley enjoys creating and running training courses and workshops. I have
                                        presented to large
                                        corporations and smaller institutions. She is passionate about learning and is
                                        always attending
                                        courses
                                        to keep her knowledge up to date. Shelley offers a course on using BWRT in the
                                        treatment of
                                        children.
                                        <br><br>
                                        <h3>Contact Details</h3>
                                        Mobile Number :: 0630552172

                                        <br><br><br><br>
                                        <h3>Watch Video for Course #1 :: Module #1 :: Video #1</h3>

                                        <div class="flex justify-content-center mt-4">

                                            <div
                                                class="w-full"
                                                style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                                <iframe
                                                    src="https://player.mediadelivery.net/embed/618381/aabb8ba7-7469-466d-a08f-f50d4a1a5ef2?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                                    loading="lazy"
                                                    style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                                    allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                                    allowfullscreen="true"></iframe>
                                            </div>
                                        </div>


                                        <br><br><br><br>
                                        <h3>Watch Video for Course #1 :: Module #1 :: Video #2</h3>

                                        <div class="flex justify-content-center mt-4">

                                            <div
                                                class="w-full"
                                                style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                                <iframe
                                                    src="https://player.mediadelivery.net/embed/618381/b2f714f8-55f1-48ff-b6c3-d53da3a0e338?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                                    loading="lazy"
                                                    style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                                    allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                                    allowfullscreen="true"></iframe>
                                            </div>
                                        </div>


                                        <br><br><br><br>
                                        <h3>Listen to Audio for Course #1 :: Module #1 :: Video #1</h3>

                                        <div class="flex justify-content-center mt-4">

                                            <div
                                                class="w-full"
                                                style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                                <iframe
                                                    src="https://player.mediadelivery.net/embed/618381/6290d8fa-dbd9-41ec-bd88-8b42507fc084?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                                    loading="lazy"
                                                    style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                                    allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                                    allowfullscreen="true"></iframe>
                                            </div>
                                        </div>

                                        <br><br><br><br>
                                        <h3>Listen to Audio for Course #1 :: Module #1 :: Video #2</h3>

                                        <div class="flex justify-content-center mt-4">

                                            <div
                                                class="w-full"
                                                style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                                <iframe
                                                    src="https://player.mediadelivery.net/embed/618381/9d47e185-f075-4c5b-92f5-011573c17660?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                                    loading="lazy"
                                                    style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                                    allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                                    allowfullscreen="true"></iframe>
                                            </div>
                                        </div>


                                        <br><br><br><br>
                                        <div class="card p-fluid">
                                            <h3>Complete Questionnaire for Course #1 : Module #1</h3>

                                            <div class="field">
                                                <label for="question1">1. What is BWRT?</label>
                                                <Dropdown v-model="course1Module1.answer1"
                                                          :options="course1Module1Question1"
                                                          optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question2">2. BWRT works with the responses from
                                                    the....</label>
                                                <Dropdown v-model="course1Module1.answer2"
                                                          :options="course1Module1Question2"
                                                          optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question3">3. What are the key factors of BWRT?</label>
                                                <Dropdown v-model="course1Module1.answer3"
                                                          :options="course1Module1Question3"
                                                          optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question4">4. Which clinical conditions can be treated by
                                                    BWRT?</label>
                                                <Dropdown v-model="course1Module1.answer4"
                                                          :options="course1Module1Question4"
                                                          optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question5">5. What are some of the challenges with setting
                                                    up private practice?</label>
                                                <Dropdown v-model="course1Module1.answer5"
                                                          :options="course1Module1Question5"
                                                          optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <Button label="Submit" class="mr-2 mb-2"
                                                    @click="submitQuestionnaireCourse1Module1"></Button>

                                        </div>

                                    </div>
                                </div>
                            </div>

                        </AccordionTab>

                        <AccordionTab header="Course #1 :: Module #2 :: Music Therapy">

                            <div class="grid">
                                <div class="col-12 md:col-12">
                                    <div class="card p-fluid">
                                        <h2>Course #1 :: Module #2 :: Music Therapy</h2>

                                        <h3>Accreditation number : AOCP001/6266/12/2026</h3>

                                        <h4>1 Clinical CEUs, HPCSA Level 1</h4>

                                        <br><br>
                                        Music Therapy is a wonderful opportunity to work with clients in a non-verbal
                                        way. It does not require
                                        clients to be
                                        musically trained or able to play an instrument. Music therapy is vast in its
                                        presentation and varied in
                                        its application.
                                        The therapist is clinical trained to use music as a tool to achieve clinical
                                        outcomes for each client.
                                        These outcomes may be behavioral, psychological or medical in nature.

                                        <br><br>
                                        This modality of therapy is based on the innate capacity that we have as human
                                        beings to respond to
                                        rhythm, melody and harmony.
                                        Our Presenter, Ms. Annelet Prinsloo will be introducing the concept of Music
                                        Therapy as well as discussing
                                        the applications
                                        of said therapeutic modality.

                                        <br><br>
                                        <h5>Aims of the Module</h5>
                                        1. An introduction to a new and exciting way of conducting therapy for patients
                                        who need relief or support
                                        where traditional modalities of therapy are not applicable.<br>
                                        2. Understanding the applications of Music Therapy.<br>
                                        3. Understanding the training requirements of different practitioners.<br>
                                        4. Understanding how and when to refer to a music therapist<br>
                                        5. Understanding the complimentary contribution of Music Therapy to traditional
                                        therapies.<br>
                                        6. Understanding how scope of practice is crucial to running a Music Therapy
                                        practice.

                                        <br><br>
                                        The assessment of the understanding of the module is followed by a questionnaire
                                        (10 items).
                                        Based on the answers to the assessment, a certificate will be issued for your
                                        records
                                        confirming the CPD points.

                                        <br><br><br><br>

                                        <h3>Biography of Annelet Prinsloo</h3>
                                        Music Therapist<br>
                                        MMus Music Therapy University of Pretoria (2019)<br>

                                        <br><br>
                                        Music Therapy recognises that every human being has an innate response to music.
                                        We respond to rhythm,
                                        melody and harmony
                                        regardless of physical or mental disability, illness or injury. Music therapy is
                                        a non-invasive,
                                        non-pharmacological medium
                                        and is used in everyday environments to reach physical, emotional, cognitive,
                                        communicative and social
                                        goals. The essential
                                        part of music therapy is that it does not require clients to be verbally
                                        proficient.

                                        <br><br>
                                        Annelet is a passionate music therapist who uses music to connect, communicate
                                        and establish
                                        relationships. She supports
                                        clients in their journeys towards resilience and fulfilment by using music in a
                                        clinical way. Before
                                        becoming a music therapist,
                                        Annelet worked as a professional puppeteer writing and performing shows about
                                        child abuse to primary
                                        school children. She has
                                        also done extensive work with the geriatric population in terms of emotional and
                                        relational issues.

                                        <br><br>
                                        She completed her Masters in Music Therapy in 2019 and her internship
                                        encompassed a variety of experiences
                                        in paediatric oncology
                                        at Steve Biko Paediatric Ward, Mental Health at Weskoppies, Alzheimer’s Disease,
                                        Dementia and elder care
                                        at a care facility for the
                                        aged in Eesterrust, drug rehabilitation at SANCA Pretoria North, Autism and
                                        special needs at UNIKA School
                                        in Pretoria and lastly
                                        Little Eden Society in the East Rand.

                                        <br><br>
                                        Annelet works with clients of all ages in the individual capacity as well as in
                                        groups. She emphasises
                                        that clients do not need
                                        prior knowledge or experience with music or musical instruments to participate.
                                        She uses music therapy to
                                        reach a number of different
                                        types of clients such as:<br>
                                        1. Those who seek personal development and growth<br>
                                        2. Those who want to explore creativity<br>
                                        3. Those who require supportive therapy due to Alzheimer’s Disease or
                                        Dementia<br>
                                        4. Those who exhibit attachment issues in relationships<br>
                                        5. Those who have depression and anxiety<br>
                                        6. Those who have experienced stress or burnout.

                                        <br><br>
                                        Annelet is currently completing her training in Helen Bonney Guided Imagery and
                                        Music Method.

                                        <br><br>
                                        <h5>Contact Details</h5>
                                        Mobile Number :: 082 631 0238<br>
                                        Practice Address :: 20 Cloete Avenue, Birchleigh, Kempton Park, 1621<br>
                                        Email :: annelet@annimotion.co.za<br>
                                        Website:: www.annimotion.co.za

                                        <br><br><br><br>
                                        <h3>Watch Video for Course #1 :: Module #2</h3>

                                        <div class="flex justify-content-center mt-4">

                                            <div
                                                class="w-full"
                                                style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                                <iframe
                                                    src="https://player.mediadelivery.net/embed/618381/17f4fd96-b7b3-4c11-b459-33bd5451d40b?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                                    loading="lazy"
                                                    style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                                    allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                                    allowfullscreen="true"></iframe>
                                            </div>
                                        </div>

                                        <br><br><br><br>
                                        <h3>Listen to Audio for Course #1 :: Module #2</h3>

                                        <div class="flex justify-content-center mt-4">

                                            <div
                                                class="w-full"
                                                style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                                <iframe
                                                    src="https://player.mediadelivery.net/embed/618381/dad58dc9-3c51-425c-aeaf-f35390749d4e?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                                    loading="lazy"
                                                    style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                                    allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                                    allowfullscreen="true"></iframe>
                                            </div>
                                        </div>

                                        <br><br><br><br>
                                        <div class="card p-fluid">
                                            <h3>Complete Questionnaire for Course #1 : Module #2</h3>

                                            <div class="field">
                                                <label for="question1">1. The outcomes of Music Therapy generally fall
                                                    into which categories of
                                                    intervention?</label>
                                                <Dropdown v-model="course1Module2.answer1"
                                                          :options="course1Module2Question1"
                                                          optionLabel="name" optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question2">2. Music Therapy is a form of therapy that
                                                    requires participants to have the
                                                    following...</label>
                                                <Dropdown v-model="course1Module2.answer2"
                                                          :options="course1Module2Question2"
                                                          optionLabel="name" optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question3">3. Which university currently offers training of
                                                    Music Therapists in South
                                                    Africa?</label>
                                                <Dropdown v-model="course1Module2.answer3"
                                                          :options="course1Module2Question3"
                                                          optionLabel="name" optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question4">4. Some of the techniques of music therapy
                                                    includes...</label>
                                                <Dropdown v-model="course1Module2.answer4"
                                                          :options="course1Module2Question4"
                                                          optionLabel="name" optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question5">5. Music therapy enables individuals with ADHD to
                                                    focus by...</label>
                                                <Dropdown v-model="course1Module2.answer5"
                                                          :options="course1Module2Question5"
                                                          optionLabel="name" optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <Button label="Submit" class="mr-2 mb-2"
                                                    @click="submitQuestionnaireCourse1Module2"></Button>
                                        </div>

                                    </div>
                                </div>
                            </div>

                        </AccordionTab>


                        <AccordionTab header="Course #1 :: Module #3 :: Hypnotherapy">

                            <div class="grid">
                                <div class="col-12 md:col-12">
                                    <div class="card p-fluid">
                                        <h2>Course #1 :: Module #3 :: Hypnotherapy</h2>

                                        <h3>Accreditation number : AOCP001/6266/12/2026</h3>

                                        <h4>1 Clinical CEUs, HPCSA Level 1</h4>

                                        <br><br>
                                        Hypnosis is a frame of mind in which you bypass the critical faculty for
                                        selective thinking.

                                        <br><br>
                                        Although this phenomenon is observed in every type of therapy, Clinical Hypnosis
                                        as a modality of therapy
                                        is making a remarkable comeback.
                                        Hypnotherapy is a modality of psychotherapy that uses the natural neurocognitive
                                        phenomenon of trance, or
                                        hypnosis, to alleviate presenting
                                        complaints and reach therapeutic goals. So in hypnosis, we take advantage of the
                                        fact that a person’s
                                        brain is programmed and inclined to
                                        go into this natural state we call hypnosis or trance in order to help them
                                        alleviate the presenting
                                        complaints and reach the therapeutic goals.

                                        <br><br>
                                        Our speaker on this Modality of Therapy is Ms. Jeanie Cave, who is a private
                                        practice owner as well as a
                                        hypnotherapist. Her task is to
                                        enlighten us about hypnotherapy in clinical practice.

                                        <br><br>
                                        <h5>Aims of the Module</h5>
                                        1. To facilitate an understanding as to how Hypnotherapy is used in clinical
                                        practice.<br>
                                        2. To understand the training and practice of clinical Hypnotherapy.<br>
                                        3. Applications of this modality of therapy.<br>
                                        4. To understand the ethical considerations around informed consent with
                                        Hypnotherapy.<br>
                                        5. To understand how the unconscious and subconscious mind play a part in
                                        Hypnotherapy.

                                        <br><br>
                                        The assessment of the understanding of the module is followed by a questionnaire
                                        (10 items).
                                        Based on the answers to the assessment, a certificate will be issued for your
                                        records
                                        confirming the CPD points.

                                        <br><br><br><br>

                                        <h3>Biography of Jeanie Cavé</h3>
                                        Clinical Psychologist and Hypnotherapist<br>
                                        MA Clinical Psychology- Unisa (2008)<br>
                                        Hypnotherapist<br>

                                        <br><br>
                                        Jeanie Cavé is the business owner of Impact Therapy Centre. She is also a
                                        passionate Clinical Psychologist
                                        working from a
                                        systemic psychotherapy paradigm and interpersonal psychotherapy model. She works
                                        with individuals,
                                        couples, families, groups, and adults.

                                        <br><br>
                                        Jeanie’s key areas of interest are:
                                        1. Hypnotherapy<br>
                                        2. Brain Spotting<br>
                                        3. Individual Psychotherapy<br>
                                        4. Person-Centered Therapy<br>
                                        5. Group Therapy<br>
                                        6. Cognitive Behavioral Therapy<br>
                                        7. Equine Assisted Psychotherapy

                                        <br><br>
                                        Jeanie is also passionate about working to empower her colleagues in the field
                                        of psychology. She runs
                                        various workshops and training
                                        for psychologists as well as supervising psychologists.

                                        <br><br>
                                        <h5>Contact Details</h5>
                                        Mobile Number :: 083 6951432, 0836951432<br>
                                        Practice Address :: 2 Blinkbaar Avenue, Witkoppen, Sandton, Johannesburg,
                                        2191<br>
                                        Email :: info@impacttherapy.co.za<br>
                                        Website:: www.impacttherapy.co.za

                                        <br><br><br><br>
                                        <h3>Watch Video for Course #1 :: Module #3</h3>

                                        <div class="flex justify-content-center mt-4">

                                            <div
                                                class="w-full"
                                                style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                                <iframe
                                                    src="https://player.mediadelivery.net/embed/618381/b9ac69c2-b533-404b-a4bd-dce95205ab31?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                                    loading="lazy"
                                                    style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                                    allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                                    allowfullscreen="true"></iframe>
                                            </div>
                                        </div>

                                        <br><br><br><br>
                                        <h3>Listen to Audio for Course #1 :: Module #3</h3>

                                        <div class="flex justify-content-center mt-4">

                                            <div
                                                class="w-full"
                                                style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                                <iframe
                                                    src="https://player.mediadelivery.net/embed/618381/8bd45964-ddb5-4a91-b25c-ea43aa6fc0eb?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                                    loading="lazy"
                                                    style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                                    allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                                    allowfullscreen="true"></iframe>
                                            </div>
                                        </div>

                                        <br><br><br><br>
                                        <div class="card p-fluid">
                                            <h3>Complete Questionnaire for Course #1 : Module #3</h3>

                                            <div class="field">
                                                <label for="question1">1. Hypnotherapy is used in the treatment of the
                                                    following conditions...</label>
                                                <Dropdown v-model="course1Module3.answer1"
                                                          :options="course1Module3Question1"
                                                          optionLabel="name" optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question2">2. The three components of the mind
                                                    are...</label>
                                                <Dropdown v-model="course1Module3.answer2"
                                                          :options="course1Module3Question2"
                                                          optionLabel="name" optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question3">3. Having healthy relationships is an indication
                                                    of having a healthy...</label>
                                                <Dropdown v-model="course1Module3.answer3"
                                                          :options="course1Module3Question3"
                                                          optionLabel="name" optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question4">4. Name different types of Hypnotherapy</label>
                                                <Dropdown v-model="course1Module3.answer4"
                                                          :options="course1Module3Question4"
                                                          optionLabel="name" optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question5">5. Which part of the mind is completely blank at
                                                    birth?</label>
                                                <Dropdown v-model="course1Module3.answer5"
                                                          :options="course1Module3Question5"
                                                          optionLabel="name" optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <Button label="Submit" class="mr-2 mb-2"
                                                    @click="submitQuestionnaireCourse1Module3"></Button>
                                        </div>

                                    </div>
                                </div>
                            </div>

                        </AccordionTab>


                        <AccordionTab header="Course #1 :: Module #4 :: Burnout and CBT">

                            <div class="grid">
                                <div class="col-12 md:col-12">
                                    <div class="card p-fluid">
                                        <h2>Course #1 :: Module #4 :: Burnout and CBT</h2>

                                        <h3>Accreditation number : AOCP001/6266/12/2026</h3>

                                        <h4>1 Clinical CEUs, HPCSA Level 1</h4>

                                        <br><br>
                                        Our speaker on this Modality of Therapy is Ms. Casey-Garnett Forman who is a
                                        Counselling Psychologist and
                                        Psychometrist. Her task is to
                                        enlighten us about Burnout and the role in Cognitive Behaviour Therapy as a
                                        treatment in clinical
                                        practice.

                                        <br><br>
                                        <h5>Aims of the Module</h5>
                                        1. To understand what Burnout is and how it is different from depression.<br>
                                        2. To facilitate an understanding as to how CBT is used in clinical
                                        practice.<br>
                                        3. To understand the role of the limbic system in the stress response and how to
                                        counteract this.<br>
                                        4. Applications of this modality of therapy.<br>
                                        5. To understand the underpinnings of CBT that can be incorporated into the
                                        therapeutic space.<br>
                                        6. To understand the ethical considerations around informed consent with CBT.

                                        <br><br>
                                        The assessment of the understanding of the module is followed by a questionnaire
                                        (10 items).
                                        Based on the answers to the assessment, a certificate will be issued for your
                                        records
                                        confirming the CPD points.

                                        <br><br><br><br>

                                        <h3>Biography of Casey-Garnett Forman</h3>
                                        Counselling Psychologist and Psychometrist<br>
                                        MA Counselling Psych University of Pretoria<br>
                                        HBA Psychometry University of Johannesburg

                                        <br><br>
                                        Casey currently assists individuals of all ages. Her key areas of interest
                                        include assisting children and
                                        adults with anxiety; depression; special needs; grief and loss; trauma; and
                                        career development and
                                        guidance.She is a registered Counselling Psychologist and Psychometrist (PS
                                        0148830), utilising an
                                        integrative approach to psychotherapy, working primarily from an interpersonal
                                        therapy model and
                                        incorporating cognitive behavioural and narrative techniques where necessary.

                                        <br><br>
                                        Casey is passionate about developing the field of psychology and strives to
                                        bring positive change to South
                                        Africa within the mental health sector by enabling and inspiring children,
                                        adolescents, families, adults
                                        and communities to create more meaningful and fulfilling lives.

                                        <br><br>
                                        Casey’s special areas of interests are:<br>
                                        1. Play therapy<br>
                                        2. Children and adults with special needs Anxiety<br>
                                        3. Depression<br>
                                        4. Trauma<br>
                                        5. Life adjustments<br>
                                        6. Grief & Loss<br>
                                        7. Cognitive Behavioural Therapy (CBT) Narrative Therapy<br>
                                        8. Interpersonal Therapy

                                        <br><br>
                                        She also offers the following assessments:<br>
                                        1. Career Development and Guidance<br>
                                        2. Subject choice assessments<br>
                                        3. School-readiness assessments<br>
                                        4. Psycho-educational assessments<br>
                                        5. Scholastic assessments<br>
                                        6. Employee wellness and development

                                        <br><br>
                                        <h5>Contact Details</h5>
                                        Mobile Number :: 087 250 0782 x39<br>
                                        Practice Address :: Langhams Medical, 1 Tamchele Avenue, Langhams Health Hub,
                                        Beverley, Fourways 2191<br>
                                        Email:: caseyformanpsychology@gmail.com<br>
                                        Website:: www.krmc.co.za

                                        <br><br><br><br>
                                        <h3>Watch Video for Course #1 :: Module #4</h3>

                                        <div class="flex justify-content-center mt-4">
                                            <div
                                                class="w-full"
                                                style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                                <iframe
                                                    src="https://player.mediadelivery.net/embed/618381/a091e9bf-f2e6-4c4c-9614-abd0486f5f80?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                                    loading="lazy"
                                                    style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                                    allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                                    allowfullscreen="true"></iframe>
                                            </div>
                                        </div>

                                        <br><br><br><br>
                                        <h3>Listen to Audio for Course #1 :: Module #4</h3>

                                        <div class="flex justify-content-center mt-4">
                                            <div
                                                class="w-full"
                                                style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                                <iframe
                                                    src="https://player.mediadelivery.net/embed/618381/47ec9c10-b23a-47d7-94b7-460b7ef46eab?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                                    loading="lazy"
                                                    style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                                    allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                                    allowfullscreen="true"></iframe>
                                            </div>
                                        </div>

                                        <br><br><br><br>
                                        <div class="card p-fluid">
                                            <h3>Complete Questionnaire for Course #1 : Module #4</h3>

                                            <div class="field">
                                                <label for="question1">1. What are the key components of
                                                    Burnout?</label>
                                                <Dropdown v-model="course1Module4.answer1"
                                                          :options="course1Module4Question1"
                                                          optionLabel="name" optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question2">2. The formula for Burnout is...</label>
                                                <Dropdown v-model="course1Module4.answer2"
                                                          :options="course1Module4Question2"
                                                          optionLabel="name" optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question3">3. Who coined the term “Amydala Hijack”</label>
                                                <Dropdown v-model="course1Module4.answer3"
                                                          :options="course1Module4Question3"
                                                          optionLabel="name" optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question4">4. Being able to regulate one’s breathing is
                                                    associated with...</label>
                                                <Dropdown v-model="course1Module4.answer4"
                                                          :options="course1Module4Question4"
                                                          optionLabel="name" optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question5">5. Which of the following is the best fit as an
                                                    example of mindfulness?</label>
                                                <Dropdown v-model="course1Module4.answer5"
                                                          :options="course1Module4Question5"
                                                          optionLabel="name" optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <Button label="Submit" class="mr-2 mb-2"
                                                    @click="submitQuestionnaireCourse1Module4"></Button>
                                        </div>

                                    </div>
                                </div>
                            </div>

                        </AccordionTab>


                        <AccordionTab header="Course #1 :: Module #5 :: Play Therapy with an Educational Psychologist">

                            <div class="grid">
                                <div class="col-12 md:col-12">
                                    <div class="card p-fluid">
                                        <h2>Course #1 :: Module #5 :: Play Therapy with an Educational Psychologist</h2>

                                        <h3>Accreditation number : AOCP001/6266/12/2026</h3>

                                        <h4>1 Clinical CEUs, HPCSA Level 1</h4>

                                        <br><br>
                                        Our speaker on this Modality of Therapy is Ms. Zaheera Seedat, an Educational
                                        Psychologist, in private
                                        practice
                                        who is passionate about working with children, and has an interest in
                                        psychological assessments and early
                                        childhood development.
                                        She also works at an NGO called Johannesburg Parent and Child Counselling
                                        Centre.

                                        <br><br>
                                        <h5>Aims of the Module</h5>
                                        1. To understand what Play Therapy is and how it is used in the treatment of
                                        children.<br>
                                        2. To understand the difference between the directive and non-directive approach
                                        in Play Therapy.<br>
                                        3. To understand how to create a therapeutic safe space for a child to work in
                                        Play Therapy.<br>
                                        4. To understand when a referral to Play Therapy is indicated.

                                        <br><br>
                                        The assessment of the understanding of the module is followed by a questionnaire
                                        (10 items).
                                        Based on the answers to the assessment, a certificate will be issued for your
                                        records
                                        confirming the CPD points.

                                        <br><br><br><br>

                                        <h3>Biography of Zaheera Seedat</h3>
                                        Educational Psychologist<br>
                                        MEd Educational Psychology- University of the Witwatersrand (2019)

                                        <br><br>
                                        Zaheera is an Educational Psychologist. She completed her training at the
                                        University of the Witwatersrand.
                                        Zaheera is passionate
                                        about working with children, and has an interest in psychological assessments
                                        and early childhood
                                        development.

                                        <br><br>
                                        As a therapist, I offer something different for a child, I offer an experience –
                                        an experience which a
                                        child is able
                                        to hold on to, attach to, internalise and negotiate with. I allow the child to
                                        use me, to become angry
                                        with me,
                                        expressing how they feel and show them that with every rupture there can be a
                                        repair.

                                        <br><br>
                                        <h5>Contact Details</h5>
                                        Mobile Number :: 083 395 0491<br>
                                        Email Address :: zaheeraseedat5@gmail.com

                                        <br><br><br><br>
                                        <h3>Watch Video for Course #1 :: Module #5</h3>

                                        <div class="flex justify-content-center mt-4">

                                            <div
                                                class="w-full"
                                                style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                                <iframe
                                                    src="https://player.mediadelivery.net/embed/618381/be695008-ba4d-44c1-98f3-e8fed0e6e5d4?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                                    loading="lazy"
                                                    style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                                    allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                                    allowfullscreen="true"></iframe>
                                            </div>
                                        </div>

                                        <br><br><br><br>
                                        <h3>Listen to Audio for Course #1 :: Module #5</h3>

                                        <div class="flex justify-content-center mt-4">

                                            <div
                                                class="w-full"
                                                style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                                <iframe
                                                    src="https://player.mediadelivery.net/embed/618381/91ece833-11ff-403c-b6ba-f37774d8ef7f?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                                    loading="lazy"
                                                    style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                                    allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                                    allowfullscreen="true"></iframe>
                                            </div>
                                        </div>

                                        <br><br><br><br>
                                        <div class="card p-fluid">
                                            <h3>Complete Questionnaire for Course #1 : Module #5</h3>

                                            <div class="field">
                                                <label for="question1">1. Play is an expression of the following things
                                                    for children...</label>
                                                <Dropdown v-model="course1Module5.answer1"
                                                          :options="course1Module5Question1"
                                                          optionLabel="name" optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question2">2. Who is one of the pioneers of Play
                                                    Therapy?</label>
                                                <Dropdown v-model="course1Module5.answer2"
                                                          :options="course1Module5Question2"
                                                          optionLabel="name" optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question3">3. Some of the techniques used in Play Therapy
                                                    are?</label>
                                                <Dropdown v-model="course1Module5.answer3"
                                                          :options="course1Module5Question3"
                                                          optionLabel="name" optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question4">4. What is the age range that is appropriate for
                                                    play therapy?</label>
                                                <Dropdown v-model="course1Module5.answer4"
                                                          :options="course1Module5Question4"
                                                          optionLabel="name" optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question5">5. When should you seek Play therapy for your
                                                    child?</label>
                                                <Dropdown v-model="course1Module5.answer5"
                                                          :options="course1Module5Question5"
                                                          optionLabel="name" optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <Button label="Submit" class="mr-2 mb-2"
                                                    @click="submitQuestionnaireCourse1Module5"></Button>
                                        </div>

                                    </div>
                                </div>
                            </div>

                        </AccordionTab>


                        <AccordionTab header="Course #1 :: Module #6 :: Contextual Therapy">

                            <div class="grid">
                                <div class="col-12 md:col-12">
                                    <div class="card p-fluid">
                                        <h2>Course #1 :: Module #6 :: Contextual Therapy</h2>

                                        <h3>Accreditation number : AOCP001/6266/12/2026</h3>

                                        <h4>1 Clinical CEUs, HPCSA Level 1</h4>

                                        <br><br>
                                        Our speaker on this Modality of Therapy is Dr. Tanya Defferary. She has been in
                                        private practice for over
                                        10 years, with a special interest
                                        in Contextual Therapy and EMDR. Tanya’s main focus is to help her clients
                                        achieve greater balance in their
                                        lives. In her work with individuals
                                        and families, she aims to facilitate change and to help people discover their
                                        true potential. She
                                        practices from her office which is situated
                                        in the peaceful neighborhood of Theescombe, in Port Elizabeth.

                                        <br><br>
                                        <h5>Aims of the Module</h5>
                                        1. To understand what Contextual Therapy is.<br>
                                        2. To facilitate an understanding as to how create a practice that focuses on
                                        Contextual Therapy.<br>
                                        3. To understand how one builds a network for referrals using Contextual Therapy
                                        as a paradigm.<br>
                                        4. Looking at how Contextual Therapy addresses the space between individual
                                        therapy and family therapy.

                                        <br><br>
                                        The assessment of the understanding of the module is followed by a questionnaire
                                        (10 items).
                                        Based on the answers to the assessment, a certificate will be issued for your
                                        records
                                        confirming the CPD points.

                                        <br><br><br><br>

                                        <h3>Biography of Dr. Tanya Defferary</h3>
                                        Counselling Psychologist<br>
                                        MA Counselling Psychology - Fort Hare (2008)<br>
                                        Doctor Philosophy (Psychology ) - Nelson Mandela Metropolitan University (2016)

                                        <br><br>
                                        After qualifying as a Counselling Psychologist in 2008, Dr Tanya Defferary went
                                        on to graduate with a
                                        Doctor of Philosophy (Psychology)
                                        Degree from the Nelson Mandela Metropolitan University in April 2016.

                                        <br><br>
                                        She has been in private practice for over 10 years, with a special interest in
                                        Contextual Therapy and
                                        EMDR. Tanya’s main focus is to
                                        help her clients achieve greater balance in their lives. In her work with
                                        individuals and families, she
                                        aims to facilitate change
                                        and to help people discover their true potential. She practices from her office
                                        which is situated in the
                                        peaceful neighbourhood
                                        of Theescombe, in Port Elizabeth.

                                        <br><br>
                                        Over the years, Tanya has worked as a school psychologist, provided therapy to
                                        children in children’s
                                        homes, as well as run
                                        her private practice. She also held the position of Senior Psychology Lecturer
                                        and BPsych Level 4
                                        Practicum Coordinator at
                                        the Pearson Institute of Higher Education for 7 years. For the past 2 years,
                                        Tanya has also offered her
                                        expertise to
                                        develop and facilitate workshops to companies and schools across South Africa.

                                        <br><br>
                                        <h5>Contact Details</h5>
                                        Mobile Number :: 061 589 1188<br>
                                        Email :: info@drdefferary.co.za

                                        <br><br><br><br>
                                        <h3>Watch Video for Course #1 :: Module #6</h3>

                                        <div class="flex justify-content-center mt-4">

                                            <div
                                                class="w-full"
                                                style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                                <iframe
                                                    src="https://player.mediadelivery.net/embed/618381/78770536-57fc-47bb-8fdf-7fec83933487?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                                    loading="lazy"
                                                    style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                                    allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                                    allowfullscreen="true"></iframe>
                                            </div>
                                        </div>

                                        <br><br><br><br>
                                        <h3>Listen to Audio for Course #1 :: Module #6</h3>

                                        <div class="flex justify-content-center mt-4">

                                            <div
                                                class="w-full"
                                                style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                                <iframe
                                                    src="https://player.mediadelivery.net/embed/618381/ecb14896-cca4-4163-bda8-a16f0ea21880?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                                    loading="lazy"
                                                    style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                                    allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                                    allowfullscreen="true"></iframe>
                                            </div>
                                        </div>

                                        <br><br><br><br>
                                        <div class="card p-fluid">
                                            <h3>Complete Questionnaire for Course #1 : Module #6</h3>

                                            <div class="field">
                                                <label for="question1">1. Contextual Therapy was developed as a new form
                                                    of therapy in...</label>
                                                <Dropdown v-model="course1Module6.answer1"
                                                          :options="course1Module6Question1"
                                                          optionLabel="name" optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question2">2. Contextual Therapy may be described as a
                                                    therapy that fits...</label>
                                                <Dropdown v-model="course1Module6.answer2"
                                                          :options="course1Module6Question2"
                                                          optionLabel="name" optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question3">3. Some of the concepts that are covered in
                                                    Contextual therapy is...</label>
                                                <Dropdown v-model="course1Module6.answer3"
                                                          :options="course1Module6Question3"
                                                          optionLabel="name" optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question4">4. What are the four dimensions in Contextual
                                                    Therapy?</label>
                                                <Dropdown v-model="course1Module6.answer4"
                                                          :options="course1Module6Question4"
                                                          optionLabel="name" optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question5">5. The purpose of the genogram in Contextual
                                                    Therapy is...</label>
                                                <Dropdown v-model="course1Module6.answer5"
                                                          :options="course1Module6Question5"
                                                          optionLabel="name" optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <Button label="Submit" class="mr-2 mb-2"
                                                    @click="submitQuestionnaireCourse1Module6"></Button>
                                        </div>

                                    </div>
                                </div>
                            </div>

                        </AccordionTab>


                        <AccordionTab
                            header="Course #1 :: Module #7 :: Hippotherapy and Sensory Integration Disorder from an Occupational Therapist’s Perspective">

                            <div class="grid">
                                <div class="col-12 md:col-12">
                                    <div class="card p-fluid">
                                        <h2>Course #1 :: Module #7 :: Hippotherapy and Sensory Integration Disorder from
                                            an Occupational Therapist’s Perspective</h2>

                                        <h3>Accreditation number : AOCP001/6266/12/2026</h3>

                                        <h4>1 Clinical CEUs, HPCSA Level 1</h4>

                                        <br><br>
                                        Our speaker on this Modality of Therapy is Ms. Emma Wijnberg who is an
                                        Occupational Therapist in private
                                        practice. Emma is also
                                        the founder of Little Lives Occupational Therapy and Big Strides Hippotherapy.
                                        Emma is passionate about
                                        understanding each and
                                        every Little Life, finding their special light, and helping them shine.

                                        <br><br>
                                        <h5>Aims of the Module</h5>
                                        1. To understand what Hippotherapy is and when is it indicated to refer a child
                                        for Hippotherapy.<br>
                                        2. To understand the difference between Hippotherapy and Equine Assisted
                                        Therapy.<br>
                                        3. To understand Hippotherapy may be used in Vestibular Stimulation.<br>
                                        4. To understand the benefits that Hippotherapy offers.<br>
                                        5. To understand the post-graduate qualifications needed to become a
                                        Hippotherapist.

                                        <br><br>
                                        The assessment of the understanding of the module is followed by a questionnaire
                                        (10 items).
                                        Based on the answers to the assessment, a certificate will be issued for your
                                        records
                                        confirming the CPD points.

                                        <br><br><br><br>

                                        <h3>Biography of Emma Wijnberg</h3>
                                        Occupational Therapist<br>
                                        BSc (Occupational Therapy)- University of Cape Town (2010)

                                        <br><br>
                                        Owner, Supervising Occupational Therapist, Speaker and Hippotherapy Partner
                                        As well as being the mother to two barefoot boys, Emma is also the founder of
                                        Little Lives Occupational
                                        Therapy and Big Strides Hippotherapy.

                                        <br><br>
                                        Emma is passionate about understanding each and every Little Life, finding their
                                        special light, and
                                        helping them shine.

                                        <br><br>
                                        Emma has completed a number of post-graduate qualifications, which she has
                                        integrated to design the
                                        unique, effective approach that she uses in her practice.
                                        Emma has done her post graduate qualification in Hippotherapy.

                                        <br><br>
                                        She is also a level 4 qualified Equine Specialist.

                                        <br><br>
                                        <h5>Contact Details</h5>
                                        Mobile Number :: 066 254 7553<br>
                                        Email :: emma.wijnberg@gmail.com

                                        <br><br><br><br>
                                        <h3>Watch Video for Course #1 :: Module #7</h3>

                                        <div class="flex justify-content-center mt-4">

                                            <div
                                                class="w-full"
                                                style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                                <iframe
                                                    src="https://player.mediadelivery.net/embed/618381/6a44d59d-c5fc-4f03-9727-45ceb79e5a64?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                                    loading="lazy"
                                                    style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                                    allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                                    allowfullscreen="true"></iframe>
                                            </div>
                                        </div>

                                        <br><br><br><br>
                                        <h3>Listen to Audio for Course #1 :: Module #7</h3>

                                        <div class="flex justify-content-center mt-4">

                                            <div
                                                class="w-full"
                                                style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                                <iframe
                                                    src="https://player.mediadelivery.net/embed/618381/f00bd631-82b9-4bc1-9b21-ab2a2e564550?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                                    loading="lazy"
                                                    style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                                    allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                                    allowfullscreen="true"></iframe>
                                            </div>
                                        </div>

                                        <br><br><br><br>
                                        <div class="card p-fluid">
                                            <h3>Complete Questionnaire for Course #1 : Module #7</h3>

                                            <div class="field">
                                                <label for="question1">1. What is Hippotherapy?</label>
                                                <Dropdown v-model="course1Module7.answer1"
                                                          :options="course1Module7Question1"
                                                          optionLabel="name" optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question2">2. Postural changes that the patient makes in
                                                    terms of Hippotherapy helps
                                                    with...</label>
                                                <Dropdown v-model="course1Module7.answer2"
                                                          :options="course1Module7Question2"
                                                          optionLabel="name" optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question3">3. Some of the challenges faced by
                                                    Hippotherapists are...</label>
                                                <Dropdown v-model="course1Module7.answer3"
                                                          :options="course1Module7Question3"
                                                          optionLabel="name" optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question4">4. The speaker’s practice has the biggest
                                                    referral from which of the following
                                                    disorders?</label>
                                                <Dropdown v-model="course1Module7.answer4"
                                                          :options="course1Module7Question4"
                                                          optionLabel="name" optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question5">5. What qualifications are needed to become a
                                                    Hippotherapist?</label>
                                                <Dropdown v-model="course1Module7.answer5"
                                                          :options="course1Module7Question5"
                                                          optionLabel="name" optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <Button label="Submit" class="mr-2 mb-2"
                                                    @click="submitQuestionnaireCourse1Module7"></Button>
                                        </div>

                                    </div>
                                </div>
                            </div>

                        </AccordionTab>


                        <AccordionTab
                            header="Course #1 :: Module #8 :: Hand Therapy from an Occupational Therapist’s Perspective">

                            <div class="grid">
                                <div class="col-12 md:col-12">
                                    <div class="card p-fluid">
                                        <h2>Course #1 :: Module #8 :: Hand Therapy from an Occupational Therapist’s
                                            Perspective</h2>

                                        <h3>Accreditation number : AOCP001/6266/12/2026</h3>

                                        <h4>1 Clinical CEUs, HPCSA Level 1</h4>

                                        <br><br>
                                        Our speaker on this Modality of Therapy is Ms. Jessica Dent who is an
                                        Occupational Therapist in private
                                        practice. During her
                                        community service year, Jessica realised her passion for working with people
                                        with hand injuries. Hand
                                        therapy includes splinting,
                                        sewing pressure garments, and finding different and creative ways to get the
                                        results you are looking for.

                                        <br><br>
                                        <h5>Aims of the Module</h5>
                                        1. To understand what Hand Therapy involves and how treatment is conducted.<br>
                                        2. To facilitate an understanding as to how a Hand Therapist works in clinical
                                        private practice.<br>
                                        3. To understand how one builds a network for referrals into a hand therapy
                                        practice<br>
                                        4. What are the illnesses, injuries, scar management etc. that a Hand Therapist
                                        would deal with.<br>
                                        5. Understanding the assessment process and treatment plan of a Hand
                                        Therapist.<br>
                                        6. Understanding the process to handling an Injury on Duty and how the Hand
                                        Therapist manages both
                                        treatment and relationship between patient and employer.

                                        <br><br>
                                        The assessment of the understanding of the module is followed by a questionnaire
                                        (10 items).
                                        Based on the answers to the assessment, a certificate will be issued for your
                                        records
                                        confirming the CPD points.

                                        <br><br><br><br>

                                        <h3>Biography of Jessica Dent</h3>
                                        Occupational Therapist<br>
                                        BSc (Occupational Therapy) University of Witwatersrand (2014)

                                        <br><br>
                                        Jessica qualified at Wits University in 2014 and completed her year of community
                                        service at Estcourt
                                        Provincial Hospital in KZN in 2015. In 2017,
                                        Jessica completed a postgraduate diploma in Hand Therapy at the University of
                                        Pretoria, and in 2019 she
                                        completed her Lymphoedema management course.

                                        <br><br>
                                        During her community service year, Jessica realised her passion for working with
                                        people with hand
                                        injuries. Hand therapy includes splinting,
                                        sewing pressure garments, and finding different and creative ways to get the
                                        results you are looking for.

                                        <br><br>
                                        From the smallest injury to the most severe, Jessica understands that for each
                                        patient their injury has
                                        turned their world upside down. While
                                        helping them through this time, Jessica finds that her patients teach her so
                                        much: “I have learnt about
                                        different cultures, jobs, family antics
                                        and so much more, and it can be really humbling”.

                                        <br><br>
                                        Jessica’s proudest moments are of graduating with a distinction in her hand
                                        therapy diploma, and when she
                                        partnered with Natalie Powell (OT)
                                        to form Powell and Dent Occupational Therapy Inc. For Jessica she absolutely
                                        loves what she does for a
                                        living. To help people to grow despite
                                        what they are going through gives Jessica indescribable happiness.

                                        <br><br>
                                        <h5>Contact Details</h5>
                                        Office Number :: 011 869 6937<br>
                                        email :: jessica@panddot.co.za

                                        <br><br><br><br>
                                        <h3>Watch Video for Course #1 :: Module #8</h3>

                                        <div class="flex justify-content-center mt-4">

                                            <div
                                                class="w-full"
                                                style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                                <iframe
                                                    src="https://player.mediadelivery.net/embed/618381/3fe089ad-e256-4c61-a357-a48fd10a26f2?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                                    loading="lazy"
                                                    style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                                    allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                                    allowfullscreen="true"></iframe>
                                            </div>
                                        </div>


                                        <br><br><br><br>
                                        <h3>Listen to Audio for Course #1 :: Module #8</h3>

                                        <div class="flex justify-content-center mt-4">

                                            <div
                                                class="w-full"
                                                style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                                <iframe
                                                    src="https://player.mediadelivery.net/embed/618381/28ef1714-9bc3-44c5-9fe8-911b6bd99ce5?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                                    loading="lazy"
                                                    style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                                    allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                                    allowfullscreen="true"></iframe>
                                            </div>
                                        </div>

                                        <br><br><br><br>
                                        <div class="card p-fluid">
                                            <h3>Complete Questionnaire for Course #1 : Module #8</h3>

                                            <div class="field">
                                                <label for="question1">1. What is hand therapy?</label>
                                                <Dropdown v-model="course1Module8.answer1"
                                                          :options="course1Module8Question1"
                                                          optionLabel="name" optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question2">2. What does the comprehensive assessment of the
                                                    hand injury/dysfunction
                                                    entail?</label>
                                                <Dropdown v-model="course1Module8.answer2"
                                                          :options="course1Module8Question2"
                                                          optionLabel="name" optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question3">3. What is the role of the hand therapist when
                                                    there is a hand injury on duty
                                                    in a work environment?</label>
                                                <Dropdown v-model="course1Module8.answer3"
                                                          :options="course1Module8Question3"
                                                          optionLabel="name" optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question4">4. Which practitioners would form part of a
                                                    multi-disciplinary hand therapist
                                                    team?</label>
                                                <Dropdown v-model="course1Module8.answer4"
                                                          :options="course1Module8Question4"
                                                          optionLabel="name" optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question5">5. What is unique to an OT hand therapist that
                                                    other professionals do not
                                                    offer?</label>
                                                <Dropdown v-model="course1Module8.answer5"
                                                          :options="course1Module8Question5"
                                                          optionLabel="name" optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <Button label="Submit" class="mr-2 mb-2"
                                                    @click="submitQuestionnaireCourse1Module8"></Button>
                                        </div>

                                    </div>
                                </div>
                            </div>

                        </AccordionTab>


                    </Accordion>


                </div>
            </div>
        </div>


        <div v-show="activeTab === 3" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Course #2 :: Special Interest Series :: ADHD (Modules 1 to 3)</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callHome" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Home</span>
                                </a>
                            </li>
                            <li>
                                <a @click="callReset" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Application Store</span>
                                </a>
                            </li>
                        </ul>
                    </div>


                    <Accordion>
                        <AccordionTab
                            header="Course #2 :: Module #1 :: Special Interest Series :: ADHD :: ADHD from a Speech Therapist’s Perspective">

                            <div class="grid">
                                <div class="col-12 md:col-12">
                                    <div class="card p-fluid">
                                        <h2>Course #2 :: Module #1 :: Special Interest Series :: ADHD :: ADHD from a
                                            Speech Therapist’s Perspective</h2>

                                        <h3>Accreditation number : AOCP001/6267/12/2026</h3>

                                        <h4>1 Clinical CEUs, HPCSA Level 1</h4>

                                        <br><br>
                                        Our speaker on this special interest series is Jolané Kotzé who is a Speech
                                        Therapist in private practice, a part-time lecturer and supervisor of other
                                        practitioners. Her task is to enlighten us about ADHD and the role of a Speech
                                        Therapist in the treatment of ADHD.

                                        <br><br>
                                        <h5>Aims of the Module</h5>
                                        1. To understand what ADHD is and how the diagnosis is made.<br>
                                        2. To facilitate an understanding as to how a Speech Therapist works with ADHD
                                        in clinical practice.<br>
                                        3. To understand the terms neurodiversity and neurotypical and how it impacts
                                        the perception of ADHD.<br>
                                        4. Comorbidities with ADHD.<br>
                                        5. To understand the underpinnings of language difficulties and the impact on
                                        the severity of ADHD.<br>
                                        6. To understand the different stages of speech therapy in a child’s development
                                        of language.

                                        <br><br>
                                        The assessment of the understanding of the module is followed by a questionnaire
                                        (10 items).
                                        Based on the answers to the assessment, a certificate will be issued for your
                                        records
                                        confirming the CPD points.

                                        <br><br><br><br>

                                        <h3>Biography of Jolané Kotze</h3>
                                        Speech Therapist and Part-time lecturer<br>
                                        B (Speech -Lang and Hearing Therapy) – Stellenbosch University (2016) <br>

                                        <br><br>
                                        Jolané is an HPCSA registered speech and language therapist with a passion for
                                        paediatrics and in her private practice she supports
                                        children and adults with communication, feeding and swallowing difficulties.

                                        <br><br>
                                        Ever the academic Jolané is a part-time lecturer and clinical supervisor at the
                                        University of Stellenbosch.

                                        <br><br>
                                        Her special areas of interest include:<br>
                                        1. ADHD / Learning Difficulties<br>
                                        2. Babies / Toddlers<br>
                                        3. Children<br>
                                        4. Autism<br>
                                        5. Remedial Therapy

                                        <br><br>
                                        <h5>Contact Details</h5>
                                        Mobile Number :: 0844180742 / 0724802223<br>
                                        Practice Address :: 87 Borghorst Street, Monte Vista, Cape Town, 7460<br>
                                        Email:: jolaneslt@gmail.com

                                        <br><br><br><br>
                                        <h3>Watch Video for Course #2 :: Module #1</h3>

                                        <div class="flex justify-content-center mt-4">

                                            <div
                                                class="w-full"
                                                style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                                <iframe
                                                    src="https://player.mediadelivery.net/embed/618381/a22275e0-6978-4c33-8aa7-9281f934d6ac?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                                    loading="lazy"
                                                    style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                                    allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                                    allowfullscreen="true"></iframe>
                                            </div>
                                        </div>

                                        <br><br><br><br>
                                        <h3>Listen to Audio for Course #2 :: Module #1</h3>

                                        <div class="flex justify-content-center mt-4">

                                            <div
                                                class="w-full"
                                                style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                                <iframe
                                                    src="https://player.mediadelivery.net/embed/618381/fb1d1be3-c55c-4b60-a45e-93eeed7c7227?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                                    loading="lazy"
                                                    style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                                    allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                                    allowfullscreen="true"></iframe>
                                            </div>
                                        </div>

                                        <br><br><br><br>
                                        <div class="card p-fluid">
                                            <h3>Complete Questionnaire for Course #2 : Module #1</h3>

                                            <div class="field">
                                                <label for="question1">1. Is a treatment plan for ADHD normally
                                                    standardised?</label>
                                                <Dropdown v-model="course2Module1.answer1"
                                                          :options="course2Module1Question1" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question2">2. Are children with ADHD normally
                                                    talkative?</label>
                                                <Dropdown v-model="course2Module1.answer2"
                                                          :options="course2Module1Question2" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question3">3. How long does speech therapy for a patient
                                                    normally last?</label>
                                                <Dropdown v-model="course2Module1.answer3"
                                                          :options="course2Module1Question3" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question4">4. Is a paeditrician and a psychiatrist a normal
                                                    referral practitioner for a speech therapist working with
                                                    ADHD?</label>
                                                <Dropdown v-model="course2Module1.answer4"
                                                          :options="course2Module1Question4" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question5">5. Is ADHD a neurological condition?</label>
                                                <Dropdown v-model="course2Module1.answer5"
                                                          :options="course2Module1Question5" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <Button label="Submit" class="mr-2 mb-2"
                                                    @click="submitQuestionnaireCourse2Module1"></Button>

                                        </div>

                                    </div>
                                </div>
                            </div>

                        </AccordionTab>

                        <AccordionTab
                            header="Course #2 :: Module #2 :: Special Interest Series :: ADHD :: Discussing Adult ADHD with an Educational Psychologist">

                            <div class="grid">
                                <div class="col-12 md:col-12">
                                    <div class="card p-fluid">
                                        <h2>Course #2 :: Module #2 :: Special Interest Series :: ADHD :: Discussing
                                            Adult ADHD with an Educational Psychologist</h2>

                                        <h3>Accreditation number : AOCP001/6267/12/2026</h3>

                                        <h4>1 Clinical CEUs, HPCSA Level 1</h4>

                                        <br><br>
                                        Our speaker on this special interest series is Mr. Dayne Williams, a registered
                                        educational psychologist who is passionate about
                                        young adult and adolescent mental health. He works with a broad range of
                                        concerns including anxiety, ADHD, depression, social
                                        challenges and personal development amongst many others.

                                        <br><br>
                                        <h5>Aims of the Module</h5>
                                        1. To understand the process of diagnosis with Adult ADHD<br>
                                        2. To facilitate an understanding of the difficulties that individuals with
                                        Adult ADHD face in relationships and responsibilities.<br>
                                        3. To understand the management and treatment of Adult ADHD.<br>
                                        4. To understand the role of executive functioning in Adult ADHD.<br>

                                        <br><br>
                                        The assessment of the understanding of the module is followed by a questionnaire
                                        (10 items).
                                        Based on the answers to the assessment, a certificate will be issued for your
                                        records
                                        confirming the CPD points.

                                        <br><br><br><br>

                                        <h3>Biography of Dayne Williams</h3>
                                        Educational Psychologist<br>
                                        M Ed (Educ Psychology) – Stellenbosch University (2020)

                                        <br><br>
                                        Dayne is a registered educational psychologist who is passionate about young
                                        adult & adolescent mental health. He works with a broad
                                        range of concerns including anxiety, ADHD, depression, social challenges and
                                        personal development amongst many others. His goal as a
                                        therapist is to work alongside his patients to promote & encourage positive
                                        change in their lives, in whatever way that is defined
                                        and valued by them. He feels strongly that sustainable change happens when we
                                        feel comfortable and empowered to make our own decisions.
                                        This is the reason he places great importance on a genuinely warm and empathetic
                                        therapeutic relationship in which one can grow.

                                        <br><br>
                                        He has a wide range of interest areas but focuses solely on young adults and
                                        adolescents. He practices using several forms of therapy
                                        such as psychodynamics, narrative therapy and mindfulness-based cognitive
                                        therapy which brings together traditional CBT approaches and mindfulness.

                                        <br><br>
                                        <h5>Contact Details</h5>
                                        Mobile Number :: 062 346 1776<br>
                                        Email :: dayne@edugrow.co.za

                                        <br><br><br><br>
                                        <h3>Watch Video for Course #2 :: Module #2</h3>

                                        <div class="flex justify-content-center mt-4">

                                            <div
                                                class="w-full"
                                                style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                                <iframe
                                                    src="https://player.mediadelivery.net/embed/618381/1f05bc3f-e883-4efe-a60a-92538340fca6?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                                    loading="lazy"
                                                    style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                                    allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                                    allowfullscreen="true"></iframe>
                                            </div>
                                        </div>

                                        <br><br><br><br>
                                        <h3>Listen to Audio for Course #2 :: Module #2</h3>

                                        <div class="flex justify-content-center mt-4">

                                            <div
                                                class="w-full"
                                                style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                                <iframe
                                                    src="https://player.mediadelivery.net/embed/618381/ee622b90-9132-44b5-99dc-37729fc9d704?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                                    loading="lazy"
                                                    style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                                    allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                                    allowfullscreen="true"></iframe>
                                            </div>
                                        </div>

                                        <br><br><br><br>
                                        <div class="card p-fluid">
                                            <h3>Complete Questionnaire for Course #2 : Module #2</h3>

                                            <div class="field">
                                                <label for="question1">1. Why is there ADHD in Adults?</label>
                                                <Dropdown v-model="course2Module2.answer1"
                                                          :options="course2Module2Question1" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question2">2. Do coping skills help a patient deal with
                                                    ADHD?</label>
                                                <Dropdown v-model="course2Module2.answer2"
                                                          :options="course2Module2Question2" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question3">3. Is planning and organising an example of
                                                    executive functioning?</label>
                                                <Dropdown v-model="course2Module2.answer3"
                                                          :options="course2Module2Question3" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question4">4. What is normally considered in the first
                                                    sessions with a patient with ADHD?</label>
                                                <Dropdown v-model="course2Module2.answer4"
                                                          :options="course2Module2Question4" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question5">5. At what age should ADHD have been present for
                                                    a typical diagnosis of patient?</label>
                                                <Dropdown v-model="course2Module2.answer5"
                                                          :options="course2Module2Question5" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <Button label="Submit" class="mr-2 mb-2"
                                                    @click="submitQuestionnaireCourse2Module2"></Button>

                                        </div>

                                    </div>
                                </div>
                            </div>

                        </AccordionTab>


                        <AccordionTab
                            header="Course #2 :: Module #3 :: Special Interest Series :: ADHD :: Insights from a Paediatric Occupational Therapist">

                            <div class="grid">
                                <div class="col-12 md:col-12">
                                    <div class="card p-fluid">
                                        <h2>Course #2 :: Module #3 :: Special Interest Series :: ADHD :: Insights from a
                                            Paediatric Occupational Therapist</h2>

                                        <h3>Accreditation number : AOCP001/6267/12/2026</h3>

                                        <h4>1 Clinical CEUs, HPCSA Level 1</h4>

                                        <br><br>
                                        Our speaker on this special interest series is Ms. Ashley Jones, who is an
                                        Occupational Therapist in private practice.
                                        Ashley Jones is the founder and owner of Bright Eyes Therapy. She graduated cum
                                        laude from the University of Pretoria in 2017
                                        and discovered her passion for Paediatric.

                                        <br><br>
                                        Ashley ensures that she stays up to date with training and evidence-based
                                        practice, She is Ayres Sensory Integration (ASI)
                                        trained as well DIR Floortime trained. She is a fun-loving, gentle and kind
                                        therapist and finds kids the most phenomenal
                                        little beings. She always gravitates towards children and finds their zest for
                                        life, energy and world views so fulfilling.

                                        <br><br>
                                        <h5>Aims of the Module</h5>
                                        1. To understand what a Paediatric Occupational Therapist treats in private
                                        practice.<br>
                                        2. To understand how one builds a network for referrals into a Paediatric
                                        Therapy Practice.<br>
                                        3. Understanding the assessment process and treatment plan of a Paediatric
                                        Occupational Therapist.<br>
                                        4. Looking at the role of Ayres Sensory Integration (ASI) in various paediatric
                                        conditions.

                                        <br><br>
                                        The assessment of the understanding of the module is followed by a questionnaire
                                        (10 items).
                                        Based on the answers to the assessment, a certificate will be issued for your
                                        records
                                        confirming the CPD points.

                                        <br><br><br><br>

                                        <h3>Biography of Ashley Jones</h3>
                                        Occupational Therapist<br>
                                        B Occupational Therapy- University of Pretoria (2017)

                                        <br><br>
                                        Ashley Jones is the founder and owner of Bright Eyes Therapy. She graduated cum
                                        laude from the University of Pretoria in 2017.
                                        She received numerous awards and acknowledgments during this time including a
                                        Golden Key Membership and an award for the highest
                                        marks in paediatrics.

                                        <br><br>
                                        Ashley ensures that she stays up to date with training and evidence-based
                                        practice, She is Ayres Sensory Integration (ASI) trained
                                        as well DIR Floortime trained. She is a fun-loving, gentle and kind therapist
                                        and finds kids the most phenomenal little beings.
                                        She always gravitates towards children and finds their zest for life, energy and
                                        world views so fulfilling.

                                        <br><br>
                                        For this reason, she has decided to dedicate her time, passion and expertise to
                                        ensure each child reaches their full potential.
                                        She endeavors to ensure optimal development by involving parents, teachers,
                                        family members and sport coaches throughout the therapy process.

                                        <br><br>
                                        <h5>Contact Details</h5>
                                        Mobile Number :: 083 616 1662<br>
                                        Email Address :: ashley.brighteyestherapy@gmail.com<br>
                                        Practice Address :: 594 Tassel Street, Garsfontein, Pretoria, 0042<br>
                                        Website Address :: https://bright-eyes-therapy.com

                                        <br><br><br><br>
                                        <h3>Watch Video for Course #2 :: Module #3</h3>

                                        <div class="flex justify-content-center mt-4">

                                            <div
                                                class="w-full"
                                                style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                                <iframe
                                                    src="https://player.mediadelivery.net/embed/618381/457eea8f-bccf-4d4f-9906-20e69a7d4514?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                                    loading="lazy"
                                                    style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                                    allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                                    allowfullscreen="true"></iframe>
                                            </div>
                                        </div>

                                        <br><br><br><br>
                                        <h3>Listen to Audio for Course #2 :: Module #3</h3>

                                        <div class="flex justify-content-center mt-4">

                                            <div
                                                class="w-full"
                                                style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                                <iframe
                                                    src="https://player.mediadelivery.net/embed/618381/ed954da6-1ba1-47c8-bb26-e30700777a5a?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                                    loading="lazy"
                                                    style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                                    allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                                    allowfullscreen="true"></iframe>
                                            </div>
                                        </div>

                                        <br><br><br><br>
                                        <div class="card p-fluid">
                                            <h3>Complete Questionnaire for Course #2 : Module 3</h3>

                                            <div class="field">
                                                <label for="question1">1. Is sensory integration difficulties normally
                                                    worked on by an OT for a patient with ADHD?</label>
                                                <Dropdown v-model="course2Module3.answer1"
                                                          :options="course2Module3Question1" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question2">2. What are examples of calming actions?</label>
                                                <Dropdown v-model="course2Module3.answer2"
                                                          :options="course2Module3Question2" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question3">3. Do you have to buy specialised OT equipment to
                                                    help a child with ADHD at home?</label>
                                                <Dropdown v-model="course2Module3.answer3"
                                                          :options="course2Module3Question3" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question4">4. Can a cause for ADHD clearly be understood for
                                                    a client?</label>
                                                <Dropdown v-model="course2Module3.answer4"
                                                          :options="course2Module3Question4" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question5">5. What can an OT help a child's reaction
                                                    with?</label>
                                                <Dropdown v-model="course2Module3.answer5"
                                                          :options="course2Module3Question5" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <Button label="Submit" class="mr-2 mb-2"
                                                    @click="submitQuestionnaireCourse2Module3"></Button>

                                        </div>

                                    </div>
                                </div>
                            </div>

                        </AccordionTab>

                    </Accordion>


                </div>
            </div>
        </div>


        <div v-show="activeTab === 4" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Course #3 :: Special Interest Series :: Disorders (Modules 1 to 14)</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callHome" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Home</span>
                                </a>
                            </li>
                            <li>
                                <a @click="callReset" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Application Store</span>
                                </a>
                            </li>
                        </ul>
                    </div>


                    <Accordion>
                        <AccordionTab
                            header="Course #3 :: Module #1 :: Special Interest Series :: Disorders :: Discussing Autism from a Speech Therapist’s Perspective">

                            <div class="grid">
                                <div class="col-12 md:col-12">
                                    <div class="card p-fluid">
                                        <h2>Course #3 :: Module #1 :: Special Interest Series :: Disorders :: Discussing
                                            Autism from a Speech Therapist’s Perspective</h2>

                                        <h3>Accreditation number : AOCP001/6268/12/2026</h3>

                                        <h4>1 Clinical CEUs, HPCSA Level 1</h4>

                                        <br><br>
                                        Our speaker on this module is Ms. Marié Theart, who is a Speech Therapist in
                                        private practice. Marié
                                        supports children in the
                                        pre-primary and primary schools in her area. She has a passion for autism and
                                        works at 2 special needs
                                        schools in Cape Town.
                                        Marié completed her Professional Certificate Level 1 for the DIR model and the
                                        Foundational Capacities for
                                        Development (FCD™) in 2017.
                                        This has forever changed her approach to help support children who struggle with
                                        communication
                                        difficulties, as well as their parents and educators.

                                        <br><br>
                                        <h5>Aims of the Module</h5>
                                        1. To understand what the Autistic Spectrum entails.<br>
                                        2. To understand the process of diagnosis according to the DSM V, and what the
                                        outdated terms referred to.<br>
                                        3. Understanding the multi-disciplinary approach to autism to maximize
                                        therapeutic goals.<br>
                                        4. Coping mechanisms and strategies for parents with children on the Autistic
                                        spectrum.

                                        <br><br>
                                        The assessment of the understanding of the module is followed by a questionnaire
                                        (10 items).
                                        Based on the answers to the assessment, a certificate will be issued for your
                                        records
                                        confirming the CPD points.

                                        <br><br><br><br>

                                        <h3>Biography of Marié Theart</h3>
                                        Speech Therapist<br>
                                        BA Speech Language and Hearing Therapy – Stellenbosch University (2007)<br>
                                        Profectum Professional Level 1 Certificate (CL1)

                                        <br><br>
                                        Marié earned her BA in speech-language and hearing therapy from the University
                                        of Stellenbosch,
                                        South-Africa in 2007. She is currently
                                        a paediatric speech therapist in Cape Town, South-Africa, and is a member of a
                                        private multi-professional
                                        practice where she has been working since 2010.

                                        <br><br>
                                        Marié supports children in the pre- and primary schools in her area. She has a
                                        passion for autism and
                                        works at 2 special needs schools
                                        in Cape Town. Marié completed her Professional Certificate Level 1 for the DIR
                                        model and the Foundational
                                        Capacities for
                                        Development (FCD™) in 2017. This has forever changed her approach to help
                                        support children who struggle
                                        with communication difficulties,
                                        as well as their parents and educators.

                                        <br><br>
                                        To her, the carers of the child with communication difficulties hold the key to
                                        empowering that individual
                                        to become the best regulated
                                        and engaged individual that he/she can be, using whatever forms of communication
                                        that person finds
                                        functional.

                                        <br><br>
                                        <h5>Contact Details</h5>
                                        Mobile Number :: 072 480 2223<br>
                                        Email Address :: mariet.salt@gmail.com<br>

                                        <br><br><br><br>
                                        <h3>Watch Video for Course #3 :: Module #1</h3>

                                        <div class="flex justify-content-center mt-4">

                                            <div
                                                class="w-full"
                                                style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                                <iframe
                                                    src="https://player.mediadelivery.net/embed/618381/21e0262b-93fa-4b6a-a149-5e6bd2e5e4e5?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                                    loading="lazy"
                                                    style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                                    allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                                    allowfullscreen="true"></iframe>
                                            </div>
                                        </div>


                                        <br><br><br><br>
                                        <h3>Listen to Audio for Course #3 :: Module #1</h3>

                                        <div class="flex justify-content-center mt-4">

                                            <div
                                                class="w-full"
                                                style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                                <iframe
                                                    src="https://player.mediadelivery.net/embed/618381/4fca832f-dc00-443e-a21e-3e38a3be6f39?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                                    loading="lazy"
                                                    style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                                    allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                                    allowfullscreen="true"></iframe>
                                            </div>
                                        </div>

                                        <br><br><br><br>
                                        <div class="card p-fluid">
                                            <h3>Complete Questionnaire for Course #3 :: Module #1</h3>

                                            <div class="field">
                                                <label for="question1">1. Autism was defined in the past...</label>
                                                <Dropdown v-model="course3Module1.answer1"
                                                          :options="course3Module1Question1" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question2">2. The DSM V has acknowledged Autism as a
                                                    neurodiverse condition...</label>
                                                <Dropdown v-model="course3Module1.answer2"
                                                          :options="course3Module1Question2" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question3">3. According to the speaker, what can be ruled
                                                    out as causes of Autism:</label>
                                                <Dropdown v-model="course3Module1.answer3"
                                                          :options="course3Module1Question3" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question4">4. How does the speaker describe an interruption
                                                    in the development of
                                                    children?</label>
                                                <Dropdown v-model="course3Module1.answer4"
                                                          :options="course3Module1Question4" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question5">5. The speaker believes that the following is the
                                                    easiest form of
                                                    communication:</label>
                                                <Dropdown v-model="course3Module1.answer5"
                                                          :options="course3Module1Question5" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <Button label="Submit" class="mr-2 mb-2"
                                                    @click="submitQuestionnaireCourse3Module1"></Button>

                                        </div>

                                    </div>
                                </div>
                            </div>

                        </AccordionTab>

                        <AccordionTab
                            header="Course #3 :: Module #2 :: Special Interest Series :: Disorders :: Discussing Sensory Integration Disorder from an Occupational Therapist’s Perspective">

                            <div class="grid">
                                <div class="col-12 md:col-12">
                                    <div class="card p-fluid">
                                        <h2>Course #3 :: Module #2 :: Special Interest Series :: Disorders :: Discussing
                                            Sensory Integration Disorder from an Occupational Therapist’s
                                            Perspective</h2>

                                        <h3>Accreditation number : AOCP001/6268/12/2026</h3>

                                        <h4>1 Clinical CEUs, HPCSA Level 1</h4>

                                        <br><br>
                                        Our speaker on this module is Ms. René Loggerenberg. René is an Occupational
                                        Therapist with a special
                                        interest in Paediatrics and Sensory Integration.

                                        <br><br>
                                        She completed her degree in Occupational Therapy at the University of Pretoria
                                        in 2005. René has worked at
                                        various private paediatric practices and
                                        remedial schools since then and completed her training in Ayres Sensory
                                        Integration ® in 2008. She is also
                                        a qualified Interactive Metronome provider,
                                        and has completed various other courses on additional treatment modalities and
                                        complimentary tools.

                                        <br><br>
                                        <h5>Aims of the Module</h5>
                                        1. To understand what Sensory Integration Disorder is.<br>
                                        2. To identify the difficulties that children experience that are related to
                                        Sensory Integration Disorder.<br>
                                        3. Understanding the prevalence of Sensory Integration Disorder on a spectrum of
                                        severity.<br>
                                        4. To understand the impact of early diagnosis and intervention on Sensory
                                        Integration Disorder.

                                        <br><br>
                                        The assessment of the understanding of the module is followed by a questionnaire
                                        (10 items).
                                        Based on the answers to the assessment, a certificate will be issued for your
                                        records
                                        confirming the CPD points.

                                        <br><br><br><br>

                                        <h3>Biography of René Loggerenberg</h3>
                                        Occupational Therapist and Sensory Integration specialist<br>
                                        B Occ Therapy- University of Pretoria (2005)<br>
                                        Completed Ayres Sensory Integration ® in 2008

                                        <br><br>
                                        René is an Occupational Therapist with a special interest in Paediatrics and
                                        Sensory Integration.

                                        <br><br>
                                        She completed her degree in Occupational Therapy at the University of Pretoria
                                        in 2005. René has worked at
                                        various private paediatric practices
                                        and remedial schools since then and completed her training in Ayres Sensory
                                        Integration ® in 2008. She is
                                        also a qualified Interactive Metronome provider,
                                        and has completed various other courses on additional treatment modalities and
                                        complementary tools.

                                        <br><br>
                                        René started SenseAble Kids as she has a passion for helping children reach
                                        their full potential, and she
                                        loves building trusting relationships
                                        with children and to see their confidence grow. In order to achieve this she
                                        also values the importance of
                                        working with the child’s parents and
                                        the rest of the multidisciplinary team to complement the child’s therapy
                                        process.

                                        <br><br>
                                        <h5>Contact Details</h5>
                                        Mobile Number :: 082 440 3788<br>
                                        Email :: info@senseblekids.co.za

                                        <br><br><br><br>
                                        <h3>Watch Video for Course #3 :: Module #2</h3>

                                        <div class="flex justify-content-center mt-4">

                                            <div
                                                class="w-full"
                                                style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                                <iframe
                                                    src="https://player.mediadelivery.net/embed/618381/f0253fc9-11e2-4322-90a3-ae570b8a1d22?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                                    loading="lazy"
                                                    style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                                    allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                                    allowfullscreen="true"></iframe>
                                            </div>
                                        </div>

                                        <br><br><br><br>
                                        <h3>Listen to Audio for Course #3 :: Module #2</h3>

                                        <div class="flex justify-content-center mt-4">

                                            <div
                                                class="w-full"
                                                style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                                <iframe
                                                    src="https://player.mediadelivery.net/embed/618381/735db3d5-036a-4178-b4c8-28751d345690?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                                    loading="lazy"
                                                    style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                                    allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                                    allowfullscreen="true"></iframe>
                                            </div>
                                        </div>


                                        <br><br><br><br>
                                        <div class="card p-fluid">
                                            <h3>Complete Questionnaire for Course #3 : Module #2</h3>

                                            <div class="field">
                                                <label for="question1">1. What is sensory integration disorder?</label>
                                                <Dropdown v-model="course3Module2.answer1"
                                                          :options="course3Module2Question1" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question2">2. The speaker views the development of a child
                                                    in the form of a triangle.
                                                    Which are the three levels of functioning that are taken into
                                                    consideration?</label>
                                                <Dropdown v-model="course3Module2.answer2"
                                                          :options="course3Module2Question2" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question3">3. Which system forms the foundations of
                                                    development?</label>
                                                <Dropdown v-model="course3Module2.answer3"
                                                          :options="course3Module2Question3" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question4">4. What are some of the emotional difficulties
                                                    that children with sensory
                                                    integration disorder face?</label>
                                                <Dropdown v-model="course3Module2.answer4"
                                                          :options="course3Module2Question4" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question5">5. Which two systems affect handwriting?</label>
                                                <Dropdown v-model="course3Module2.answer5"
                                                          :options="course3Module2Question5" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <Button label="Submit" class="mr-2 mb-2"
                                                    @click="submitQuestionnaireCourse3Module2"></Button>

                                        </div>

                                    </div>
                                </div>
                            </div>

                        </AccordionTab>

                        <AccordionTab
                            header="Course #3 :: Module #3 :: Special Interest Series :: Disorders :: Discussing Bereavement from a Clinical Psychologist's Perspective">

                            <div class="grid">
                                <div class="col-12 md:col-12">
                                    <div class="card p-fluid">
                                        <h2>Course #3 :: Module #3 :: Special Interest Series :: Disorders :: Discussing
                                            Bereavement from a Clinical Psychologist's Perspective</h2>

                                        <h3>Accreditation number : AOCP001/6268/12/2026</h3>

                                        <h4>1 Clinical CEUs, HPCSA Level 1</h4>

                                        <br><br>
                                        Our speaker on this module is Ms. Bronwen Davies, who is a Clinical Psychologist
                                        in private practice.
                                        Bronwen works with adults of all ages, and does individual therapy, as well as
                                        couple counselling.
                                        Through psychotherapy and counselling, she helps her clients make sense of their
                                        psychological distress;
                                        find helpful ways to manage their problems; and strive towards mental health and
                                        well-being.

                                        <br><br>
                                        <h5>Aims of the Module</h5>
                                        1. To understand what grief and bereavement entails.<br>
                                        2. Understanding grief and bereavement in the pandemic.<br>
                                        3. To understand the role of guilt in the bereavement process.<br>
                                        4. To understand the stages of bereavement.<br>
                                        5. To understand when referral for bereavement is necessary.

                                        <br><br>
                                        The assessment of the understanding of the module is followed by a questionnaire
                                        (10 items).
                                        Based on the answers to the assessment, a certificate will be issued for your
                                        records
                                        confirming the CPD points.

                                        <br><br><br><br>

                                        <h3>Biography of Bronwen Davies</h3>
                                        Clinical Psychologist in Private Practice<br>

                                        <br><br>
                                        Bronwen works with adults of all ages, and does individual therapy, as well as
                                        couple counselling. Through
                                        psychotherapy and counselling, she helps her clients make sense of their
                                        psychological distress; find
                                        helpful ways to manage their problems; and strive towards mental health and
                                        well-being.

                                        <br><br>
                                        Bronwen believes that emotional pain and distress is every bit as real and
                                        challenging, as physical
                                        illness or injury, and you do not have to suffer on, alone, just because your
                                        pain cannot be seen. There
                                        is hope and there is help available. She has over twenty years' experience as a
                                        mental health
                                        professional.

                                        <br><br>
                                        <h5>Special Areas of Interest</h5>
                                        1. Cancer Counselling<br>
                                        2. Bereavement<br>
                                        3. Mood Disorders<br>
                                        4. Relationship issues<br>
                                        5. Stress

                                        <br><br>
                                        <h5>Contact Details</h5>
                                        Mobile Number :: 083 2727017<br>
                                        Email Address :: 1bronwen.d@gmail.com

                                        <br><br><br><br>
                                        <h3>Watch Video for Course #3 :: Module #3</h3>

                                        <div class="flex justify-content-center mt-4">

                                            <div
                                                class="w-full"
                                                style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                                <iframe
                                                    src="https://player.mediadelivery.net/embed/618381/7d7a6c48-eedd-4fbf-85c8-6e80cbb1391e?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                                    loading="lazy"
                                                    style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                                    allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                                    allowfullscreen="true"></iframe>
                                            </div>
                                        </div>

                                        <br><br><br><br>
                                        <h3>Listen to Audio for Course #3 :: Module #3</h3>

                                        <div class="flex justify-content-center mt-4">

                                            <div
                                                class="w-full"
                                                style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                                <iframe
                                                    src="https://player.mediadelivery.net/embed/618381/4cfaf28e-100d-4a71-a1d6-4135b6f8f70b?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                                    loading="lazy"
                                                    style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                                    allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                                    allowfullscreen="true"></iframe>
                                            </div>
                                        </div>

                                        <br><br><br><br>
                                        <div class="card p-fluid">
                                            <h3>Complete Questionnaire for Course #3 : Module #3</h3>

                                            <div class="field">
                                                <label for="question1">1. What was one of the sparks that led the
                                                    speaker to focus on bereavement as
                                                    an area of interest?</label>
                                                <Dropdown v-model="course3Module3.answer1"
                                                          :options="course3Module3Question1" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question2">2. What are the referral sources that the speaker
                                                    mentions for her private
                                                    practice?</label>
                                                <Dropdown v-model="course3Module3.answer2"
                                                          :options="course3Module3Question2" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question3">3. How long has the speaker been in private
                                                    practice?</label>
                                                <Dropdown v-model="course3Module3.answer3"
                                                          :options="course3Module3Question3" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question4">4. Are guilt and shame closely tied to
                                                    bereavement?</label>
                                                <Dropdown v-model="course3Module3.answer4"
                                                          :options="course3Module3Question4" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question5">5. What is one of the common scenarios with
                                                    parents losing a child in
                                                    death?</label>
                                                <Dropdown v-model="course3Module3.answer5"
                                                          :options="course3Module3Question5" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <Button label="Submit" class="mr-2 mb-2"
                                                    @click="submitQuestionnaireCourse3Module3"></Button>

                                        </div>

                                    </div>
                                </div>
                            </div>

                        </AccordionTab>

                        <AccordionTab
                            header="Course #3 :: Module #4 :: Special Interest Series :: Disorders :: Discussing Disenfranchised Grief from a Counselling Psychologist's Perspective">

                            <div class="grid">
                                <div class="col-12 md:col-12">
                                    <div class="card p-fluid">
                                        <h2>Course #3 :: Module #4 :: Special Interest Series :: Disorders :: Discussing
                                            Disenfranchised Grief from a Counselling Psychologist's Perspective</h2>

                                        <h3>Accreditation number : AOCP001/6268/12/2026</h3>

                                        <h4>1 Clinical CEUs, HPCSA Level 1</h4>

                                        <br><br>
                                        Our speaker on this module is Ms. Bêne Otto, who is passionate about working
                                        with adults, adolescents and
                                        couples, helping them navigate a variety of life challenges such as depression,
                                        anxiety, burnout and
                                        trauma. She has a special interest in grief and bereavement, with a particular
                                        focus on normalising the
                                        grief experience and helping society become more grief literate.

                                        <br><br>
                                        <h5>Aims of the Module</h5>
                                        1. To understand what Disenfranchised Grief is and how this compares to Grief
                                        and Bereavement.<br>
                                        2. Understanding Disenfranchised Grief in the pandemic.<br>
                                        3. To understand the role of Grief in the bereavement process and allowing
                                        people to speak about their
                                        loss openly.<br>
                                        4. To understand the importance of religious and cultural rites and rituals in
                                        the process of
                                        grieving.<br>
                                        5. To understand the impact of Disenfranchised Grief on the individual who
                                        experiences the loss.

                                        <br><br>
                                        The assessment of the understanding of the module is followed by a questionnaire
                                        (10 items).
                                        Based on the answers to the assessment, a certificate will be issued for your
                                        records
                                        confirming the CPD points.

                                        <br><br><br><br>

                                        <h3>Biography of Bêne Otto</h3>
                                        Counselling Psychologist

                                        <br><br>
                                        Bêne works in Private Practice in Melville, Johannesburg. She is currently
                                        completing a PhD at the
                                        University of Johannesburg in Disenfranchised Grief.

                                        <br><br>
                                        Bêne completed her MA in Counselling Psychology (cum laude). She did her
                                        internship at the Counselling
                                        and Careers Development Unit (CCDU) at Wits, where she was trained in
                                        psychotherapy (children, adults and
                                        couples),
                                        psychological assessment, group therapy and career counselling. She has also
                                        worked as a Locum
                                        Psychologist
                                        at Mayo Clinic and Akeso Arcadia Clinic, as well as lecturing psychology on a
                                        temporary basis at the
                                        University of Johannesburg.

                                        <br><br>
                                        Bêne is passionate about working with adults, adolescents and couples, helping
                                        them navigate a variety of
                                        life challenges such as depression, anxiety, burnout and trauma. She has a
                                        special interest in grief and
                                        bereavement, with a particular focus on normalising the grief experience and
                                        helping society become more
                                        grief literate.

                                        <br><br>
                                        <h5>Special Areas of Interest</h5>
                                        1. Bereavement<br>
                                        2. Anxiety<br>
                                        3. Disenfranchised Grief<br>
                                        4. Depression

                                        <br><br>
                                        <h5>Contact Details</h5>
                                        Mobile Number :: 066 072 6699<br>
                                        Email Address :: beneotto1@gmail.com<br>
                                        Practice Address :: 35 3rd Avenue, Melville, Johannesburg<br>
                                        Website Address :: https://beneotto.wixsite.com/website

                                        <br><br><br><br>
                                        <h3>Watch Video for Course #3 :: Module #4</h3>

                                        <div class="flex justify-content-center mt-4">

                                            <div
                                                class="w-full"
                                                style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                                <iframe
                                                    src="https://player.mediadelivery.net/embed/618381/6a2168ce-dfa9-4699-af21-601ff3d9a0eb?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                                    loading="lazy"
                                                    style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                                    allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                                    allowfullscreen="true"></iframe>
                                            </div>
                                        </div>

                                        <br><br><br><br>
                                        <h3>Listen to Audio for Course #3 :: Module #4</h3>

                                        <div class="flex justify-content-center mt-4">

                                            <div
                                                class="w-full"
                                                style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                                <iframe
                                                    src="https://player.mediadelivery.net/embed/618381/7e69d236-4f70-4b7f-8845-88fca865dea3?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                                    loading="lazy"
                                                    style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                                    allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                                    allowfullscreen="true"></iframe>
                                            </div>
                                        </div>

                                        <br><br><br><br>
                                        <div class="card p-fluid">
                                            <h3>Complete Questionnaire for Course #3 : Module #4</h3>

                                            <div class="field">
                                                <label for="question1">1. How should we approach loss?</label>
                                                <Dropdown v-model="course3Module4.answer1"
                                                          :options="course3Module4Question1" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question2">2. How can we support those that have experienced
                                                    loss?</label>
                                                <Dropdown v-model="course3Module4.answer2"
                                                          :options="course3Module4Question2" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question3">3. What is disenfranchised grief?</label>
                                                <Dropdown v-model="course3Module4.answer3"
                                                          :options="course3Module4Question3" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question4">4. What do we do to make sure that we are not
                                                    disenfranchising someone's
                                                    loss?</label>
                                                <Dropdown v-model="course3Module4.answer4"
                                                          :options="course3Module4Question4" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question5">5. Does disenfranchised grief only pertain to the
                                                    loss of people?</label>
                                                <Dropdown v-model="course3Module4.answer5"
                                                          :options="course3Module4Question5" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <Button label="Submit" class="mr-2 mb-2"
                                                    @click="submitQuestionnaireCourse3Module4"></Button>

                                        </div>

                                    </div>
                                </div>
                            </div>

                        </AccordionTab>

                        <AccordionTab
                            header="Course #3 :: Module #5 :: Special Interest Series :: Disorders :: Discussing Anxiety in Children and Teens from a Counselling Psychologist's Perspective">

                            <div class="grid">
                                <div class="col-12 md:col-12">
                                    <div class="card p-fluid">
                                        <h2>Course #3 :: Module #5 :: Special Interest Series :: Disorders :: Discussing
                                            Anxiety in Children and Teens from a Counselling Psychologist's
                                            Perspective</h2>

                                        <h3>Accreditation number : AOCP001/6268/12/2026</h3>

                                        <h4>1 Clinical CEUs, HPCSA Level 1</h4>

                                        <br><br>
                                        Our speaker on this module is Ms. Jayde Green, who is a Counselling Psychologist
                                        in private practice.
                                        She is a Counselling Psychologist practicing from Westville, Durban, and works
                                        predominantly with children
                                        and adolescents. She offers play therapy, intellectual assessments, career
                                        assessment and guidance,
                                        psychotherapy, and counselling.

                                        <br><br>
                                        <h5>Aims of the Module</h5>
                                        1. To understand Childhood anxieties and how they impact children and teens.<br>
                                        2. Understanding when psychological intervention is needed in the presentation
                                        of anxiety in children and
                                        teens.<br>
                                        3. To understand the assessment and treatment process with children and teens
                                        with anxiety.<br>
                                        4. Understanding the role of triggers in anxiety and how to develop coping
                                        mechanisms.

                                        <br><br>
                                        The assessment of the understanding of the module is followed by a questionnaire
                                        (10 items).
                                        Based on the answers to the assessment, a certificate will be issued for your
                                        records
                                        confirming the CPD points.

                                        <br><br><br><br>

                                        <h3>Biography of Jayde Green</h3>
                                        Counselling Psychologist in Private Practice

                                        <br><br>
                                        Ms. Jayde Green, who is a Counselling Psychologist in private practice. She is a
                                        Counselling Psychologist
                                        practising from Westville, Durban, and works predominantly with children and
                                        adolescents. She offers play
                                        therapy,
                                        intellectual assessments, career assessment and guidance, psychotherapy, and
                                        counselling.

                                        <br><br>
                                        <h5>Special Areas of Interest</h5>
                                        1. Children and Teen’s Anxiety<br>
                                        2. Career Counselling<br>
                                        3. Video Game Addiction<br>
                                        4. ADHD<br>
                                        5. Behavioural Issues<br>
                                        6. Coping Skills<br>
                                        7. Parenting<br>
                                        8. School Issues<br>
                                        9. Trauma and PTSD<br>
                                        10. Video Game Addiction

                                        <br><br>
                                        <h5>Contact Details</h5>
                                        Mobile Number :: 081 385 4431<br>
                                        Email Address :: jayde@greenpsych.co.za<br>
                                        Practice Address :: 28 Rodger Sishi Road, Grayleigh, Westville, 3629

                                        <br><br><br><br>
                                        <h3>Watch Video for Course #3 :: Module #5</h3>

                                        <div class="flex justify-content-center mt-4">

                                            <div
                                                class="w-full"
                                                style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                                <iframe
                                                    src="https://player.mediadelivery.net/embed/618381/a685d933-e13a-4001-9490-3ea5d96991df?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                                    loading="lazy"
                                                    style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                                    allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                                    allowfullscreen="true"></iframe>
                                            </div>
                                        </div>

                                        <br><br><br><br>
                                        <h3>Listen to Audio for Course #3 :: Module #5</h3>

                                        <div class="flex justify-content-center mt-4">

                                            <div
                                                class="w-full"
                                                style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                                <iframe
                                                    src="https://player.mediadelivery.net/embed/618381/69eb60ac-813b-4836-9bb8-9704bbd54679?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                                    loading="lazy"
                                                    style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                                    allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                                    allowfullscreen="true"></iframe>
                                            </div>
                                        </div>

                                        <br><br><br><br>
                                        <div class="card p-fluid">
                                            <h3>Complete Questionnaire for Course #3 : Module #5</h3>

                                            <div class="field">
                                                <label for="question1">1. How is anxiety often present in
                                                    children?</label>
                                                <Dropdown v-model="course3Module5.answer1"
                                                          :options="course3Module5Question1" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question2">2. What is normal anxiety?</label>
                                                <Dropdown v-model="course3Module5.answer2"
                                                          :options="course3Module5Question2" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question3">3. How does one diagnose anxiety in
                                                    children?</label>
                                                <Dropdown v-model="course3Module5.answer3"
                                                          :options="course3Module5Question3" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question4">4. How does a therapist treat anxiety in
                                                    children?</label>
                                                <Dropdown v-model="course3Module5.answer4"
                                                          :options="course3Module5Question4" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question5">5. What does Jayde recommend for creating a space
                                                    to manage anxiety?</label>
                                                <Dropdown v-model="course3Module5.answer5"
                                                          :options="course3Module5Question5" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <Button label="Submit" class="mr-2 mb-2"
                                                    @click="submitQuestionnaireCourse3Module5"></Button>

                                        </div>

                                    </div>
                                </div>
                            </div>

                        </AccordionTab>

                        <AccordionTab
                            header="Course #3 :: Module #6 :: Special Interest Series :: Disorders :: Discussing Depression and Suicide from an Educational Psychologist's Perspective">

                            <div class="grid">
                                <div class="col-12 md:col-12">
                                    <div class="card p-fluid">
                                        <h2>Course #3 :: Module #6 :: Special Interest Series :: Disorders :: Discussing
                                            Depression and Suicide from an Educational Psychologist's Perspective</h2>

                                        <h3>Accreditation number : AOCP001/6268/12/2026</h3>

                                        <h4>1 Clinical CEUs, HPCSA Level 1</h4>

                                        <br><br>
                                        Our speaker on this module is Ms. Laila Jeebodh-Desai is an Educational
                                        Psychologist at St Peter’s college
                                        where she provides Psycho- Educational Assessments and Therapeutic Interventions
                                        which includes
                                        Mindfulness-Based practices, Narrative Therapy, Solution Focused brief therapy
                                        and other blended
                                        techniques.
                                        Laila has been a lecturer at the South African College of Applied Psychology in
                                        Johannesburg since 2016.

                                        <br><br>
                                        <h5>Aims of the Module</h5>
                                        1. To understand depression and suicide.<br>
                                        2. Learning about how suicidal ideation and behaviour are different.<br>
                                        3. Being able to identify the signs of suicidal ideation and behaviour.<br>
                                        4. Understanding how isolation during Covid pandemic has contributed to
                                        depression and suicide.<br>
                                        5. Prevalence of depression and suicide in both population groups.<br>
                                        6. Misconceptions of suicide.

                                        <br><br>
                                        The assessment of the understanding of the module is followed by a questionnaire
                                        (10 items).
                                        Based on the answers to the assessment, a certificate will be issued for your
                                        records
                                        confirming the CPD points.

                                        <br><br><br><br>

                                        <h3>Biography of Laila Jeebodh-Desai</h3>
                                        Educational Psychologist at St. Peter’s College

                                        <br><br>
                                        Laila Jeebodh-Desai is an Educational Psychologist at St Peter’s college where
                                        she provides Psycho-
                                        Educational Assessments and Therapeutic Interventions which includes
                                        Mindfulness-Based practices,
                                        Narrative Therapy, Solution Focused brief therapy and other blended techniques.
                                        Laila also practices as a
                                        lecturer at the South African College of Applied Psychology in Johannesburg
                                        since 2016.

                                        <br><br>
                                        As part of a community outreach, Laila is part of the Atlantic Humanitarian
                                        Relief group (AHR), which is a
                                        non-profit organisation which conducts medical, surgical, psychological and
                                        humanitarian missions in
                                        Jordan Amman to assist Syrian Women and Children in camps.

                                        <br><br>
                                        Laila’s narrative entails global and unique domestic experiences from living and
                                        working in South Korea
                                        teaching English to children and adults, then returning to her homeland in South
                                        Africa to complete her
                                        Honours and Master’s degrees in Educational Psychology at the University of
                                        Johannesburg. Laila also
                                        worked in a school with special needs children diagnosed with Autism Spectrum
                                        Disorder (ASD); Attention
                                        Deficit Hyperactivity Disorder (ADHD); and Pervasive Developmental Disorder
                                        (PDD). As part of her
                                        internship programme she thoroughly enjoyed her experience of working at King
                                        David College and immersing
                                        herself to understand and celebrate Jewish ethnicity. Proudly a diverse South
                                        African female and
                                        passionate about Mindfulness practices, Laila is also a member of the Institute
                                        of Mindfulness in South
                                        Africa (IMISA).

                                        <br><br>
                                        Laila is currently completing her PhD through the University of Johannesburg
                                        (UJ). Her study focuses on
                                        Trauma Sensitive Mindfulness for the treatment of Post-Traumatic Stress Disorder
                                        (PTSD) of refugee
                                        survivors of war. A proud Mom to her Beagle, Rocco, and wife to a Zimbabwean,
                                        Laila enjoys spending her
                                        free time travelling, exploring diversities, diving, cooking, boxing and
                                        spending quality time with her
                                        family.

                                        <br><br>
                                        <h5>Contact Details</h5>
                                        Mobile Number :: +27 82 885 8579<br>
                                        Physical Address: 38 Central Park,9 Laing Street,Sandton, 2196

                                        <br><br><br><br>
                                        <h3>Watch Video for Course #3 :: Module #6</h3>

                                        <div class="flex justify-content-center mt-4">

                                            <div
                                                class="w-full"
                                                style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                                <iframe
                                                    src="https://player.mediadelivery.net/embed/618381/5e86ece1-6424-4b9d-8c5f-c1e6249a3639?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                                    loading="lazy"
                                                    style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                                    allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                                    allowfullscreen="true"></iframe>
                                            </div>
                                        </div>

                                        <br><br><br><br>
                                        <h3>Listen to Audio for Course #3 :: Module #6</h3>

                                        <div class="flex justify-content-center mt-4">

                                            <div
                                                class="w-full"
                                                style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                                <iframe
                                                    src="https://player.mediadelivery.net/embed/618381/6fb359cd-e32b-46f6-8aaf-e4a293cbae6f?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                                    loading="lazy"
                                                    style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                                    allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                                    allowfullscreen="true"></iframe>
                                            </div>
                                        </div>

                                        <br><br><br><br>
                                        <div class="card p-fluid">
                                            <h3>Complete Questionnaire for Course #3 : Module #6</h3>

                                            <div class="field">
                                                <label for="question1">1. How did we connect to the speaker and invite
                                                    her to do the course?</label>
                                                <Dropdown v-model="course3Module6.answer1"
                                                          :options="course3Module6Question1" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question2">2. Which Winnie the Pooh character symbolises
                                                    depression?</label>
                                                <Dropdown v-model="course3Module6.answer2"
                                                          :options="course3Module6Question2" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question3">3. Is depression synonymous with suicide?</label>
                                                <Dropdown v-model="course3Module6.answer3"
                                                          :options="course3Module6Question3" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question4">4. What are often catalysts to mental health
                                                    disorders?</label>
                                                <Dropdown v-model="course3Module6.answer4"
                                                          :options="course3Module6Question4" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question5">5. Which demographic is more prone to
                                                    suicide?</label>
                                                <Dropdown v-model="course3Module6.answer5"
                                                          :options="course3Module6Question5" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <Button label="Submit" class="mr-2 mb-2"
                                                    @click="submitQuestionnaireCourse3Module6"></Button>

                                        </div>

                                    </div>
                                </div>
                            </div>

                        </AccordionTab>

                        <AccordionTab
                            header="Course #3 :: Module #7 :: Special Interest Series :: Disorders :: Discussing Postnatal Depression and Birth Trauma from a Social Worker's Perspective">

                            <div class="grid">
                                <div class="col-12 md:col-12">
                                    <div class="card p-fluid">
                                        <h2>Course #3 :: Module #7 :: Special Interest Series :: Disorders :: Discussing
                                            Postnatal Depression and Birth Trauma from a Social Worker's
                                            Perspective</h2>

                                        <h3>Accreditation number : AOCP001/6268/12/2026</h3>

                                        <h4>1 Clinical CEUs, HPCSA Level 1</h4>

                                        <br><br>
                                        Our speaker on this module is Ms. Sally Baker, a Social Worker in private
                                        practice, with a special
                                        interest
                                        in Women’s health.

                                        <br><br>
                                        <h5>Aims of the Module</h5>
                                        1. To understand the role that a Social worker can play in Postnatal Depression
                                        as part of a
                                        multidisciplinary team.<br>
                                        2. To identify the difficulties women experience when they have Postnatal
                                        Depression.<br>
                                        3. To understand the healing process in Birth Trauma for both Mother and child.

                                        <br><br>
                                        The assessment of the understanding of the module is followed by a questionnaire
                                        (10 items).
                                        Based on the answers to the assessment, a certificate will be issued for your
                                        records
                                        confirming the CPD points.

                                        <br><br><br><br>

                                        <h3>Biography of Sally Baker</h3>
                                        Social Worker

                                        <br><br>
                                        Sally Baker has been passionate about women and women's issues for as long as
                                        she can remember.
                                        Sally is privileged to be a mother of two independent adult children, She is
                                        also a social worker,
                                        ex-doula,
                                        childbirth educator, counsellor, mentor, trainer, and facilitator.

                                        <br><br>
                                        She has a social work private practice based in Johannesburg where she
                                        specialises in supporting people
                                        through all experiences and transitions. Online Zoom sessions and webinars allow
                                        her to assist clients
                                        throughout South Africa and abroad.
                                        Her focus is on helping people “birth” more of themselves hence the name “Birth
                                        Support” which was first
                                        created in 2003 when she first became a doula. 17 years later, she now trains
                                        childbirth professionals on
                                        trauma informed practices and has developed the training Birth Trauma
                                        Dissolution.

                                        <br><br>
                                        <h5>Special Areas of Interest</h5>
                                        1. BWRT<br>
                                        2. EMI<br>
                                        3. Emotional and physical birth trauma<br>
                                        4. Loss<br>
                                        5. Postpartum Depression<br>
                                        6. Anxiety<br>
                                        7. PTSD

                                        <br><br>
                                        <h5>Contact Details</h5>
                                        Mobile Number :: 082 584 0666<br>
                                        Email Address :: sally@birthsupport.co.za<br>
                                        Practice Address :: The Collaborative Healing Centre, 17 Cactus Road, Kyalami,
                                        Johannesburg, 1684<br>
                                        Website Address :: https://www.sallybaker.co.za<br>
                                        Website Address :: https://www.birthsupport.co.za

                                        <br><br><br><br>
                                        <h3>Watch Video for Course #3 :: Module #7</h3>

                                        <div class="flex justify-content-center mt-4">

                                            <div
                                                class="w-full"
                                                style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                                <iframe
                                                    src="https://player.mediadelivery.net/embed/618381/62320cb7-f669-43ba-8090-249597e7d5cb?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                                    loading="lazy"
                                                    style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                                    allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                                    allowfullscreen="true"></iframe>
                                            </div>
                                        </div>

                                        <br><br><br><br>
                                        <h3>Listen to Audio for Course #3 :: Module #7</h3>

                                        <div class="flex justify-content-center mt-4">

                                            <div
                                                class="w-full"
                                                style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                                <iframe
                                                    src="https://player.mediadelivery.net/embed/618381/2eb93606-42ed-4b87-82bb-2cc5a8fc69fe?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                                    loading="lazy"
                                                    style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                                    allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                                    allowfullscreen="true"></iframe>
                                            </div>
                                        </div>

                                        <br><br><br><br>
                                        <div class="card p-fluid">
                                            <h3>Complete Questionnaire for Course #3 : Module #7</h3>

                                            <div class="field">
                                                <label for="question1">1. What was the speaker's journey into working
                                                    with birth support?</label>
                                                <Dropdown v-model="course3Module7.answer1"
                                                          :options="course3Module7Question1" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question2">2. What is the focus of most pregnancies?</label>
                                                <Dropdown v-model="course3Module7.answer2"
                                                          :options="course3Module7Question2" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question3">3. What is a common referral source for the
                                                    speaker?</label>
                                                <Dropdown v-model="course3Module7.answer3"
                                                          :options="course3Module7Question3" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question4">4. Have dads changed as parents over the
                                                    ages?</label>
                                                <Dropdown v-model="course3Module7.answer4"
                                                          :options="course3Module7Question4" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question5">5. What are good gifts for parents?</label>
                                                <Dropdown v-model="course3Module7.answer5"
                                                          :options="course3Module7Question5" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <Button label="Submit" class="mr-2 mb-2"
                                                    @click="submitQuestionnaireCourse3Module7"></Button>

                                        </div>

                                    </div>
                                </div>
                            </div>

                        </AccordionTab>

                        <AccordionTab
                            header="Course #3 :: Module #8 :: Special Interest Series :: Disorders :: Discussing Bipolar and Depressive Disorders from a Clinical Psychologist's Perspective">

                            <div class="grid">
                                <div class="col-12 md:col-12">
                                    <div class="card p-fluid">
                                        <h2>Course #3 :: Module #8 :: Special Interest Series :: Disorders :: Discussing
                                            Bipolar and Depressive Disorders from a Clinical Psychologist's
                                            Perspective</h2>

                                        <h3>Accreditation number : AOCP001/6268/12/2026</h3>

                                        <h4>1 Clinical CEUs, HPCSA Level 1</h4>

                                        <br><br>
                                        Our speaker on this module is Ms. Laure’ Coulter. Laure’ is a qualified Clinical
                                        Psychologist registered
                                        with the Health Professions Council of South Africa (HPCSA) offering a range of
                                        psychological services in
                                        both English and Afrikaans. She is currently based at the Psych Central
                                        psychology practice in Rivonia,
                                        Sandton where she primarily offers psychotherapeutic services for adults,
                                        adolescents, and couples.

                                        <br><br>
                                        <h5>Aims of the Module</h5>
                                        1. To gain an understanding of Depression and Bipolar Mood disorders.<br>
                                        2. How to identify the symptoms of Depression and what to look out for.<br>
                                        3. To gain an understanding of prognosis of Depression.<br>
                                        4. How to identify the symptoms of Bipolar Mood Disorder.<br>
                                        5. Understanding the decreased need for sleep in Bipolar Mood Disorder.<br>
                                        6. Understanding comorbidities with mood disorders.

                                        <br><br>
                                        The assessment of the understanding of the module is followed by a questionnaire
                                        (10 items).
                                        Based on the answers to the assessment, a certificate will be issued for your
                                        records
                                        confirming the CPD points.

                                        <br><br><br><br>

                                        <h3>Biography of Lauré Coulter</h3>
                                        Clinical Psychologist

                                        <br><br>
                                        Lauré is a qualified Clinical Psychologist registered with the Health
                                        Professions Council of South Africa
                                        (HPCSA) offering a range of psychological services in both English and
                                        Afrikaans.

                                        <br><br>
                                        She graduated Cum Laude with her Bachelor of Arts and Honours Psychology degrees
                                        at the University of
                                        Johannesburg. Thereafter, she obtained her Master’s Degree Cum Laude in Clinical
                                        Psychology from Nelson
                                        Mandela University.

                                        <br><br>
                                        Lauré is currently based at the Psych Central psychology practice in Rivonia,
                                        Sandton where she primarily
                                        offers psychotherapeutic services for adults, adolescents, and couples.

                                        <br><br>
                                        <h5>Special Areas of interests</h5>
                                        1. Anxiety<br>
                                        2. Depressive Disorders<br>
                                        3. Trauma/Grief<br>
                                        4. Relationship problems

                                        <br><br>
                                        <h5>Contact Details</h5>
                                        Mobile Number :: 066 259 1627<br>
                                        Email Address :: admin@psychcentral.co.za<br>
                                        Practice Address :: Block F, 37 Homestead Rd, Rivonia, Sandton, 2128<br>
                                        Website Address :: www.psychcentral.co.za

                                        <br><br><br><br>
                                        <h3>Watch Video for Course #3 :: Module #8</h3>

                                        <div class="flex justify-content-center mt-4">

                                            <div
                                                class="w-full"
                                                style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                                <iframe
                                                    src="https://player.mediadelivery.net/embed/618381/0b7cecbd-3ef5-4211-90e7-dc7a37fe3efb?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                                    loading="lazy"
                                                    style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                                    allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                                    allowfullscreen="true"></iframe>
                                            </div>
                                        </div>

                                        <br><br><br><br>
                                        <h3>Listen to Audio for Course #3 :: Module #8</h3>

                                        <div class="flex justify-content-center mt-4">

                                            <div
                                                class="w-full"
                                                style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                                <iframe
                                                    src="https://player.mediadelivery.net/embed/618381/1f9da4d4-cf49-4a94-865f-e6ccad247502?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                                    loading="lazy"
                                                    style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                                    allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                                    allowfullscreen="true"></iframe>
                                            </div>
                                        </div>

                                        <br><br><br><br>
                                        <div class="card p-fluid">
                                            <h3>Complete Questionnaire for Course #3 : Module #8</h3>

                                            <div class="field">
                                                <label for="question1">1. Are there two types of bipolar?</label>
                                                <Dropdown v-model="course3Module8.answer1"
                                                          :options="course3Module8Question1" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question2">2. What do you need in order to be categorised as
                                                    bipolar one?</label>
                                                <Dropdown v-model="course3Module8.answer2"
                                                          :options="course3Module8Question2" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question3">3. How many symptoms must be present for a major
                                                    depressive episode?</label>
                                                <Dropdown v-model="course3Module8.answer3"
                                                          :options="course3Module8Question3" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question4">4. How long must symptoms not be present in order
                                                    for a depression to be in
                                                    remission?</label>
                                                <Dropdown v-model="course3Module8.answer4"
                                                          :options="course3Module8Question4" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question5">5. What are the characteristics of a manic
                                                    episode?</label>
                                                <Dropdown v-model="course3Module8.answer5"
                                                          :options="course3Module8Question5" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <Button label="Submit" class="mr-2 mb-2"
                                                    @click="submitQuestionnaireCourse3Module8"></Button>

                                        </div>

                                    </div>
                                </div>
                            </div>

                        </AccordionTab>

                        <AccordionTab
                            header="Course #3 :: Module #9 :: Special Interest Series :: Disorders :: Phobias and Trauma from a Counselling Psychologist’s Perspective">

                            <div class="grid">
                                <div class="col-12 md:col-12">
                                    <div class="card p-fluid">
                                        <h2>Course #3 :: Module #9 :: Special Interest Series :: Disorders :: Phobias
                                            and Trauma from a Counselling Psychologist’s Perspective</h2>

                                        <h3>Accreditation number : AOCP001/6268/12/2026</h3>

                                        <h4>1 Clinical CEUs, HPCSA Level 1</h4>

                                        <br><br>
                                        Our speaker on this module is Mr. Philip Louw, a South African trained,
                                        Counselling Psychologist who
                                        currently works and resides in Hamilton, New Zealand. He completed his
                                        professional training at the
                                        University of the Witwatersrand in South Africa. He has experience working in
                                        private practice, NGO and
                                        correctional environments and has dealt with a broad range of client population
                                        types and presenting
                                        problems.

                                        <br><br>
                                        Phillip has been trained in and has experience working with a range of
                                        therapeutic modalities including
                                        cognitive-behavioural therapy, modern psychodynamic therapies, positive
                                        psychological therapies,
                                        such as mindfulness-based therapies, as well as neuropsychological and
                                        brain-based therapies such as
                                        BrainWorking Recursive Therapy®. He is an approved New Zealand BWRT® trainer.

                                        <br><br>
                                        <h5>Aims of the Module</h5>
                                        1. To understand how Phobias and Traumas present in different geographic
                                        areas.<br>
                                        2. To understand the role of intergenerational Traumas in society.<br>
                                        3. Gaining insights into how Phobias and Traumas present in the correctional
                                        services population.<br>
                                        4. Understanding the link between Phobias and PTSD.

                                        <br><br>
                                        The assessment of the understanding of the module is followed by a questionnaire
                                        (10 items).
                                        Based on the answers to the assessment, a certificate will be issued for your
                                        records
                                        confirming the CPD points.

                                        <br><br><br><br>

                                        <h3>Biography of Philip Louw</h3>
                                        Counselling Psychologist<br>
                                        Counselling Psychology- University of the Witwatersrand

                                        <br><br>
                                        Phillip is a Hamilton-based, New Zealand, registered Counselling Psychologist.
                                        He completed his
                                        professional
                                        training at the University of the Witwatersrand in South Africa. He has
                                        experience working in private
                                        practice,
                                        NGO and correctional environments and has dealt with a broad range of client
                                        population types and
                                        presenting problems.

                                        <br><br>
                                        Phillip has been trained in and has experience working with a range of
                                        therapeutic modalities including
                                        cognitive-behavioural therapy, modern psychodynamic therapies, positive
                                        psychological therapies, such as
                                        mindfulness-based therapies, as well as neuropsychological and brain-based
                                        therapies such as
                                        BrainWorking Recursive Therapy®. He is an approved New Zealand BWRT® trainer.

                                        <br><br>
                                        <h5>Areas of Interests</h5>
                                        1. Anxiety<br>
                                        2. Depression<br>
                                        3. Emotional Entropy<br>
                                        4. Phobias<br>
                                        5. Trauma<br>
                                        6. Abuse<br>
                                        7. Post-Traumatic Stress Disorder<br>
                                        8. Weight Management<br>
                                        9. Fears

                                        <br><br>
                                        <h5>Contact Details</h5>
                                        Mobile Number :: 0278555850<br>
                                        Email Address :: phillip@mindwaypsych.com<br>
                                        Website Address :: www.mindwaypsych.com

                                        <br><br><br><br>
                                        <h3>Watch Video for Course #3 :: Module #9</h3>

                                        <div class="flex justify-content-center mt-4">

                                            <div
                                                class="w-full"
                                                style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                                <iframe
                                                    src="https://player.mediadelivery.net/embed/618381/3751c6d9-4506-47bb-8eff-b0d64fb40a89?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                                    loading="lazy"
                                                    style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                                    allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                                    allowfullscreen="true"></iframe>
                                            </div>
                                        </div>


                                        <br><br><br><br>
                                        <h3>Listen to Audio for Course #3 :: Module #9</h3>

                                        <div class="flex justify-content-center mt-4">

                                            <div
                                                class="w-full"
                                                style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                                <iframe
                                                    src="https://player.mediadelivery.net/embed/618381/ad777312-9f48-426a-961f-a78157c6d800?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                                    loading="lazy"
                                                    style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                                    allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                                    allowfullscreen="true"></iframe>
                                            </div>
                                        </div>

                                        <br><br><br><br>
                                        <div class="card p-fluid">
                                            <h3>Complete Questionnaire for Course #3 : Module #9</h3>

                                            <div class="field">
                                                <label for="question1">1. How did we connect to the speaker and invite
                                                    him to do the course?</label>
                                                <Dropdown v-model="course3Module9.answer1"
                                                          :options="course3Module9Question1" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question2">2. Where was the speaker's private practice in
                                                    South Africa?</label>
                                                <Dropdown v-model="course3Module9.answer2"
                                                          :options="course3Module9Question2" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question3">3. What are phobias directly tied to?</label>
                                                <Dropdown v-model="course3Module9.answer3"
                                                          :options="course3Module9Question3" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question4">4. According to the DSM V, are phobias considered
                                                    a mental illness?</label>
                                                <Dropdown v-model="course3Module9.answer4"
                                                          :options="course3Module9Question4" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question5">5. What types of therapy can be used for
                                                    balancing the disproportionate levels
                                                    of fear in patients with phobias?</label>
                                                <Dropdown v-model="course3Module9.answer5"
                                                          :options="course3Module9Question5" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <Button label="Submit" class="mr-2 mb-2"
                                                    @click="submitQuestionnaireCourse3Module9"></Button>

                                        </div>

                                    </div>
                                </div>
                            </div>

                        </AccordionTab>

                        <AccordionTab
                            header="Course #3 :: Module #10 :: Special Interest Series :: Disorders :: Discussing Eating Disorders from a Clinical Psychologist's Perspective">

                            <div class="grid">
                                <div class="col-12 md:col-12">
                                    <div class="card p-fluid">
                                        <h2>Course #3 :: Module #10 :: Special Interest Series :: Disorders ::
                                            Discussing Eating Disorders from a Clinical Psychologist's Perspective</h2>

                                        <h3>Accreditation number : AOCP001/6268/12/2026</h3>

                                        <h4>1 Clinical CEUs, HPCSA Level 1</h4>

                                        <br><br>
                                        Our speaker on this module is Dr. Adilia Silva, a Clinical Psychologist, based
                                        in Kensington
                                        (eastern area of Johannesburg, near Eastgate, Bedfordview). She received her PhD
                                        degree from
                                        The University of the Witwatersrand, Clinical Psychology Master’s degree from
                                        The North West University
                                        and her Research Psychology Master’s degree from The University of the
                                        Witwatersrand.
                                        She also holds a BSc with Honours. She has a special interest in Eating
                                        Disorders which she will be
                                        sharing with us.

                                        <br><br>
                                        <h5>Aims of the Module</h5>
                                        1. To gain an understanding of Eating Disorders and the different types.<br>
                                        2. To gain an understanding of how the relationship with food plays a part in
                                        the formation and
                                        maintenance of an Eating Disorder.<br>
                                        3. To identify the relationship between body image and Eating Disorders.<br>
                                        4. Understanding the role of social media in the prevalence of Eating Disorders.

                                        <br><br>
                                        The assessment of the understanding of the module is followed by a questionnaire
                                        (10 items).
                                        Based on the answers to the assessment, a certificate will be issued for your
                                        records
                                        confirming the CPD points.

                                        <br><br><br><br>

                                        <h3>Biography of Dr Adilia Silva</h3>
                                        Clinical Psychologist

                                        <br><br>
                                        Dr Silva is a Clinical Psychologist based in Kensington (eastern area of
                                        Johannesburg, near Eastgate,
                                        Bedfordview).
                                        She received her PhD degree from The University of the Witwatersrand, Clinical
                                        Psychology Masters degree
                                        from The North West University and her Research Psychology Master’s degree from
                                        The University of the
                                        Witwatersrand.
                                        She also holds a BSc with Honours.

                                        <br><br>
                                        Dr Silva has worked at an NGO as well as an academic at the University of the
                                        Witwatersrand. She did her
                                        clinical psychology internship at Sterkfontein Hospital where she did rotations
                                        in the forensic unit
                                        as well as the male and female units. She worked with chronic and acute cases,
                                        and did psychotherapy
                                        in the West Rand community clinics. Thereafter she worked at a general hospital,
                                        with a vast variety of
                                        clients with different difficulties/challenges. She has obtained a lot of
                                        experience in various factors of
                                        psychometric/psychological assessment.

                                        <br><br>
                                        Dr Silva is fluent in English, Portuguese and Afrikaans.

                                        <br><br>
                                        <h5>Special Areas of Interest</h5>
                                        1. BWRT<br>
                                        2. Eating Disorders<br>
                                        3. Play Therapy<br>
                                        4. Child Therapy

                                        <br><br>
                                        <h5>Contact Details</h5>
                                        Email Address :: adiliasilva@yahoo.com<br>

                                        <br><br><br><br>
                                        <h3>Watch Video for Course #3 :: Module #10</h3>

                                        <div class="flex justify-content-center mt-4">

                                            <div
                                                class="w-full"
                                                style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                                <iframe
                                                    src="https://player.mediadelivery.net/embed/618381/d6b6c002-d79a-4017-8bff-81d7ecca5ef6?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                                    loading="lazy"
                                                    style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                                    allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                                    allowfullscreen="true"></iframe>
                                            </div>
                                        </div>

                                        <br><br><br><br>
                                        <h3>Listen to Audio for Course #3 :: Module #10</h3>

                                        <div class="flex justify-content-center mt-4">

                                            <div
                                                class="w-full"
                                                style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                                <iframe
                                                    src="https://player.mediadelivery.net/embed/618381/035a7613-137e-4b21-8862-648760277375?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                                    loading="lazy"
                                                    style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                                    allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                                    allowfullscreen="true"></iframe>
                                            </div>
                                        </div>

                                        <br><br><br><br>
                                        <div class="card p-fluid">
                                            <h3>Complete Questionnaire for Course #3 : Module #10</h3>

                                            <div class="field">
                                                <label for="question1">1. What is an eating disorder about?</label>
                                                <Dropdown v-model="course3Module10.answer1"
                                                          :options="course3Module10Question1" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question2">2. At what age does an eating disorder normally
                                                    start?</label>
                                                <Dropdown v-model="course3Module10.answer2"
                                                          :options="course3Module10Question2" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question3">3. Is cardiac arrest a reality for a patient with
                                                    an eating disorder?</label>
                                                <Dropdown v-model="course3Module10.answer3"
                                                          :options="course3Module10Question3" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question4">4. What was the reason for the speaker writing a
                                                    book on nutrition?</label>
                                                <Dropdown v-model="course3Module10.answer4"
                                                          :options="course3Module10Question4" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question5">5. What is the one term that is often associated
                                                    with an eating order?</label>
                                                <Dropdown v-model="course3Module10.answer5"
                                                          :options="course3Module10Question5" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <Button label="Submit" class="mr-2 mb-2"
                                                    @click="submitQuestionnaireCourse3Module10"></Button>

                                        </div>

                                    </div>
                                </div>
                            </div>

                        </AccordionTab>

                        <AccordionTab
                            header="Course #3 :: Module #11 :: Special Interest Series :: Disorders :: Discussing Gender Identity from a Clinical Psychologist's Perspective">

                            <div class="grid">
                                <div class="col-12 md:col-12">
                                    <div class="card p-fluid">
                                        <h2>Course #3 :: Module #11 :: Special Interest Series :: Disorders ::
                                            Discussing Gender Identity from a Clinical Psychologist's Perspective</h2>

                                        <h3>Accreditation number : AOCP001/6268/12/2026</h3>

                                        <h4>1 Clinical CEUs, HPCSA Level 1</h4>

                                        <br><br>
                                        Our speaker on this module is Ms. Claire Haggard, Clinical Psychologist in
                                        private practice.
                                        She works with a range of mental health issues, including, depression, anxiety,
                                        as well as struggles
                                        coping adaptively within a number of life contexts (e.g., relationships,
                                        personality functioning,
                                        occupational struggles and emotional or spiritual/existential difficulties).

                                        <br><br>
                                        Her theoretical (and practical) interests centre on the critical exploration of
                                        the practice of
                                        psychotherapy within the South African context from a Queer and Psychoanalytic
                                        perspective.
                                        Making her sensitive to issues of race, class and identity and how they impact
                                        on the expression of human
                                        subjectivity.

                                        <br><br>
                                        <h5>Aims of the Module</h5>
                                        1. Understanding what Gender Identity is.<br>
                                        2. Understanding why the fluidity of Gender Identity is so prevalent
                                        currently.<br>
                                        3. Understanding the importance of the fluidity of Gender Identity within a
                                        therapeutic context.<br>
                                        4. To gain insight into the difficulties presented by Gender Fluidity.<br>
                                        5. Understanding the role of cultural, religious pressures on the formation of
                                        Gender Identity.

                                        <br><br>
                                        The assessment of the understanding of the module is followed by a questionnaire
                                        (10 items).
                                        Based on the answers to the assessment, a certificate will be issued for your
                                        records
                                        confirming the CPD points.

                                        <br><br><br><br>

                                        <h3>Biography of Claire Haggard</h3>
                                        Clinical Psychologist

                                        <br><br>
                                        Claire is a registered Clinical Psychologist (PS 0098035), with over 13 years
                                        experience offering brief
                                        and
                                        long term psychotherapeutic intervention, clinical assessment, case management,
                                        group psychotherapy and
                                        clinical supervision (individual and group therapy). She has practised in a
                                        variety of settings, including
                                        the higher education context (including student wellness services at both the
                                        University of Cape Town and
                                        Stellenbosch University from 2008-2017), the primary health care setting, the
                                        private sector and, more
                                        recently,
                                        within the context of addiction (Bloemendal Addiction Treatment).

                                        <br><br>
                                        Claire works with a range of mental health issues, including, depression,
                                        anxiety, as well as struggles
                                        coping adaptively within a number of life contexts (e.g., relationships,
                                        personality functioning,
                                        occupational struggles and emotional or spiritual/existential difficulties).

                                        <br><br>
                                        Her theoretical (and practical) interests centre on the critical exploration of
                                        the practice of
                                        psychotherapy within the South African context from a Queer and Psychoanalytic
                                        perspective.
                                        Making her sensitive to issues of race, class and identity and how they impact
                                        on the expression of human
                                        subjectivity.

                                        <br><br>
                                        <h5>Special Areas of Interest</h5>
                                        1. Depression<br>
                                        2. Anxiety<br>
                                        3. Gender Identity<br>
                                        4. Bereavement<br>
                                        5. Bipolar Disorder<br>
                                        6. Divorce<br>
                                        7. Racial Identity<br>
                                        8. Stress<br>
                                        9. Transgender<br>
                                        10. Trauma and PTSD<br>
                                        11. Relationship Issues

                                        <br><br>
                                        <h5>Contact Details</h5>
                                        Mobile Number :: 087 250 2042<br>
                                        Email Address :: claire.haggard@gmail.com<br>
                                        Practice Address :: Office Suite 13, Oewerpark, Die Boord, Stellenbosch 7600

                                        <br><br><br><br>
                                        <h3>Watch Video for Course #3 :: Module #11</h3>

                                        <div class="flex justify-content-center mt-4">

                                            <div
                                                class="w-full"
                                                style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                                <iframe
                                                    src="https://player.mediadelivery.net/embed/618381/86c7f8de-c840-4b3d-bae9-073ce83b2573?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                                    loading="lazy"
                                                    style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                                    allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                                    allowfullscreen="true"></iframe>
                                            </div>
                                        </div>


                                        <br><br><br><br>
                                        <h3>Listen to Audio for Course #3 :: Module #11</h3>

                                        <div class="flex justify-content-center mt-4">

                                            <div
                                                class="w-full"
                                                style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                                <iframe
                                                    src="https://player.mediadelivery.net/embed/618381/a9582cec-8423-4854-87ca-08868c476e36?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                                    loading="lazy"
                                                    style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                                    allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                                    allowfullscreen="true"></iframe>
                                            </div>
                                        </div>

                                        <br><br><br><br>
                                        <div class="card p-fluid">
                                            <h3>Complete Questionnaire for Course #3 : Module #11</h3>

                                            <div class="field">
                                                <label for="question1">1. Why does the speaker not profess to be an
                                                    expert at gender identity?</label>
                                                <Dropdown v-model="course3Module11.answer1"
                                                          :options="course3Module11Question1" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question2">2. Is identity concerns limited to
                                                    gender?</label>
                                                <Dropdown v-model="course3Module11.answer2"
                                                          :options="course3Module11Question2" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question3">3. At what age does gender identity concerns
                                                    typically present with
                                                    patients?</label>
                                                <Dropdown v-model="course3Module11.answer3"
                                                          :options="course3Module11Question3" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question4">4. Is a dead name normally spoken of during
                                                    discussions with patients with
                                                    gender identity?</label>
                                                <Dropdown v-model="course3Module11.answer4"
                                                          :options="course3Module11Question4" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question5">5. What are the typical factors that influence
                                                    gender identity?</label>
                                                <Dropdown v-model="course3Module11.answer5"
                                                          :options="course3Module11Question5" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <Button label="Submit" class="mr-2 mb-2"
                                                    @click="submitQuestionnaireCourse3Module11"></Button>

                                        </div>

                                    </div>
                                </div>
                            </div>

                        </AccordionTab>

                        <AccordionTab
                            header="Course #3 :: Module #12 :: Special Interest Series :: Disorders :: Discussing Diabetes Management with a Dietician">

                            <div class="grid">
                                <div class="col-12 md:col-12">
                                    <div class="card p-fluid">
                                        <h2>Course #3 :: Module #12 :: Special Interest Series :: Disorders ::
                                            Discussing Diabetes Management with a Dietician</h2>

                                        <h3>Accreditation number : AOCP001/6268/12/2026</h3>

                                        <h4>1 Clinical CEUs, HPCSA Level 1</h4>

                                        <br><br>
                                        Our speaker on this module is Ms. Annaleen Joubert, a Dietician in private
                                        practice.
                                        She works with a range of patients including overweight/ obesity, underweight,
                                        diabetes,
                                        renal disease, cholesterol, hypertension, food allergies/ intolerances, GIT
                                        disorders, appetite disorders
                                        and sport nutrition.

                                        <br><br>
                                        <h5>Aims of the Module</h5>
                                        1. Understanding what good nutrition is.<br>
                                        2. Understanding why nutrition and healthy diet needs more care for diabetes
                                        patients.<br>
                                        3. Understand the intricacies of working with patients with diabetes.<br>
                                        4. Understanding the importance of regular assessments and self check-ups to
                                        maintain good health.<br>
                                        5. To gain insight into the difficulties presented by patients with diabetes.

                                        <br><br>
                                        The assessment of the understanding of the module is followed by a questionnaire
                                        (10 items).
                                        Based on the answers to the assessment, a certificate will be issued for your
                                        records
                                        confirming the CPD points.

                                        <br><br><br><br>

                                        <h3>Biography of Annaleen Joubert</h3>
                                        Dietician
                                        BSc (Dietetics) Stell

                                        <br><br>
                                        Annaleeen has been in private practice since 2018, and is based in the Western
                                        Cape and has the following
                                        special areas of interest.

                                        <br><br>
                                        <h5>Special Areas of Interest</h5>
                                        1. Overweight/ obesity<br>
                                        2. Underweight<br>
                                        3. Diabetes<br>
                                        4. Renal disease<br>
                                        5. Cholesterol<br>
                                        6. Hypertension<br>
                                        7. Food allergies/ intolerances<br>
                                        8. GIT disorders<br>
                                        9. Appetite disorders<br>
                                        10. Sport Nutrition

                                        <br><br>
                                        <h5>Contact Details</h5>
                                        Office Number :: 021 396 1155<br>
                                        Email Address :: annaleenjbrt@gmail.com<br>
                                        Practice Address :: One Healthcare Dr chantal van Zitters, 11 Dollarbird Road,
                                        Pelican Park, 7941

                                        <br><br><br><br>
                                        <h3>Watch Video for Course #3 :: Module #12</h3>

                                        <div class="flex justify-content-center mt-4">
                                            <div
                                                class="w-full"
                                                style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                                <iframe
                                                    src="https://player.mediadelivery.net/embed/618381/dff1063b-ada5-43b6-a0df-b4acbc96ec56?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                                    loading="lazy"
                                                    style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                                    allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                                    allowfullscreen="true"></iframe>
                                            </div>
                                        </div>

                                        <br><br><br><br>
                                        <h3>Listen to Audio for Course #3 :: Module #12</h3>

                                        <div class="flex justify-content-center mt-4">

                                            <div
                                                class="w-full"
                                                style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                                <iframe
                                                    src="https://player.mediadelivery.net/embed/618381/6c51abe2-a060-4cf9-a1fe-d25da8eb833b?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                                    loading="lazy"
                                                    style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                                    allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                                    allowfullscreen="true"></iframe>
                                            </div>
                                        </div>

                                        <br><br><br><br>
                                        <div class="card p-fluid">
                                            <h3>Complete Questionnaire for Course #3 : Module #12</h3>

                                            <div class="field">
                                                <label for="question1">1. How did we connect to the speaker and invite
                                                    him to do the course?</label>
                                                <Dropdown v-model="course3Module12.answer1"
                                                          :options="course3Module12Question1" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question2">2. What percentage of diabetes patients does the
                                                    speaker normally have in her
                                                    private practice?</label>
                                                <Dropdown v-model="course3Module12.answer2"
                                                          :options="course3Module12Question2" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question3">3. What is used to produce glucose or
                                                    sugar?</label>
                                                <Dropdown v-model="course3Module12.answer3"
                                                          :options="course3Module12Question3" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question4">4. Where is insulin produced in the body?</label>
                                                <Dropdown v-model="course3Module12.answer4"
                                                          :options="course3Module12Question4" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question5">5. At what age is Type 1 Diabetes typically
                                                    diagnosed?</label>
                                                <Dropdown v-model="course3Module12.answer5"
                                                          :options="course3Module12Question5" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <Button label="Submit" class="mr-2 mb-2"
                                                    @click="submitQuestionnaireCourse3Module12"></Button>

                                        </div>

                                    </div>
                                </div>
                            </div>

                        </AccordionTab>

                        <AccordionTab
                            header="Course #3 :: Module #13 :: Special Interest Series :: Disorders :: Discussing Foot Management for Diabetics with a Podiatrist">

                            <div class="grid">
                                <div class="col-12 md:col-12">
                                    <div class="card p-fluid">
                                        <h2>Course #3 :: Module #13 :: Special Interest Series :: Disorders ::
                                            Discussing Foot Management for Diabetics with a Podiatrist</h2>

                                        <h3>Accreditation number : AOCP001/6268/12/2026</h3>

                                        <h4>1 Clinical CEUs, HPCSA Level 1</h4>

                                        <br><br>
                                        Our speaker on this module is Lucas Breedt, a Podiatrist in private practice. He
                                        works with a range of
                                        patients including management of ingrown toenails, corns, calluses, warts and
                                        foot fissures, assessment of
                                        paediatric and geriatric foot conditions, sport injury management, wound
                                        management and custom foot
                                        orthoses and insole devices.

                                        <br><br>
                                        <h5>Aims of the Module</h5>
                                        1. Understanding what foot management is.<br>
                                        2. Understanding why foot management needs more care for diabetes patients.<br>
                                        3. Understand the intricacies of working with patients with diabetes.<br>
                                        4. Understanding the importance of regular assessments and check-ups to maintain
                                        good health for patients
                                        with diabetes.<br>
                                        5. Understanding the mental wellness aspects of patients that do not receive
                                        adequate foot management
                                        care.<br>
                                        6. To gain insight into the difficulties presented by patients with diabetes.

                                        <br><br>
                                        The assessment of the understanding of the module is followed by a questionnaire
                                        (10 items).
                                        Based on the answers to the assessment, a certificate will be issued for your
                                        records
                                        confirming the CPD points.

                                        <br><br><br><br>

                                        <h3>Biography of Dr Lucas Breedt</h3>
                                        Podiatrist<br>
                                        B Tech (Pod) Johannesburg

                                        <br><br>
                                        Lucas has been in private practice in 2016, is based in Gauteng and has the
                                        following special areas of
                                        interest.

                                        <br><br>
                                        <h5>Special Areas of Interest</h5>
                                        1. Management of ingrown toenails, corns, calluses, warts and foot fissures.<br>
                                        2. Assessment of paediatric and geriatric foot conditions.<br>
                                        3. Sport injury management.<br>
                                        4. Wound management.<br>
                                        5. Custom foot orthoses and insole devices.

                                        <br><br>
                                        <h5>Contact Details</h5>
                                        Mobile Number :: 0834332347<br>
                                        Office Number :: 0126631572<br>
                                        Email Address :: lucas.podiatry@gmail.com<br>
                                        Practice Address :: The W Sport and Wellness center, Super Sport Park, 283 West
                                        Avenue, Die Hoewes,
                                        Centurion<br>
                                        Website Address :: http://www.centurionpodiatrist.com

                                        <br><br><br><br>
                                        <h3>Watch Video for Course #3 :: Module #13</h3>

                                        <div class="flex justify-content-center mt-4">

                                            <div
                                                class="w-full"
                                                style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                                <iframe
                                                    src="https://player.mediadelivery.net/embed/618381/2f487d38-bb25-4121-892d-aa8f17ff5524?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                                    loading="lazy"
                                                    style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                                    allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                                    allowfullscreen="true"></iframe>
                                            </div>
                                        </div>

                                        <br><br><br><br>
                                        <h3>Listen to Audio for Course #3 :: Module #13</h3>

                                        <div class="flex justify-content-center mt-4">

                                            <div
                                                class="w-full"
                                                style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                                <iframe
                                                    src="https://player.mediadelivery.net/embed/618381/d113a382-1344-4339-bd9c-ba5a2ae49e38?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                                    loading="lazy"
                                                    style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                                    allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                                    allowfullscreen="true"></iframe>
                                            </div>
                                        </div>

                                        <br><br><br><br>
                                        <div class="card p-fluid">
                                            <h3>Complete Questionnaire for Course #3 : Module #13</h3>

                                            <div class="field">
                                                <label for="question1">1. What is the most important factor for a
                                                    diabetic patient?</label>
                                                <Dropdown v-model="course3Module13.answer1"
                                                          :options="course3Module13Question1" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question2">2. Why is foot management important for
                                                    diabetics?</label>
                                                <Dropdown v-model="course3Module13.answer2"
                                                          :options="course3Module13Question2" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question3">3. According to the speaker, at what level should
                                                    the random blood glucose
                                                    level be at?</label>
                                                <Dropdown v-model="course3Module13.answer3"
                                                          :options="course3Module13Question3" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question4">4. Is amputation a reality for many
                                                    diabetics?</label>
                                                <Dropdown v-model="course3Module13.answer4"
                                                          :options="course3Module13Question4" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question5">5. What is the typical time-frame for a recurring
                                                    appointment of a diabetic
                                                    patient with a podiatrist?</label>
                                                <Dropdown v-model="course3Module13.answer5"
                                                          :options="course3Module13Question5" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <Button label="Submit" class="mr-2 mb-2"
                                                    @click="submitQuestionnaireCourse3Module13"></Button>

                                        </div>

                                    </div>
                                </div>
                            </div>

                        </AccordionTab>

                        <AccordionTab
                            header="Course #3 :: Module #14 :: Special Interest Series :: Disorders :: Discussing Obsessive Compulsive Disorder from a Clinical Psychologist’s Perspective">

                            <div class="grid">
                                <div class="col-12 md:col-12">
                                    <div class="card p-fluid">
                                        <h2>Course #3 :: Module #14 :: Special Interest Series :: Disorders ::
                                            Discussing Obsessive Compulsive Disorder from a Clinical Psychologist’s
                                            Perspective</h2>

                                        <h3>Accreditation number : AOCP001/6268/12/2026</h3>

                                        <h4>1 Clinical CEUs, HPCSA Level 1</h4>

                                        <br><br>
                                        Our speaker on this module is Ms. Leslie Faria Mendes, a Clinical Psychologist
                                        with expertise gained over
                                        several years working to deliver the best quality, patient focused clinical
                                        services to the highest
                                        professional standards. Due to her deep and abiding passion for metacognition,
                                        she has developed
                                        excellent skills as a CBT therapist and worked closely with patients who have
                                        been diagnosed with OCD,
                                        Anxiety Disorders and Trauma & Stress Related Disorders.

                                        <br><br>
                                        <h5>Aims of the Module</h5>
                                        1. To gain an understanding of the misconceptions of OCD.<br>
                                        2. How to identify the three components to OCD: Obsessions, Compulsions and
                                        Associations.<br>
                                        3. To identify the personality traits that are present in OCD.<br>
                                        4. To understand the different types of OCD.<br>
                                        5. To understand the predisposition and prevalence of OCD.

                                        <br><br>
                                        The assessment of the understanding of the module is followed by a questionnaire
                                        (10 items).
                                        Based on the answers to the assessment, a certificate will be issued for your
                                        records
                                        confirming the CPD points.

                                        <br><br><br><br>

                                        <h3>Biography of Leslie Faria Mendes</h3>
                                        Clinical Psychologist

                                        <br><br>
                                        Leslie is a Clinical Psychologist with expertise gained over several years
                                        working to deliver the best
                                        quality, patient focused clinical services to the highest professional
                                        standards. Due to her deep and
                                        abiding passion for metacognition, she has developed excellent skills as a CBT
                                        therapist and worked
                                        closely with patients who have been diagnosed with OCD, Anxiety Disorders and
                                        Trauma & Stress Related
                                        Disorders.

                                        <br><br>
                                        Leslie prides herself on being patient focused. She is dedicated to working hard
                                        to find new and better
                                        ways of improving or enhancing her clinical delivery standards. It gives her
                                        great satisfaction to see a
                                        patient recovering from what are often debilitating disorders.

                                        <br><br>
                                        <h5>Special Areas of Interest</h5>
                                        1. Anxiety Disorders<br>
                                        2. Attention Deficit and Hyperactivity Disorder<br>
                                        3. Bipolar Disorder<br>
                                        4. Depression<br>
                                        5. Obsessive-compulsive Disorder<br>
                                        6. Post-traumatic Stress Disorder<br>
                                        7. Schizophrenia

                                        <br><br>
                                        <h5>Contact Details</h5>
                                        Mobile Number :: +27-84-0970127<br>
                                        Email Address :: leslie.ebben@gmail.com<br>
                                        Practice Address :: Blubird Medical Suites, Blubird Shopping Centre,
                                        Corner Athol-Oakland Road & Forte Street, Melrose

                                        <br><br><br><br>
                                        <h3>Watch Video for Course #3 :: Module #14</h3>

                                        <div class="flex justify-content-center mt-4">

                                            <div
                                                class="w-full"
                                                style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                                <iframe
                                                    src="https://player.mediadelivery.net/embed/618381/ba9c78f8-a0b1-4215-ad80-6010a2567ecb?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                                    loading="lazy"
                                                    style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                                    allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                                    allowfullscreen="true"></iframe>
                                            </div>
                                        </div>

                                        <br><br><br><br>
                                        <h3>Listen to Audio for Course #3 :: Module #14</h3>

                                        <div class="flex justify-content-center mt-4">

                                            <div
                                                class="w-full"
                                                style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                                <iframe
                                                    src="https://player.mediadelivery.net/embed/618381/ad3c532c-3dc0-4494-9c0b-c1a244a1356b?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                                    loading="lazy"
                                                    style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                                    allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                                    allowfullscreen="true"></iframe>
                                            </div>
                                        </div>

                                        <br><br><br><br>
                                        <div class="card p-fluid">
                                            <h3>Complete Questionnaire for Course #3 : Module #14</h3>

                                            <div class="field">
                                                <label for="question1">1. How did we connect to the speaker and invite
                                                    her to do the course?</label>
                                                <Dropdown v-model="course3Module14.answer1"
                                                          :options="course3Module14Question1" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question2">2. Is having OCD a result of
                                                    perfectionism?</label>
                                                <Dropdown v-model="course3Module14.answer2"
                                                          :options="course3Module14Question2" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question3">3. What are the characteristics of OCD?</label>
                                                <Dropdown v-model="course3Module14.answer3"
                                                          :options="course3Module14Question3" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question4">4. If a parent has OCD, what is the likelihood of
                                                    the child getting
                                                    OCD?</label>
                                                <Dropdown v-model="course3Module14.answer4"
                                                          :options="course3Module14Question4" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <div class="field">
                                                <label for="question5">5. What is the difference between OCD and OCD
                                                    Personality Disorder
                                                    (OCDPD)?</label>
                                                <Dropdown v-model="course3Module14.answer5"
                                                          :options="course3Module14Question5" optionLabel="name"
                                                          optionValue="code"
                                                          placeholder="Select an Answer"/>
                                            </div>

                                            <Button label="Submit" class="mr-2 mb-2"
                                                    @click="submitQuestionnaireCourse3Module14"></Button>

                                        </div>

                                    </div>
                                </div>
                            </div>

                        </AccordionTab>

                    </Accordion>


                </div>
            </div>
        </div>


        <div v-show="activeTab === 5" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Course #4 :: Private Practice Management</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callHome" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Home</span>
                                </a>
                            </li>
                            <li>
                                <a @click="callReset" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Application Store</span>
                                </a>
                            </li>
                        </ul>
                    </div>


                    <div class="grid">
                        <div class="col-12 md:col-12">
                            <div class="card p-fluid">

                                <h2>Course #4 :: Private Practice Management</h2>

                                <h3>Accreditation number : AOCP001/6269/12/2026</h3>

                                <h4>5 Ethics CEUs, HPCSA Level 1</h4>

                                <br><br>
                                The running of a healthcare private practice is a difficult transition for most
                                healthcare practitioners.
                                In this course, we review the HPCSA
                                guidelines and provide insight and actionable learnings to help any healthcare
                                practitioner with their
                                private practice management.

                                <br><br>
                                Our Presenter, Ingrid James, will be introducing the concepts, as well as discussing the
                                applications of
                                each area within a healthcare private practice.

                                <br><br>
                                <h3>Aims of the Programme</h3>
                                1. Strategy and mapping out your journey.<br>
                                2. Ethical considerations.<br>
                                3. Marketing considerations.<br>
                                4. Legal considerations.<br>
                                5. People and human resources considerations.<br>
                                6. Processes and operational functional considerations.<br>
                                7. Billing, financials and tax considerations.<br>
                                8. Continuous learning and educational considerations.<br>
                                9. Coaching and mentorship considerations.<br>
                                10. Tools and resources.

                                <br><br>
                                The assessment of the understanding of the module is followed by a questionnaire (10
                                items).
                                Based on the answers to the assessment, a certificate will be issued for your records
                                confirming the CPD points.

                                <br><br><br><br>

                                <h3>Biography of Ingrid James</h3>
                                Clinical Psychologist<br>
                                MA (Clin Psychology) Zululand<br>

                                <br><br>
                                Ingrid is a Senior Clinical Psychologist, with special interest in the maintenance of
                                well-being and the
                                prevention of mental illness.
                                She has been in private practice since 2005 based in Gauteng, South Africa.

                                <br><br>
                                She trained at the University of Zululand in a community psychology based programme.
                                Zululand in Northern
                                KwaZulu Natal and its
                                surrounding areas is a predominantly mining area where supporting towns sprang up as a
                                result of migrant
                                employees. The aim of
                                the University in developing the community psychology programme was to create support
                                for the displaced
                                migrant employees,
                                facilitate tolerance in this cultural melting pot, and most of all create an environment
                                of physical and
                                emotional well-being
                                for the employees and their families.

                                <br><br>
                                She was initially moved to concentrate on well-being and prevention of mental illness
                                during my internship
                                where I worked
                                as a consultant psychologist to companies such as Mondi (Richards Bay and Empangeni),
                                South African Ports
                                Authority (Portnet),
                                Ticor and Richards Bay Coal Terminal (RBCT). She was responsible for the Employee
                                Assistance Programme
                                (EAP) in each of these
                                companies and was confronted on a daily basis with individuals who struggled to cope
                                with their unfamiliar
                                environments and
                                the demands of work. The research for her Master’s Thesis was The Effect of Exercise on
                                Psychological
                                Well-Being in the Workplace.

                                <br><br>
                                During the course of her practice, she has dealt with a number of clients with work
                                related difficulties.
                                She was instrumental
                                in establishing the EAP programme in a medical hospital during my Community Service.
                                After establishing a
                                successful private practice,
                                she branched out into Coaching and received accreditation through Success Factory. This
                                was mainly due to
                                the yearning to be able to
                                intervene at an earlier stage of distress.

                                <br><br>
                                She is an internationally accredited assessor of the EQ-i and MBTI New. Her training as
                                a clinical
                                psychologist, exposure to
                                coaching and work experience equips her to understand the relationships of individuals
                                both with
                                themselves and each other.
                                She excels at managing difficult situations through her attitude, professionalism and
                                ethical point of
                                view.

                                <br><br>
                                <h3>Contact Details</h3>
                                Email :: ingrid@ingridnagaya.com<br>
                                Website:: www.ingridnagaya.com

                                <br><br><br><br>
                                <h3>Watch Video for Course 4 :: Module #1</h3>

                                <div class="flex justify-content-center mt-4">
                                    <div
                                        class="w-full"
                                        style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                        <iframe
                                            src="https://player.mediadelivery.net/embed/618381/64edbb01-06bf-481f-ad7f-729b1dc832a4?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                            loading="lazy"
                                            style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                            allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                            allowfullscreen="true"></iframe>
                                    </div>
                                </div>

                                <br><br><br><br>
                                <h3>Watch Video for Course 4 :: Module #2</h3>

                                <div class="flex justify-content-center mt-4">
                                    <div
                                        class="w-full"
                                        style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                        <iframe
                                            src="https://player.mediadelivery.net/embed/618381/65473340-58c0-491a-8006-65d8217ec97f?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                            loading="lazy"
                                            style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                            allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                            allowfullscreen="true"></iframe>
                                    </div>
                                </div>

                                <br><br><br><br>
                                <h3>Watch Video for Course 4 :: Module #3</h3>

                                <div class="flex justify-content-center mt-4">
                                    <div
                                        class="w-full"
                                        style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                        <iframe
                                            src="https://player.mediadelivery.net/embed/618381/4492fd8e-a8b8-4ae4-8ba3-2ef180f6da88?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                            loading="lazy"
                                            style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                            allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                            allowfullscreen="true"></iframe>
                                    </div>
                                </div>


                                <br><br><br><br>
                                <h3>Watch Video for Course 4 :: Module #4</h3>

                                <div class="flex justify-content-center mt-4">
                                    <div
                                        class="w-full"
                                        style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                        <iframe
                                            src="https://player.mediadelivery.net/embed/618381/6329e0f6-655d-488b-ac34-88e7f65b8c61?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                            loading="lazy"
                                            style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                            allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                            allowfullscreen="true"></iframe>
                                    </div>
                                </div>


                                <br><br><br><br>
                                <h3>Watch Video for Course 4 :: Module #5</h3>

                                <div class="flex justify-content-center mt-4">
                                    <div
                                        class="w-full"
                                        style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                        <iframe
                                            src="https://player.mediadelivery.net/embed/618381/034a5fbb-1284-46b8-919d-6693a8ea845c?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                            loading="lazy"
                                            style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                            allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                            allowfullscreen="true"></iframe>
                                    </div>
                                </div>


                                <br><br><br><br>
                                <h3>Listen to Audio for Course 4 :: Module #1</h3>

                                <div class="flex justify-content-center mt-4">
                                    <div
                                        class="w-full"
                                        style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                        <iframe
                                            src="https://player.mediadelivery.net/embed/618381/f95097b3-4745-4693-abc4-9781f3e31c27?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                            loading="lazy"
                                            style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                            allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                            allowfullscreen="true"></iframe>
                                    </div>
                                </div>


                                <br><br><br><br>
                                <h3>Listen to Audio for Course 4 :: Module #2</h3>

                                <div class="flex justify-content-center mt-4">
                                    <div
                                        class="w-full"
                                        style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                        <iframe
                                            src="https://player.mediadelivery.net/embed/618381/33fcd6e1-d215-4bea-83db-c99af80e8e62?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                            loading="lazy"
                                            style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                            allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                            allowfullscreen="true"></iframe>
                                    </div>
                                </div>


                                <br><br><br><br>
                                <h3>Listen to Audio for Course 4 :: Module #3</h3>

                                <div class="flex justify-content-center mt-4">
                                    <div
                                        class="w-full"
                                        style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                        <iframe
                                            src="https://player.mediadelivery.net/embed/618381/fc5b90b9-4900-4fa4-88f3-6011bc43231b?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                            loading="lazy"
                                            style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                            allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                            allowfullscreen="true"></iframe>
                                    </div>
                                </div>


                                <br><br><br><br>
                                <h3>Listen to Audio for Course 4 :: Module #4</h3>

                                <div class="flex justify-content-center mt-4">
                                    <div
                                        class="w-full"
                                        style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                        <iframe
                                            src="https://player.mediadelivery.net/embed/618381/4d830d37-1cad-4c7b-beaa-d3343c0153ee?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                            loading="lazy"
                                            style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                            allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                            allowfullscreen="true"></iframe>
                                    </div>
                                </div>


                                <br><br><br><br>
                                <h3>Listen to Audio for Course 4 :: Module #5</h3>

                                <div class="flex justify-content-center mt-4">
                                    <div
                                        class="w-full"
                                        style="max-width: 900px; aspect-ratio: 16 / 9; position: relative;">
                                        <iframe
                                            src="https://player.mediadelivery.net/embed/618381/3c72e8c8-9e75-4cce-a346-712cec9b65e7?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                            loading="lazy"
                                            style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                            allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                            allowfullscreen="true"></iframe>
                                    </div>
                                </div>


                                <div>
                                    <br><br><br><br>
                                    <h3>Complete Questionnaire for Course 4</h3>

                                    <div class="field">
                                        <label for="question1">1. Can you use the expression "hospital", "clinic" or
                                            "institute" in your practice name?</label>
                                        <Dropdown v-model="course4.answer1" :options="course4Question1"
                                                  optionLabel="name" optionValue="code"
                                                  placeholder="Select an Answer"/>
                                    </div>

                                    <div class="field">
                                        <label for="question2">2. How many core ethical values and standards are there
                                            in terms of clinical practice?</label>
                                        <Dropdown v-model="course4.answer2" :options="course4Question2"
                                                  optionLabel="name" optionValue="code"
                                                  placeholder="Select an Answer"/>
                                    </div>

                                    <div class="field">
                                        <label for="question3">3. Can information on a patient be shared on social media
                                            platforms (if no consent is received from patient)?</label>
                                        <Dropdown v-model="course4.answer3" :options="course4Question3"
                                                  optionLabel="name" optionValue="code"
                                                  placeholder="Select an Answer"/>
                                    </div>

                                    <div class="field">
                                        <label for="question4">4. Can a practitioner divulge information regarding a
                                            patient under certain circumstances?</label>
                                        <Dropdown v-model="course4.answer4" :options="course4Question4"
                                                  optionLabel="name" optionValue="code"
                                                  placeholder="Select an Answer"/>
                                    </div>

                                    <div class="field">
                                        <label for="question5">5. How long can a practitioner employ a locum
                                            tenen?</label>
                                        <Dropdown v-model="course4.answer5" :options="course4Question5"
                                                  optionLabel="name" optionValue="code"
                                                  placeholder="Select an Answer"/>
                                    </div>

                                    <Button label="Submit" class="mr-2 mb-2"
                                            @click="submitQuestionnaireCourse4"></Button>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

    </div>

    <IsoEvolveFooter/>

</template>

<script>
import IsoEvolveFooter from "@/components/heading/authentication/IsoEvolveFooter.vue";
import MenuHealthCompact from "@/components/menu/health/MenuHealthCompact.vue";
import {useUserStore} from "@/stores/UserStore";
import UserService from "@/service/UserService";
import CourseAssessmentService from "@/service/CourseAssessmentService";
import MenuFinancialCompact from "@/components/menu/famodule/MenuFinancialCompact.vue";

export default {
    components: {
        MenuFinancialCompact,
        IsoEvolveFooter, MenuHealthCompact
    },
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    async mounted() {
        await this.loadCompanyContext();
    },
    data() {

        return {
            profile: {},
            activeTab: 1,
            userConfiguration: {},
            submitted: false,
            course1Module1: {},
            course1Module2: {},
            course1Module3: {},
            course1Module4: {},
            course1Module5: {},
            course1Module6: {},
            course1Module7: {},
            course1Module8: {},
            course1Module1Question1: [
                {name: 'A. It is a form of therapy that is similar to Cognitive Behavioural Therapy (CBT).', code: 'A'},
                {name: 'B. BrainWorking® Recursive Therapy is an innovative new concept of psychotherapy.', code: 'B'},
                {
                    name: 'C. It is a new form of therapy based on neuroscience and includes teaching you new skills to deal with trauma.',
                    code: 'C'
                },
                {
                    name: 'D. This therapy is largely content-free, using the clients own thought processes to effect a release from the symptomatic pattern.',
                    code: 'D'
                },
                {name: 'E. B and D.', code: 'E'},
            ],
            course1Module1Question2: [
                {name: 'A. Amydala in the brain.', code: 'A'},
                {name: 'B. Hippocampus in the brain.', code: 'B'},
                {name: 'C. Frontal cortex of the brain.', code: 'C'},
                {name: 'D. Spinal column in the brain.', code: 'D'},
                {name: 'E. All of the above.', code: 'E'},
            ],
            course1Module1Question3: [
                {name: 'A. Identifying a list of responses that a patient wants to change.', code: 'A'},
                {
                    name: 'B. Use the naturally occurring freeze response to target the response that must be changed.',
                    code: 'B'
                },
                {
                    name: 'C. Normal communication of the early brain then organises and neutralises the response.',
                    code: 'C'
                },
                {
                    name: 'D. Therapist works with a traumatic memory to freeze the response and change it to the desired one.',
                    code: 'D'
                },
                {name: 'E. All of the above.', code: 'E'},
            ],
            course1Module1Question4: [
                {name: 'A. PTSD and other traumatic experiences.', code: 'A'},
                {name: 'B. Eating disorders and compulsive eating.', code: 'B'},
                {name: 'C. Anxiety related disorders such as OCD.', code: 'C'},
                {name: 'D. Medical conditions such as a brain tumour.', code: 'D'},
                {name: 'E. A, B & C.', code: 'E'},
            ],
            course1Module1Question5: [
                {name: 'A. Billing and medical aid submissions.', code: 'A'},
                {name: 'B. Marketing and getting referrals to yourself as a practitioner.', code: 'B'},
                {name: 'C. Having a referral network of colleagues you work with.', code: 'C'},
                {name: 'D. Finding office space.', code: 'D'},
                {name: 'E. All of the above.', code: 'E'},
            ],
            course1Module2Question1: [
                {name: 'A. Medical', code: 'A'},
                {name: 'B. Behavioural', code: 'B'},
                {name: 'C. Psychological', code: 'C'},
                {name: 'D. All of the above', code: 'D'},
            ],
            course1Module2Question2: [
                {name: 'A. Musical talent and aptitude', code: 'A'},
                {name: 'B. The ability to play at least one instrument', code: 'B'},
                {name: 'C. The ability to read music', code: 'C'},
                {name: 'D. None of the above', code: 'D'},
            ],
            course1Module2Question3: [
                {name: 'A. University of Stellenbosch', code: 'A'},
                {name: 'B. University of Witwatersrand', code: 'B'},
                {name: 'C. University of Cape Town', code: 'C'},
                {name: 'D. University of Pretoria', code: 'D'},
            ],
            course1Module2Question4: [
                {name: 'A. Drumming and listening to live or recorded music', code: 'A'},
                {
                    name: 'B. Listening to music-assisted relaxation such as progressive muscle relaxation techniques',
                    code: 'B'
                },
                {name: 'C. Playing percussive instruments and singing', code: 'C'},
                {name: 'D. All of the above', code: 'D'},
            ],
            course1Module2Question5: [
                {name: 'A. Teaching them to listen to one instrument at a time', code: 'A'},
                {name: 'B. Playing similar passages of music and asking them to identify similarities', code: 'B'},
                {name: 'C. Teaching them how to interpret the music', code: 'C'},
                {name: 'D. Asking them to identify the emotions each piece of music evokes', code: 'D'},
            ],
            course1Module3Question1: [
                {name: 'A. Cardiac conditions', code: 'A'},
                {name: 'B. Treating Trauma', code: 'B'},
                {name: 'C. Autism', code: 'C'},
                {name: 'D. Alzheimer’s Disease', code: 'D'},
                {name: 'E. All of the above', code: 'E'},
            ],
            course1Module3Question2: [
                {name: 'A. Frontal cortex, amydala and reptilian brain', code: 'A'},
                {name: 'B. Thinking brain, Emotional brain and Reptilian brain', code: 'B'},
                {name: 'C. Conscious mind, subconcious mind and unconscious mind', code: 'C'},
                {name: 'D. None of the above', code: 'D'},
            ],
            course1Module3Question3: [
                {name: 'A. Unconscious mind', code: 'A'},
                {name: 'B. Conscious mind', code: 'B'},
                {name: 'C. Subconscious mind', code: 'C'},
                {name: 'D. All of the above', code: 'D'},
            ],
            course1Module3Question4: [
                {name: 'A. Meditation', code: 'A'},
                {name: 'B. Brain Spotting', code: 'B'},
                {name: 'C. BWRT', code: 'C'},
                {name: 'D. Self Hypnosis', code: 'D'},
                {name: 'E. All of the Above', code: 'E'},
            ],
            course1Module3Question5: [
                {name: 'A. Unconscious mind', code: 'A'},
                {name: 'B. Subconscious mind', code: 'B'},
                {name: 'C. Conscious mind', code: 'C'},
                {name: 'D. All of the above', code: 'D'},
            ],
            course1Module4Question1: [
                {name: 'A. Depersonalisation, and extreme Exhaustion', code: 'A'},
                {name: 'B. Depersonalisation, decreased sense of accomplishment and extreme exhaustion', code: 'B'},
                {name: 'C. Depression, depersonalisation, and extreme exhaustion', code: 'C'},
                {name: 'D. Decreased sense of accomplishment, extreme exhaustion and depression', code: 'D'},
            ],
            course1Module4Question2: [
                {name: 'A. Ongoing stress with unrealistic expectations', code: 'A'},
                {name: 'B. Ongoing stress, busyness and fatigue', code: 'B'},
                {name: 'C. Chronic illness that is not managed well with a balanced lifestyle', code: 'C'},
                {name: 'D. Not being in touch with the demands on your mind and body', code: 'D'},
            ],
            course1Module4Question3: [
                {name: 'A. Freud', code: 'A'},
                {name: 'B. Berger', code: 'B'},
                {name: 'C. Bar-On', code: 'C'},
                {name: 'D. Goleman', code: 'D'},
            ],
            course1Module4Question4: [
                {name: 'A. Getting a break from the situation', code: 'A'},
                {name: 'B. Slow down the Amygdala and regain control of one’s nervous system', code: 'B'},
                {name: 'C. Allows oneself to detach from the situation', code: 'C'},
                {name: 'D. Comforting oneself and being able to steel oneself for the next demand', code: 'D'},
            ],
            course1Module4Question5: [
                {name: 'A. Exercise, regulated breathing and hobbies', code: 'A'},
                {name: 'B. Regulated breathing, yoga and medication', code: 'B'},
                {name: 'C. Regulated breathing, meditation and practicing gratitude and compassion', code: 'C'},
                {name: 'D. Journaling, exercise and healthy eating', code: 'D'},
            ],
            course1Module5Question1: [
                {name: 'A. Thoughts, feelings, fantasies, anxieties and defenses', code: 'A'},
                {name: 'B. How their homes are structured and how their parents engage with them', code: 'B'},
                {name: 'C. They play that they engage in at a social level with their peers', code: 'C'},
                {name: 'D. A manifestation of all of their observations provided by media', code: 'D'},
            ],
            course1Module5Question2: [
                {name: 'A. Sigmund Freud', code: 'A'},
                {name: 'B. Carl Rogers', code: 'B'},
                {name: 'C. Carl Jung', code: 'C'},
                {name: 'D. Melanie Klein', code: 'D'},
            ],
            course1Module5Question3: [
                {
                    name: 'A. Getting the child to verbalize their experiences by playing with dolls or action figures and recreating the scenario',
                    code: 'A'
                },
                {name: 'B. Role play, puppets, arts and crafts, storytelling', code: 'B'},
                {name: 'C. Water and sand play', code: 'C'},
                {name: 'D. All of the above', code: 'D'},
            ],
            course1Module5Question4: [
                {name: 'A. Birth to 15 years', code: 'A'},
                {name: 'B. A few months to 2 years', code: 'B'},
                {name: 'C. A few months to 13 years', code: 'C'},
                {name: 'D. All of the above', code: 'D'},
            ],
            course1Module5Question5: [
                {name: 'A. When your child says that she or he wants to play with a therapist', code: 'A'},
                {name: 'B. When your child is having many nightmares', code: 'B'},
                {
                    name: 'C. When there is a marked difference in your child and you notice a change in their behaviour',
                    code: 'C'
                },
                {name: 'D. All of the above', code: 'D'},
            ],
            course1Module6Question1: [
                {name: 'A. 1960s', code: 'A'},
                {name: 'B. 1970s', code: 'B'},
                {name: 'C. 1980s', code: 'C'},
                {name: 'D. 1990s', code: 'D'},
            ],
            course1Module6Question2: [
                {name: 'A. Between individual and family therapy', code: 'A'},
                {name: 'B. Between individual and couples therapy', code: 'B'},
                {name: 'C. Between individual and play therapy', code: 'C'},
                {name: 'D. Between individual and group therapy', code: 'D'},
            ],
            course1Module6Question3: [
                {name: 'A. Loyalty or hidden Loyalty', code: 'A'},
                {name: 'B. Delegation', code: 'B'},
                {name: 'C. Relational ethics', code: 'C'},
                {name: 'D. All of the above', code: 'D'},
            ],
            course1Module6Question4: [
                {name: 'A. Facts, family psychology, relational ethics and transactional analysis', code: 'A'},
                {name: 'B. Facts, individual psychology, relational ethics and transactional analysis', code: 'B'},
                {
                    name: 'C. Facts, intergenerational psychology, relational ethics and transactional analysis',
                    code: 'C'
                },
                {name: 'D. Delegation, family psychology, relational ethics and transactional analysis', code: 'D'},
            ],
            course1Module6Question5: [
                {name: 'A. To make sure that the client is aware of their extended family', code: 'A'},
                {
                    name: 'B. To trace the existing members as well as those that have passed on for the therapist',
                    code: 'B'
                },
                {name: 'C. To depict key members and their relationships with clients', code: 'C'},
                {name: 'D. Get clients used to the idea of working within the Contextual Therapy framework', code: 'D'},
            ],
            course1Module7Question1: [
                {name: 'A. It is the study of Hippos', code: 'A'},
                {name: 'B. It is a guided trancelike state that is facilitated by a therapist', code: 'B'},
                {name: 'C. Horse therapy', code: 'C'},
                {name: 'D. A combination of horse therapy and meditation', code: 'D'},
            ],
            course1Module7Question2: [
                {name: 'A. The stimulation of neural pathways in the brain', code: 'A'},
                {name: 'B. The activation of the vestibular system', code: 'B'},
                {name: 'C. Shift centre of gravity', code: 'C'},
                {name: 'D. All of the above', code: 'D'},
            ],
            course1Module7Question3: [
                {
                    name: 'A. Reluctance from parents to engage in this form of therapy as little is known about it',
                    code: 'A'
                },
                {name: 'B. Reluctance from patients due to fear of the unknown', code: 'B'},
                {name: 'C. Malpractice concerns for the Hippotherapist', code: 'C'},
                {name: 'D. A and B', code: 'D'},
            ],
            course1Module7Question4: [
                {name: 'A. Cerebral Palsy', code: 'A'},
                {name: 'B. ADHD', code: 'B'},
                {name: 'C. Autistic Spectrum Disorder', code: 'C'},
                {name: 'D. All of the above', code: 'D'},
            ],
            course1Module7Question5: [
                {name: 'A. You need to know horses very well', code: 'A'},
                {name: 'B. You need a post-graduate qualification', code: 'B'},
                {
                    name: 'C. You need a post-graduate qualification and level 3 of your horsemanship qualification',
                    code: 'C'
                },
                {name: 'D. You don’t need any qualifications', code: 'D'},
            ],
            course1Module8Question1: [
                {name: 'A. It entails the treatment of the hands', code: 'A'},
                {name: 'B. It is the rehabilitation of the upper limbs and hands', code: 'B'},
                {
                    name: 'C. It is an intervention that is required when due to injury or medical condition, your hand and arm do not work in the way it should',
                    code: 'C'
                },
                {name: 'D. B and C', code: 'D'},
            ],
            course1Module8Question2: [
                {name: 'A. Observation of current functioning/dysfunction', code: 'A'},
                {name: 'B. Pain, swelling and sensation that is felt by patient', code: 'B'},
                {name: 'C. Understanding what patient goals are for the therapeutic intervention', code: 'C'},
                {name: 'D. All of the above', code: 'D'},
            ],
            course1Module8Question3: [
                {
                    name: 'A. Managing the expectations of patient and employer with regards to functionality that can be obtained post injury',
                    code: 'A'
                },
                {
                    name: 'B. Working with the employer to see if there can be a reasonable accommodation of patient should functionality be limited',
                    code: 'B'
                },
                {
                    name: 'C. Helping patients accept that they may not be able to function in that position at work if their injury has caused permanent damage',
                    code: 'C'
                },
                {name: 'D. A and B', code: 'D'},
            ],
            course1Module8Question4: [
                {name: 'A. Surgeon, hand therapist (OT), surgical staff, physiotherapist', code: 'A'},
                {name: 'B. Surgeon, physiotherapist, surgical staff', code: 'B'},
                {name: 'C. Surgeon, psychologist, surgical staff', code: 'C'},
                {name: 'D. Surgeon, Neurologist, surgical staff', code: 'D'},
            ],
            course1Module8Question5: [
                {name: 'A. A postgraduate qualification in the treatment of hand and arm injury.', code: 'A'},
                {name: 'B. Custom made splints to alleviate pain or manage the use of the injured limb', code: 'B'},
                {name: 'C. Consultation and advocacy for the injured patient with her or his employer', code: 'C'},
                {name: 'D. All of the above', code: 'D'},
            ],
            course2Module1: {},
            course2Module2: {},
            course2Module3: {},
            course2Module1Question1: [
                {name: 'A. True', code: 'A'},
                {name: 'B. False', code: 'B'},
            ],
            course2Module1Question2: [
                {name: 'A. True', code: 'A'},
                {name: 'B. False', code: 'B'},
            ],
            course2Module1Question3: [
                {name: 'A. One Session', code: 'A'},
                {name: 'B. Four Sessions', code: 'B'},
                {name: 'C. Eight Sessions', code: 'C'},
                {name: 'D. Twelve Sessions', code: 'D'},
                {name: 'E. Impossible to determine, but normally longer term', code: 'E'},
            ],
            course2Module1Question4: [
                {name: 'A. True', code: 'A'},
                {name: 'B. False', code: 'B'},
            ],
            course2Module1Question5: [
                {name: 'A. True', code: 'A'},
                {name: 'B. False', code: 'B'},
            ],
            course2Module2Question1: [
                {name: 'A. Trauma', code: 'A'},
                {name: 'B. Stress', code: 'B'},
                {name: 'C. Not diagnosed as a child', code: 'C'},
                {name: 'B. Family problems', code: 'D'},
            ],
            course2Module2Question2: [
                {name: 'A. True', code: 'A'},
                {name: 'B. False', code: 'B'},
            ],
            course2Module2Question3: [
                {name: 'A. True', code: 'A'},
                {name: 'B. False', code: 'B'},
            ],
            course2Module2Question4: [
                {name: 'A. Development history', code: 'A'},
                {name: 'B. Medical history', code: 'B'},
                {name: 'C. A and B', code: 'C'},
            ],
            course2Module2Question5: [
                {name: 'A. 9 months', code: 'A'},
                {name: 'B. 2 years', code: 'B'},
                {name: 'C. 5 years', code: 'C'},
                {name: 'D. 12 years', code: 'D'},
            ],
            course2Module3Question1: [
                {name: 'A. True', code: 'A'},
                {name: 'B. False', code: 'B'},
            ],
            course2Module3Question2: [
                {name: 'A. Eat chewy food', code: 'A'},
                {name: 'B. Drink water from a water bottle', code: 'B'},
                {name: 'C. Play educational video games', code: 'C'},
                {name: 'D. A and B', code: 'D'},
            ],
            course2Module3Question3: [
                {name: 'A. True', code: 'A'},
                {name: 'B. False', code: 'B'},
            ],
            course2Module3Question4: [
                {name: 'A. True', code: 'A'},
                {name: 'B. False', code: 'B'},
            ],
            course2Module3Question5: [
                {name: 'A. Touch', code: 'A'},
                {name: 'B. Sound', code: 'B'},
                {name: 'C. Visual Input', code: 'C'},
                {name: 'D. A, B and C', code: 'D'},
            ],
            course3Module1: {},
            course3Module2: {},
            course3Module3: {},
            course3Module4: {},
            course3Module5: {},
            course3Module6: {},
            course3Module7: {},
            course3Module8: {},
            course3Module9: {},
            course3Module10: {},
            course3Module11: {},
            course3Module12: {},
            course3Module13: {},
            course3Module14: {},
            course3Module1Question1: [
                {name: 'A. As a spectrum', code: 'A'},
                {name: 'B. The opposite end of the spectrum of Autism was Asperger\'s syndrome', code: 'B'},
                {name: 'C. A and B', code: 'C'},
                {
                    name: 'D. Individuals with Asperger\'s Syndrome were highly intellectual with amazing cognitive abilities.',
                    code: 'D'
                },
            ],
            course3Module1Question2: [
                {
                    name: 'A. which is focussed on the gifts or heightened skills that such individuals possess',
                    code: 'A'
                },
                {
                    name: 'B. which is categorised in terms of  3 levels of severity, ie. requiring support; requiring substantial support and requiring very substantial support',
                    code: 'B'
                },
                {
                    name: 'C. There needs to be a significant deficit in each of the three areas of communication and exhibit restricted, repetitive behaviours',
                    code: 'C'
                },
                {name: 'D. All of the above', code: 'D'},
            ],
            course3Module1Question3: [
                {name: 'A. Bad parenting, childhood trauma and vaccines', code: 'A'},
                {name: 'B. Childhood illnesses', code: 'B'},
                {name: 'C. Injury as an infant', code: 'C'},
                {name: 'D. Poor attachment to mother as an infant', code: 'D'},
            ],
            course3Module1Question4: [
                {name: 'A. Children who are not able to communicate and engage with their worlds', code: 'A'},
                {
                    name: 'B. Children who are not able to eat a healthy variety of different foods and therefore unable to speak well',
                    code: 'B'
                },
                {
                    name: 'C. Children have the job of playing, growing and developing while being safe. If there is hindrance in any of these areas, they may not reach their full potential',
                    code: 'C'
                },
                {name: 'D. All of the above', code: 'D'},
            ],
            course3Module1Question5: [
                {name: 'A. Non-verbal communication', code: 'A'},
                {name: 'B. Verbal communication', code: 'B'},
                {name: 'C. A combination of the verbal and non-verbal communication', code: 'C'},
                {name: 'D. Gesturing', code: 'D'},
            ],
            course3Module2Question1: [
                {
                    name: 'A. It is the inefficiency in our central nervous systems to process all the information that is received through our senses',
                    code: 'A'
                },
                {
                    name: 'B. It is a disorder that results when our hidden senses, ie the vestibular system and proprioception are impaired',
                    code: 'B'
                },
                {name: 'C. It is when our sensory signals don\'t get organised into appropriate responses', code: 'C'},
                {name: 'D. A and C', code: 'D'},
            ],
            course3Module2Question2: [
                {name: 'A. Executive functioning; Sensory systems and Communication', code: 'A'},
                {name: 'B. Executive functioning, Sensory systems and Motor planning', code: 'B'},
                {name: 'C. Executive functioning and Sensory systems', code: 'C'},
                {name: 'D. Executive functioning and Motor planning', code: 'D'},
            ],
            course3Module2Question3: [
                {name: 'A. Executive functioning', code: 'A'},
                {name: 'B. Motor Planning', code: 'B'},
                {name: 'C. Sensory system', code: 'C'},
                {name: 'D. All of the above', code: 'D'},
            ],
            course3Module2Question4: [
                {name: 'A. They are rigid and insist on having things done in their own way', code: 'A'},
                {name: 'B. They tend to be anxious and easily overwhelmed in unfamiliar situations', code: 'B'},
                {name: 'C.  They struggle to make friends and self-soothe', code: 'C'},
                {name: 'D. All of the above', code: 'D'},
            ],
            course3Module2Question5: [
                {name: 'A. Tactile system and proprioceptive system', code: 'A'},
                {name: 'B. Tactile and vestibular system', code: 'B'},
                {name: 'C. Vestibular and Visual system', code: 'C'},
                {name: 'D. Vestibular and proprioceptive system', code: 'D'},
            ],
            course3Module3Question1: [
                {name: 'A. Recommendation from a psychiatrist', code: 'A'},
                {name: 'B. Recommendation from a patient', code: 'B'},
                {name: 'C. Involvement with cancer counselling society', code: 'C'},
                {name: 'D. Involvement with SADAG', code: 'D'},
            ],
            course3Module3Question2: [
                {name: 'A. Referrals from other practitioners', code: 'A'},
                {name: 'B. Referrals from existing patients', code: 'B'},
                {name: 'C. Referrals from websites', code: 'C'},
                {name: 'D. A and C', code: 'D'},
                {name: 'E. All of the above', code: 'E'},
            ],
            course3Module3Question3: [
                {name: 'A. 1-2 year', code: 'A'},
                {name: 'B. 2-5 years', code: 'B'},
                {name: 'C. Over 20 years', code: 'C'},
                {name: 'D. Over 30 years', code: 'D'},
            ],
            course3Module3Question4: [
                {name: 'A. True', code: 'A'},
                {name: 'B. False', code: 'B'},
            ],
            course3Module3Question5: [
                {name: 'A. Being over committed to their normaly responsibilities', code: 'A'},
                {name: 'B. Make significant life-altering changes', code: 'B'},
                {name: 'C. Forget the existence of the other children', code: 'C'},
                {name: 'D. All of the above', code: 'D'},
            ],
            course3Module4Question1: [
                {name: 'A. Acknowledge loss head-on ', code: 'A'},
                {name: 'B. Try not to fix or change the experience of the griever', code: 'B'},
                {name: 'C. Dont minimize the experience of the griever', code: 'C'},
                {name: 'D. All of the above', code: 'D'},
            ],
            course3Module4Question2: [
                {name: 'A. Show up and mirror their experience of loss', code: 'A'},
                {name: 'B. Try to distract them from their intense grief', code: 'B'},
                {
                    name: 'C. Help them search for meaning in other experiences rather than focussing on the loss',
                    code: 'C'
                },
                {
                    name: 'D. Helping them understand that they are still alive and therefore need to move on with their lives',
                    code: 'D'
                },
            ],
            course3Module4Question3: [
                {
                    name: 'A. A term that was coined by Dr Dennis Stoker describing extreme grief experienced by an individual',
                    code: 'A'
                },
                {
                    name: 'B. Dr. Dennis Stoker coined this term to describe someone who is deprived of the right to grieve',
                    code: 'B'
                },
                {
                    name: 'C. Dr. Dennis Stoker used this term to describe someone when their loss is not or cannot be openly acknowledged, publicly mourned or socially supported',
                    code: 'C'
                },
                {name: 'D. B and C', code: 'D'},
            ],
            course3Module4Question4: [
                {
                    name: 'A. Grieving is an individual experience so we ought to give them time and space to grieve on their own',
                    code: 'A'
                },
                {
                    name: 'B. Grieving is a lonely experience that needs social support from people who know you and your life experiences',
                    code: 'B'
                },
                {
                    name: 'C. We should try not to bring up painful memories associated with the person who has died',
                    code: 'C'
                },
                {
                    name: 'D. We should distract the person who is grieving by occupying their time and mind with more exciting experiences',
                    code: 'D'
                },
            ],
            course3Module4Question5: [
                {
                    name: 'A. Yes. The lack of acknowledgement of the impact of grief can only be used to describe how people feel when they have lost their person.',
                    code: 'A'
                },
                {
                    name: 'B. No. Disenfranchised grief may pertain to any loss that is minimized or given  public acknowledgement.',
                    code: 'B'
                },
            ],
            course3Module5Question1: [
                {name: 'A. Acting out at school such as being a bully.', code: 'A'},
                {name: 'B. Throwing tantrums.', code: 'B'},
                {name: 'C. Refusing to go to school and being disrespectful to adults.', code: 'C'},
                {name: 'D. Anxiety is often silent in its presentation in children.', code: 'D'},
            ],
            course3Module5Question2: [
                {name: 'A. Being afraid of everyday activities.', code: 'A'},
                {
                    name: 'B. Exhibiting an appropriate response in the face of a dangerous or stressful situation.',
                    code: 'B'
                },
                {name: 'C. Difficulty in separating from parents and caregivers.', code: 'C'},
                {name: 'D. Being extremely shy and not wanting to engage with peers and teachers.', code: 'D'},
            ],
            course3Module5Question3: [
                {name: 'A. Gather appropriate information from parents and caregivers about the child.', code: 'A'},
                {name: 'B. Understand the context of the child and her or his environment.', code: 'B'},
                {name: 'C. Identify possible traumatic events that may have contributed to the anxiety.', code: 'C'},
                {name: 'D. All of the above.', code: 'D'},
            ],
            course3Module5Question4: [
                {
                    name: 'A. Through the process of play therapy, the therapist helps the child to understand the triggers of anxiety and equips them with coping mechanisms.',
                    code: 'A'
                },
                {name: 'B. Empowers parents and caregivers with management skills in dealing with anxiety.', code: 'B'},
                {name: 'C. Waits for the child to mature and grow out of the anxiety.', code: 'C'},
                {name: 'D. A and B', code: 'D'},
            ],
            course3Module5Question5: [
                {name: 'A. Worry time that is scheduled with a child.', code: 'A'},
                {name: 'B. A space to verbalise their worries rather than suppressing it.', code: 'B'},
                {name: 'C. Reading stories and books about anxiety and how other children manage it.', code: 'C'},
                {name: 'D. All of the above', code: 'D'},
            ],
            course3Module6Question1: [
                {name: 'A. Facebook', code: 'A'},
                {name: 'B. Email', code: 'B'},
                {name: 'C. LinkedIn', code: 'C'},
                {name: 'D. Instagram', code: 'D'},
                {name: 'E. All of the above', code: 'E'},
            ],
            course3Module6Question2: [
                {name: 'A. Tigger', code: 'A'},
                {name: 'B. Piglet', code: 'B'},
                {name: 'C. Eeyore', code: 'C'},
                {name: 'D. Rabbit', code: 'D'},
                {name: 'E. Winnie', code: 'E'},
            ],
            course3Module6Question3: [
                {name: 'A. True', code: 'A'},
                {name: 'B. False', code: 'B'},
            ],
            course3Module6Question4: [
                {name: 'A. Substance abuse', code: 'A'},
                {name: 'B. Trauma', code: 'B'},
                {name: 'C. A traumatic event are often triggers and catalysts to mental health disorders', code: 'C'},
                {name: 'D. B and C', code: 'D'},
                {name: 'E. All of the above', code: 'E'},
            ],
            course3Module6Question5: [
                {name: 'A. Male', code: 'A'},
                {name: 'B. Female', code: 'B'},
                {name: 'C. A and B', code: 'C'},
            ],
            course3Module7Question1: [
                {name: 'A. Going to university', code: 'A'},
                {name: 'B. Attending a postgraduate course', code: 'B'},
                {name: 'C. Becoming a birth doula', code: 'C'},
                {name: 'D. All of the above', code: 'D'},
                {name: 'E. None of the above', code: 'E'},
            ],
            course3Module7Question2: [
                {name: 'A. The baby', code: 'A'},
                {name: 'B. The mother', code: 'B'},
                {name: 'C. The mother and father', code: 'C'},
                {name: 'D. Who the parents are becoming', code: 'D'},
                {name: 'E. All of the above', code: 'E'},
            ],
            course3Module7Question3: [
                {name: 'A. Psychiatrists', code: 'A'},
                {name: 'B. Psychologists', code: 'B'},
                {name: 'C. Lactation specialists', code: 'C'},
                {name: 'D. Mom and baby classes', code: 'D'},
                {name: 'E. All of the above', code: 'E'},
            ],
            course3Module7Question4: [
                {name: 'A. True', code: 'A'},
                {name: 'B. False', code: 'B'},
            ],
            course3Module7Question5: [
                {name: 'A. Pamper package', code: 'A'},
                {name: 'B. Cooked real food', code: 'B'},
                {name: 'C. Wash the dishes', code: 'C'},
                {name: 'D. All of the above', code: 'D'},
                {name: 'E. None of the above', code: 'E'},
            ],
            course3Module8Question1: [
                {name: 'A. Yes, bipolar one and bipolar two', code: 'A'},
                {name: 'B. No, just general bipolar', code: 'B'},
            ],
            course3Module8Question2: [
                {name: 'A. Visit to a psychiatrist', code: 'A'},
                {name: 'B. Presence of a manic episode', code: 'B'},
                {name: 'C. Clinical test', code: 'C'},
                {name: 'D. All of the above', code: 'D'},
            ],
            course3Module8Question3: [
                {name: 'A. One', code: 'A'},
                {name: 'B. Two', code: 'B'},
                {name: 'C. Five or more', code: 'C'},
                {name: 'D. Eight or more', code: 'D'},
            ],
            course3Module8Question4: [
                {name: 'A. One week', code: 'A'},
                {name: 'B. Two weeks', code: 'B'},
                {name: 'C. One month', code: 'C'},
                {name: 'D. Two months', code: 'D'},
                {name: 'E. Six months', code: 'E'},
            ],
            course3Module8Question5: [
                {name: 'A. An inflated self esteem', code: 'A'},
                {name: 'B. Sense of grandiosity', code: 'B'},
                {name: 'C. Over confidence', code: 'C'},
                {name: 'D. All of the above', code: 'D'},
                {name: 'E. None of the above', code: 'E'},
            ],
            course3Module9Question1: [
                {name: 'A. Facebook', code: 'A'},
                {name: 'B. Email', code: 'B'},
                {name: 'C. LinkedIn', code: 'C'},
                {name: 'D. BWRT group', code: 'D'},
                {name: 'E. All of the above', code: 'E'},
            ],
            course3Module9Question2: [
                {name: 'A. Gauteng Province', code: 'A'},
                {name: 'B. North-West Province', code: 'B'},
                {name: 'C. Northern Province', code: 'C'},
                {name: 'D. Kwa-Zulu Natal Province', code: 'D'},
                {name: 'E. None of the above', code: 'E'},
            ],
            course3Module9Question3: [
                {name: 'A. Mixed stimuli in the brain', code: 'A'},
                {name: 'B. Proportionality, when your brain struggles to differentiate the levels.', code: 'B'},
                {name: 'C. Upbringing and education', code: 'C'},
                {name: 'D. None of the above', code: 'D'},
            ],
            course3Module9Question4: [
                {name: 'A. True', code: 'A'},
                {name: 'B. False', code: 'B'},
            ],
            course3Module9Question5: [
                {name: 'A. Psychodynamic therapy', code: 'A'},
                {name: 'B. CBT', code: 'B'},
                {name: 'C. BWRT', code: 'C'},
                {name: 'D. All of the above', code: 'D'},
                {name: 'E. None of the above', code: 'E'},
            ],
            course3Module10Question1: [
                {name: 'A. Perfectionism', code: 'A'},
                {name: 'B. Anxiety', code: 'B'},
                {name: 'C. Controlling Food', code: 'C'},
                {name: 'D. All of the above', code: 'D'},
                {name: 'E. None of the above', code: 'E'},
            ],
            course3Module10Question2: [
                {name: 'A. Early childhood', code: 'A'},
                {name: 'B. Teenage years', code: 'B'},
                {name: 'C. Adult years', code: 'C'},
                {name: 'D. A and B', code: 'D'},
                {name: 'E. B and C', code: 'E'},
            ],
            course3Module10Question3: [
                {name: 'A. True', code: 'A'},
                {name: 'B. False', code: 'B'},
            ],
            course3Module10Question4: [
                {name: 'A. Being conscious of things', code: 'A'},
                {name: 'B. Having balance', code: 'B'},
                {name: 'C. Guide to preparing more meals', code: 'C'},
                {name: 'D. A and B', code: 'D'},
            ],
            course3Module10Question5: [
                {name: 'A. Body image', code: 'A'},
                {name: 'B. Skinny', code: 'B'},
                {name: 'C. Bingeing', code: 'C'},
                {name: 'D. All of the above', code: 'D'},
                {name: 'E. None of the above', code: 'E'},
            ],
            course3Module11Question1: [
                {name: 'A. It cannot be clinically diagnosed', code: 'A'},
                {name: 'B. It is always evolving and unfolding', code: 'B'},
                {name: 'C. The types of clients change', code: 'C'},
                {name: 'D. All of the above', code: 'D'},
                {name: 'E. None of the above', code: 'E'},
            ],
            course3Module11Question2: [
                {name: 'A. True', code: 'A'},
                {name: 'B. False', code: 'B'},
            ],
            course3Module11Question3: [
                {name: 'A. Early childhood', code: 'A'},
                {name: 'B. Adolescents', code: 'B'},
                {name: 'C. Young adults', code: 'C'},
                {name: 'D. Adults', code: 'D'},
                {name: 'E. B and C', code: 'E'},
            ],
            course3Module11Question4: [
                {name: 'A. True', code: 'A'},
                {name: 'B. False', code: 'B'},
            ],
            course3Module11Question5: [
                {name: 'A. Biological factors', code: 'A'},
                {name: 'B. Social factors', code: 'B'},
                {name: 'C. Environmental factors', code: 'C'},
                {name: 'D. All of the above', code: 'D'},
                {name: 'E. None of the above', code: 'E'},
            ],
            course3Module12Question1: [
                {name: 'A. Facebook', code: 'A'},
                {name: 'B. Email', code: 'B'},
                {name: 'C. LinkedIn', code: 'C'},
                {name: 'D. Instagram', code: 'D'},
                {name: 'E. None of the above', code: 'E'},
            ],
            course3Module12Question2: [
                {name: 'A. 10%', code: 'A'},
                {name: 'B. 25%', code: 'B'},
                {name: 'C. 50%', code: 'C'},
                {name: 'D. 90%', code: 'D'},
                {name: 'E. None of the above', code: 'E'},
            ],
            course3Module12Question3: [
                {name: 'A. Fat', code: 'A'},
                {name: 'B. Carbohydrates', code: 'B'},
                {name: 'C. Protein', code: 'C'},
                {name: 'D. None of the above', code: 'D'},
            ],
            course3Module12Question4: [
                {name: 'A. Pancreas', code: 'A'},
                {name: 'B. Lungs', code: 'B'},
                {name: 'C. Kidneys', code: 'C'},
                {name: 'D. Blood cells', code: 'D'},
                {name: 'E. None of the above', code: 'E'},
            ],
            course3Module12Question5: [
                {name: 'A. Early childhood', code: 'A'},
                {name: 'B. Teenage years', code: 'B'},
                {name: 'C. Adult years', code: 'C'},
                {name: 'D. A and B', code: 'D'},
                {name: 'E. B and C', code: 'E'},
            ],
            course3Module13Question1: [
                {name: 'A. Exercise', code: 'A'},
                {name: 'B. Not being the sun', code: 'B'},
                {name: 'C. Glycemic control', code: 'C'},
                {name: 'D. Taking insulin', code: 'D'},
                {name: 'E. None of the above', code: 'E'},
            ],
            course3Module13Question2: [
                {name: 'A. They are forgetful', code: 'A'},
                {name: 'B. They do not have enough strength', code: 'B'},
                {name: 'C. They need to regulate their insulin levels', code: 'C'},
                {name: 'D. They lose sensation in their feet', code: 'D'},
                {name: 'E. All of the above', code: 'E'},
            ],
            course3Module13Question3: [
                {name: 'A. Below 1', code: 'A'},
                {name: 'B. Between 2.5 and 6.1', code: 'B'},
                {name: 'C. Between 3.6 and 6.3', code: 'C'},
                {name: 'D. Between 2.7 and 6.9', code: 'D'},
                {name: 'E. None of the above', code: 'E'},
            ],
            course3Module13Question4: [
                {name: 'A. True', code: 'A'},
                {name: 'B. False', code: 'B'},
            ],
            course3Module13Question5: [
                {name: 'A. Once every two weeks', code: 'A'},
                {name: 'B. Once every four weeks', code: 'B'},
                {name: 'C. Once every eight weeks', code: 'C'},
                {name: 'D. Once every 6 months', code: 'D'},
                {name: 'E. None of the above', code: 'E'},
            ],
            course3Module14Question1: [
                {name: 'A. Facebook', code: 'A'},
                {name: 'B. Email', code: 'B'},
                {name: 'C. LinkedIn', code: 'C'},
                {name: 'D. Instagram', code: 'D'},
                {name: 'E. None of the above', code: 'E'},
            ],
            course3Module14Question2: [
                {name: 'A. True', code: 'A'},
                {name: 'B. False', code: 'B'},
            ],
            course3Module14Question3: [
                {name: 'A. It is a psychiatric disorder', code: 'A'},
                {name: 'B. It interferes with daily functioning', code: 'B'},
                {name: 'C. It causes significant impairment and distress', code: 'C'},
                {name: 'D. It is a chronic condition', code: 'D'},
                {name: 'E. All of the above', code: 'E'},
            ],
            course3Module14Question4: [
                {name: 'A. 0%', code: 'A'},
                {name: 'B. 10-15%', code: 'B'},
                {name: 'C. 20-25%', code: 'C'},
                {name: 'D. 30-50%', code: 'D'},
                {name: 'E. 100%', code: 'E'},
            ],
            course3Module14Question5: [
                {name: 'A. OCPD has more of a perfectionistic underpinning to it ', code: 'A'},
                {name: 'B. OCPD has more of a relationship association to it', code: 'B'},
                {name: 'C. There is no difference', code: 'C'},
                {name: 'D. None of the above', code: 'D'},
            ],
            course4: {},
            course4Question1: [
                {name: 'A. True', code: 'A'},
                {name: 'B. False', code: 'B'},
            ],
            course4Question2: [
                {name: 'A. One', code: 'A'},
                {name: 'B. Five', code: 'B'},
                {name: 'C. Thirteen', code: 'C'},
                {name: 'D. Sixteen', code: 'D'},
                {name: 'E. Twenty', code: 'E'},
            ],
            course4Question3: [
                {name: 'A. True', code: 'A'},
                {name: 'B. False', code: 'B'},
            ],
            course4Question4: [
                {name: 'A. True', code: 'A'},
                {name: 'B. False', code: 'B'},
            ],
            course4Question5: [
                {name: 'A. One Month', code: 'A'},
                {name: 'B. One Year', code: 'B'},
                {name: 'C. Six Months', code: 'C'},
                {name: 'D. Six Years', code: 'D'},
                {name: 'E. Nine Months', code: 'E'},
            ],
        }
    },
    watch: {
        'userStore.activeCompanyId': {
            immediate: false,
            async handler(newCompanyId, oldCompanyId) {
                if (!newCompanyId || newCompanyId === oldCompanyId) {
                    return;
                }

                console.log(
                    '[Appointments][watch] Company changed:',
                    oldCompanyId,
                    '→',
                    newCompanyId
                );

                await this.loadCompanyContext();
            }
        }
    },
    methods: {
        async loadCompanyContext() {
            try {
                // Attempt to get user data
                const userData = await UserService.getUser(this.userStore.user.id);
                this.profile = userData.data;
            } catch (e) {
                console.error("[AppointmentsNew][mounted] Error fetching user data = ", e);
                this.userStore.clearUser();
                this.$router.push('login');
                return;
            }

            this.profile.companyId = this.userStore.activeCompanyId;

            try {
                const [userConfigData] = await Promise.all([
                    UserService.getUserConfig(this.userStore.user.id)
                ]);

                this.userConfiguration = userConfigData.data;

                console.log("[Applications][mounted] userConfigData.data = ", userConfigData.data);
            } catch (e) {
                console.error("[Applications][mounted] Could not find user config for user = ", this.userStore.user.id);
                this.userConfiguration = {
                    enableAppstoreApp1: 'N',
                    enableAppstoreApp2: 'N',
                    enableAppstoreApp3: 'N',
                    enableAppstoreApp4: 'N',
                    enableAppstoreApp5: 'N',
                    enableAppstoreApp6: 'N',
                    enableAppstoreApp7: 'N',
                    enableAppstoreApp8: 'N',
                    enableAppstoreApp9: 'N',
                    enableAppstoreApp10: 'N',
                    enableAppstoreApp11: 'N'
                };
            }
        },
        closeAllMenus() {
            document.body.click(); // triggers hideOnOutsideClick

            document.querySelectorAll('.p-component-overlay, .p-menu-overlay, .p-overlay, .p-tieredmenu-overlay')
                .forEach(el => el.remove());
        },
        safeNavigate(target) {
            this.closeAllMenus();
            setTimeout(() => {
                this.$router.push(target);
            }, 0);
        },
        callReset() {
            console.log("[ProfileApplication001][callReset] Beginning.");
            this.safeNavigate('/commonApplicationStore');
        },
        callHome() {
            this.activeTab = 1;
        },
        callCourse1() {
            this.activeTab = 2;
        },
        callCourse2() {
            this.activeTab = 3;
        },
        callCourse3() {
            this.activeTab = 4;
        },
        callCourse4() {
            this.activeTab = 5;
        },
        submitQuestionnaireCourse1Module1() {
            console.log(this.course1Module1);

            var newCourseAssessmentDto = {
                userId: this.userStore.user.id,
                answer1: this.course1Module1.answer1,
                answer2: this.course1Module1.answer2,
                answer3: this.course1Module1.answer3,
                answer4: this.course1Module1.answer4,
                answer5: this.course1Module1.answer5,
            };

            console.log(newCourseAssessmentDto);

            CourseAssessmentService.processCourseModuleAssessment(this.userStore.user.id, 100, newCourseAssessmentDto)
                .then(data => {
                    console.log("[CpdOverview][mounted] Data = ", data);
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Course Module Assessment',
                        detail: "Submitted Questionnaire for Course #1 Module #1. Answers are Correct.",
                        life: 3000
                    })
                })
                .catch(e => {
                    console.log("[CpdOverview][mounted] Error = ", e);
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Course Module Assessment',
                        detail: "Submitted Questionnaire for Course #1 Module #1. Answers are NOT Correct.",
                        life: 3000
                    })
                });

        },
        submitQuestionnaireCourse1Module2() {
            console.log(this.course1Module2);

            var newCourseAssessmentDto = {
                userId: this.userStore.user.id,
                answer1: this.course1Module2.answer1,
                answer2: this.course1Module2.answer2,
                answer3: this.course1Module2.answer3,
                answer4: this.course1Module2.answer4,
                answer5: this.course1Module2.answer5,
            };

            console.log(newCourseAssessmentDto);

            CourseAssessmentService.processCourseModuleAssessment(this.userStore.user.id, 101, newCourseAssessmentDto)
                .then(data => {
                    console.log("[CpdOverview][mounted] Data = ", data);
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Course Module Assessment',
                        detail: "Submitted Questionnaire for Course #1 Module #2. Answers are Correct.",
                        life: 3000
                    })
                })
                .catch(e => {
                    console.log("[CpdOverview][mounted] Error = ", e);
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Course Module Assessment',
                        detail: "Submitted Questionnaire for Course #1 Module #2. Answers are NOT Correct.",
                        life: 3000
                    })
                });

        },
        submitQuestionnaireCourse1Module3() {
            console.log(this.course1Module3);

            var newCourseAssessmentDto = {
                userId: this.userStore.user.id,
                answer1: this.course1Module3.answer1,
                answer2: this.course1Module3.answer2,
                answer3: this.course1Module3.answer3,
                answer4: this.course1Module3.answer4,
                answer5: this.course1Module3.answer5,
            };

            console.log(newCourseAssessmentDto);

            CourseAssessmentService.processCourseModuleAssessment(this.userStore.user.id, 102, newCourseAssessmentDto)
                .then(data => {
                    console.log("[CpdOverview][mounted] Data = ", data);
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Course Module Assessment',
                        detail: "Submitted Questionnaire for Course #1 Module #3. Answers are Correct.",
                        life: 3000
                    })
                })
                .catch(e => {
                    console.log("[CpdOverview][mounted] Error = ", e);
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Course Module Assessment',
                        detail: "Submitted Questionnaire for Course #1 Module #3. Answers are NOT Correct.",
                        life: 3000
                    })
                });

        },
        submitQuestionnaireCourse1Module4() {
            console.log(this.course1Module4);

            var newCourseAssessmentDto = {
                userId: this.userStore.user.id,
                answer1: this.course1Module4.answer1,
                answer2: this.course1Module4.answer2,
                answer3: this.course1Module4.answer3,
                answer4: this.course1Module4.answer4,
                answer5: this.course1Module4.answer5,
            };

            console.log(newCourseAssessmentDto);

            CourseAssessmentService.processCourseModuleAssessment(this.userStore.user.id, 103, newCourseAssessmentDto)
                .then(data => {
                    console.log("[CpdOverview][mounted] Data = ", data);
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Course Module Assessment',
                        detail: "Submitted Questionnaire for Course #1 Module #4. Answers are Correct.",
                        life: 3000
                    })
                })
                .catch(e => {
                    console.log("[CpdOverview][mounted] Error = ", e);
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Course Module Assessment',
                        detail: "Submitted Questionnaire for Course #1 Module #4. Answers are NOT Correct.",
                        life: 3000
                    })
                });

        },
        submitQuestionnaireCourse1Module5() {
            console.log(this.course1Module5);

            var newCourseAssessmentDto = {
                userId: this.userStore.user.id,
                answer1: this.course1Module5.answer1,
                answer2: this.course1Module5.answer2,
                answer3: this.course1Module5.answer3,
                answer4: this.course1Module5.answer4,
                answer5: this.course1Module5.answer5,
            };

            console.log(newCourseAssessmentDto);

            CourseAssessmentService.processCourseModuleAssessment(this.userStore.user.id, 104, newCourseAssessmentDto)
                .then(data => {
                    console.log("[CpdOverview][mounted] Data = ", data);
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Course Module Assessment',
                        detail: "Submitted Questionnaire for Course #1 Module #5. Answers are Correct.",
                        life: 3000
                    })
                })
                .catch(e => {
                    console.log("[CpdOverview][mounted] Error = ", e);
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Course Module Assessment',
                        detail: "Submitted Questionnaire for Course #1 Module #5. Answers are NOT Correct.",
                        life: 3000
                    })
                });

        },
        submitQuestionnaireCourse1Module6() {
            console.log(this.course1Module6);

            var newCourseAssessmentDto = {
                userId: this.userStore.user.id,
                answer1: this.course1Module6.answer1,
                answer2: this.course1Module6.answer2,
                answer3: this.course1Module6.answer3,
                answer4: this.course1Module6.answer4,
                answer5: this.course1Module6.answer5,
            };

            console.log(newCourseAssessmentDto);

            CourseAssessmentService.processCourseModuleAssessment(this.userStore.user.id, 105, newCourseAssessmentDto)
                .then(data => {
                    console.log("[CpdOverview][mounted] Data = ", data);
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Course Module Assessment',
                        detail: "Submitted Questionnaire for Course #1 Module #6. Answers are Correct.",
                        life: 3000
                    })
                })
                .catch(e => {
                    console.log("[CpdOverview][mounted] Error = ", e);
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Course Module Assessment',
                        detail: "Submitted Questionnaire for Course #1 Module #6. Answers are NOT Correct.",
                        life: 3000
                    })
                });

        },
        submitQuestionnaireCourse1Module7() {
            console.log(this.course1Module7);

            var newCourseAssessmentDto = {
                userId: this.userStore.user.id,
                answer1: this.course1Module7.answer1,
                answer2: this.course1Module7.answer2,
                answer3: this.course1Module7.answer3,
                answer4: this.course1Module7.answer4,
                answer5: this.course1Module7.answer5,
            };

            console.log(newCourseAssessmentDto);

            CourseAssessmentService.processCourseModuleAssessment(this.userStore.user.id, 106, newCourseAssessmentDto)
                .then(data => {
                    console.log("[CpdOverview][mounted] Data = ", data);
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Course Module Assessment',
                        detail: "Submitted Questionnaire for Course #1 Module #7. Answers are Correct.",
                        life: 3000
                    })
                })
                .catch(e => {
                    console.log("[CpdOverview][mounted] Error = ", e);
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Course Module Assessment',
                        detail: "Submitted Questionnaire for Course #1 Module #7. Answers are NOT Correct.",
                        life: 3000
                    })
                });

        },
        submitQuestionnaireCourse1Module8() {
            console.log(this.course1Module8);

            var newCourseAssessmentDto = {
                userId: this.userStore.user.id,
                answer1: this.course1Module8.answer1,
                answer2: this.course1Module8.answer2,
                answer3: this.course1Module8.answer3,
                answer4: this.course1Module8.answer4,
                answer5: this.course1Module8.answer5,
            };

            console.log(newCourseAssessmentDto);

            CourseAssessmentService.processCourseModuleAssessment(this.userStore.user.id, 107, newCourseAssessmentDto)
                .then(data => {
                    console.log("[CpdOverview][mounted] Data = ", data);
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Course Module Assessment',
                        detail: "Submitted Questionnaire for Course #1 Module #8. Answers are Correct.",
                        life: 3000
                    })
                })
                .catch(e => {
                    console.log("[CpdOverview][mounted] Error = ", e);
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Course Module Assessment',
                        detail: "Submitted Questionnaire for Course #1 Module #8. Answers are NOT Correct.",
                        life: 3000
                    })
                });

        },
        submitQuestionnaireCourse2Module1() {
            console.log(this.course2Module1);

            var newCourseAssessmentDto = {
                userId: this.userStore.user.id,
                answer1: this.course2Module1.answer1,
                answer2: this.course2Module1.answer2,
                answer3: this.course2Module1.answer3,
                answer4: this.course2Module1.answer4,
                answer5: this.course2Module1.answer5,
            };

            console.log(newCourseAssessmentDto);

            CourseAssessmentService.processCourseModuleAssessment(this.userStore.user.id, 100, newCourseAssessmentDto)
                .then(data => {
                    console.log("[CpdOverview][mounted] Data = ", data);
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Course Module Assessment',
                        detail: "Submitted Questionnaire for Course #2 Module #1. Answers are Correct.",
                        life: 3000
                    })
                })
                .catch(e => {
                    console.log("[CpdOverview][mounted] Error = ", e);
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Course Module Assessment',
                        detail: "Submitted Questionnaire for Course #2 Module #1. Answers are NOT Correct.",
                        life: 3000
                    })
                });

        },
        submitQuestionnaireCourse2Module2() {
            console.log(this.course2Module2);

            var newCourseAssessmentDto = {
                userId: this.userStore.user.id,
                answer1: this.course2Module2.answer1,
                answer2: this.course2Module2.answer2,
                answer3: this.course2Module2.answer3,
                answer4: this.course2Module2.answer4,
                answer5: this.course2Module2.answer5,
            };

            console.log(newCourseAssessmentDto);

            CourseAssessmentService.processCourseModuleAssessment(this.userStore.user.id, 101, newCourseAssessmentDto)
                .then(data => {
                    console.log("[CpdOverview][mounted] Data = ", data);
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Course Module Assessment',
                        detail: "Submitted Questionnaire for Course #2 Module #2. Answers are Correct.",
                        life: 3000
                    })
                })
                .catch(e => {
                    console.log("[CpdOverview][mounted] Error = ", e);
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Course Module Assessment',
                        detail: "Submitted Questionnaire for Course #2 Module #2. Answers are NOT Correct.",
                        life: 3000
                    })
                });

        },
        submitQuestionnaireCourse2Module3() {
            console.log(this.course2Module3);

            var newCourseAssessmentDto = {
                userId: this.userStore.user.id,
                answer1: this.course2Module3.answer1,
                answer2: this.course2Module3.answer2,
                answer3: this.course2Module3.answer3,
                answer4: this.course2Module3.answer4,
                answer5: this.course2Module3.answer5,
            };

            console.log(newCourseAssessmentDto);

            CourseAssessmentService.processCourseModuleAssessment(this.userStore.user.id, 102, newCourseAssessmentDto)
                .then(data => {
                    console.log("[CpdOverview][mounted] Data = ", data);
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Course Module Assessment',
                        detail: "Submitted Questionnaire for Course #2 Module #3. Answers are Correct.",
                        life: 3000
                    })
                })
                .catch(e => {
                    console.log("[CpdOverview][mounted] Error = ", e);
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Course Module Assessment',
                        detail: "Submitted Questionnaire for Course #2 Module #3. Answers are NOT Correct.",
                        life: 3000
                    })
                });

        },
        submitQuestionnaireCourse3Module1() {
            console.log(this.course3Module1);

            var newCourseAssessmentDto = {
                userId: this.userStore.user.id,
                answer1: this.course3Module1.answer1,
                answer2: this.course3Module1.answer2,
                answer3: this.course3Module1.answer3,
                answer4: this.course3Module1.answer4,
                answer5: this.course3Module1.answer5,
            };

            console.log(newCourseAssessmentDto);

            CourseAssessmentService.processCourseModuleAssessment(this.userStore.user.id, 100, newCourseAssessmentDto)
                .then(data => {
                    console.log("[CpdOverview][mounted] Data = ", data);
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Course Module Assessment',
                        detail: "Submitted Questionnaire for Course #3 Module #1. Answers are Correct.",
                        life: 3000
                    })
                })
                .catch(e => {
                    console.log("[CpdOverview][mounted] Error = ", e);
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Course Module Assessment',
                        detail: "Submitted Questionnaire for Course #3 Module #1. Answers are NOT Correct.",
                        life: 3000
                    })
                });

        },
        submitQuestionnaireCourse3Module2() {
            console.log(this.course3Module2);

            var newCourseAssessmentDto = {
                userId: this.userStore.user.id,
                answer1: this.course3Module2.answer1,
                answer2: this.course3Module2.answer2,
                answer3: this.course3Module2.answer3,
                answer4: this.course3Module2.answer4,
                answer5: this.course3Module2.answer5,
            };

            console.log(newCourseAssessmentDto);

            CourseAssessmentService.processCourseModuleAssessment(this.userStore.user.id, 100, newCourseAssessmentDto)
                .then(data => {
                    console.log("[CpdOverview][mounted] Data = ", data);
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Course Module Assessment',
                        detail: "Submitted Questionnaire for Course #3 Module #2. Answers are Correct.",
                        life: 3000
                    })
                })
                .catch(e => {
                    console.log("[CpdOverview][mounted] Error = ", e);
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Course Module Assessment',
                        detail: "Submitted Questionnaire for Course #3 Module #2. Answers are NOT Correct.",
                        life: 3000
                    })
                });

        },
        submitQuestionnaireCourse3Module3() {
            console.log(this.course3Module3);

            var newCourseAssessmentDto = {
                userId: this.userStore.user.id,
                answer1: this.course3Module3.answer1,
                answer2: this.course3Module3.answer2,
                answer3: this.course3Module3.answer3,
                answer4: this.course3Module3.answer4,
                answer5: this.course3Module3.answer5,
            };

            console.log(newCourseAssessmentDto);

            CourseAssessmentService.processCourseModuleAssessment(this.userStore.user.id, 100, newCourseAssessmentDto)
                .then(data => {
                    console.log("[CpdOverview][mounted] Data = ", data);
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Course Module Assessment',
                        detail: "Submitted Questionnaire for Course #3 Module #3. Answers are Correct.",
                        life: 3000
                    })
                })
                .catch(e => {
                    console.log("[CpdOverview][mounted] Error = ", e);
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Course Module Assessment',
                        detail: "Submitted Questionnaire for Course #3 Module #3. Answers are NOT Correct.",
                        life: 3000
                    })
                });

        },
        submitQuestionnaireCourse3Module4() {
            console.log(this.course3Module4);

            var newCourseAssessmentDto = {
                userId: this.userStore.user.id,
                answer1: this.course3Module4.answer1,
                answer2: this.course3Module4.answer2,
                answer3: this.course3Module4.answer3,
                answer4: this.course3Module4.answer4,
                answer5: this.course3Module4.answer5,
            };

            console.log(newCourseAssessmentDto);

            CourseAssessmentService.processCourseModuleAssessment(this.userStore.user.id, 100, newCourseAssessmentDto)
                .then(data => {
                    console.log("[CpdOverview][mounted] Data = ", data);
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Course Module Assessment',
                        detail: "Submitted Questionnaire for Course #3 Module #4. Answers are Correct.",
                        life: 3000
                    })
                })
                .catch(e => {
                    console.log("[CpdOverview][mounted] Error = ", e);
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Course Module Assessment',
                        detail: "Submitted Questionnaire for Course #3 Module #4. Answers are NOT Correct.",
                        life: 3000
                    })
                });

        },
        submitQuestionnaireCourse3Module5() {
            console.log(this.course3Module5);

            var newCourseAssessmentDto = {
                userId: this.userStore.user.id,
                answer1: this.course3Module5.answer1,
                answer2: this.course3Module5.answer2,
                answer3: this.course3Module5.answer3,
                answer4: this.course3Module5.answer4,
                answer5: this.course3Module5.answer5,
            };

            console.log(newCourseAssessmentDto);

            CourseAssessmentService.processCourseModuleAssessment(this.userStore.user.id, 100, newCourseAssessmentDto)
                .then(data => {
                    console.log("[CpdOverview][mounted] Data = ", data);
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Course Module Assessment',
                        detail: "Submitted Questionnaire for Course #3 Module #5. Answers are Correct.",
                        life: 3000
                    })
                })
                .catch(e => {
                    console.log("[CpdOverview][mounted] Error = ", e);
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Course Module Assessment',
                        detail: "Submitted Questionnaire for Course #3 Module #5. Answers are NOT Correct.",
                        life: 3000
                    })
                });

        },
        submitQuestionnaireCourse3Module6() {
            console.log(this.course3Module6);

            var newCourseAssessmentDto = {
                userId: this.userStore.user.id,
                answer1: this.course3Module6.answer1,
                answer2: this.course3Module6.answer2,
                answer3: this.course3Module6.answer3,
                answer4: this.course3Module6.answer4,
                answer5: this.course3Module6.answer5,
            };

            console.log(newCourseAssessmentDto);

            CourseAssessmentService.processCourseModuleAssessment(this.userStore.user.id, 100, newCourseAssessmentDto)
                .then(data => {
                    console.log("[CpdOverview][mounted] Data = ", data);
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Course Module Assessment',
                        detail: "Submitted Questionnaire for Course #3 Module #6. Answers are Correct.",
                        life: 3000
                    })
                })
                .catch(e => {
                    console.log("[CpdOverview][mounted] Error = ", e);
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Course Module Assessment',
                        detail: "Submitted Questionnaire for Course #3 Module #6. Answers are NOT Correct.",
                        life: 3000
                    })
                });

        },
        submitQuestionnaireCourse3Module7() {
            console.log(this.course3Module7);

            var newCourseAssessmentDto = {
                userId: this.userStore.user.id,
                answer1: this.course3Module7.answer1,
                answer2: this.course3Module7.answer2,
                answer3: this.course3Module7.answer3,
                answer4: this.course3Module7.answer4,
                answer5: this.course3Module7.answer5,
            };

            console.log(newCourseAssessmentDto);

            CourseAssessmentService.processCourseModuleAssessment(this.userStore.user.id, 100, newCourseAssessmentDto)
                .then(data => {
                    console.log("[CpdOverview][mounted] Data = ", data);
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Course Module Assessment',
                        detail: "Submitted Questionnaire for Course #3 Module #7. Answers are Correct.",
                        life: 3000
                    })
                })
                .catch(e => {
                    console.log("[CpdOverview][mounted] Error = ", e);
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Course Module Assessment',
                        detail: "Submitted Questionnaire for Course #3 Module #7. Answers are NOT Correct.",
                        life: 3000
                    })
                });

        },
        submitQuestionnaireCourse3Module8() {
            console.log(this.course3Module8);

            var newCourseAssessmentDto = {
                userId: this.userStore.user.id,
                answer1: this.course3Module8.answer1,
                answer2: this.course3Module8.answer2,
                answer3: this.course3Module8.answer3,
                answer4: this.course3Module8.answer4,
                answer5: this.course3Module8.answer5,
            };

            console.log(newCourseAssessmentDto);

            CourseAssessmentService.processCourseModuleAssessment(this.userStore.user.id, 100, newCourseAssessmentDto)
                .then(data => {
                    console.log("[CpdOverview][mounted] Data = ", data);
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Course Module Assessment',
                        detail: "Submitted Questionnaire for Course #3 Module #8. Answers are Correct.",
                        life: 3000
                    })
                })
                .catch(e => {
                    console.log("[CpdOverview][mounted] Error = ", e);
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Course Module Assessment',
                        detail: "Submitted Questionnaire for Course #3 Module #8. Answers are NOT Correct.",
                        life: 3000
                    })
                });

        },
        submitQuestionnaireCourse3Module9() {
            console.log(this.course3Module9);

            var newCourseAssessmentDto = {
                userId: this.userStore.user.id,
                answer1: this.course3Module9.answer1,
                answer2: this.course3Module9.answer2,
                answer3: this.course3Module9.answer3,
                answer4: this.course3Module9.answer4,
                answer5: this.course3Module9.answer5,
            };

            console.log(newCourseAssessmentDto);

            CourseAssessmentService.processCourseModuleAssessment(this.userStore.user.id, 100, newCourseAssessmentDto)
                .then(data => {
                    console.log("[CpdOverview][mounted] Data = ", data);
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Course Module Assessment',
                        detail: "Submitted Questionnaire for Course #3 Module #9. Answers are Correct.",
                        life: 3000
                    })
                })
                .catch(e => {
                    console.log("[CpdOverview][mounted] Error = ", e);
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Course Module Assessment',
                        detail: "Submitted Questionnaire for Course #3 Module #9. Answers are NOT Correct.",
                        life: 3000
                    })
                });

        },
        submitQuestionnaireCourse3Module10() {
            console.log(this.course3Module10);

            var newCourseAssessmentDto = {
                userId: this.userStore.user.id,
                answer1: this.course3Module10.answer1,
                answer2: this.course3Module10.answer2,
                answer3: this.course3Module10.answer3,
                answer4: this.course3Module10.answer4,
                answer5: this.course3Module10.answer5,
            };

            console.log(newCourseAssessmentDto);

            CourseAssessmentService.processCourseModuleAssessment(this.userStore.user.id, 100, newCourseAssessmentDto)
                .then(data => {
                    console.log("[CpdOverview][mounted] Data = ", data);
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Course Module Assessment',
                        detail: "Submitted Questionnaire for Course #3 Module #10. Answers are Correct.",
                        life: 3000
                    })
                })
                .catch(e => {
                    console.log("[CpdOverview][mounted] Error = ", e);
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Course Module Assessment',
                        detail: "Submitted Questionnaire for Course #3 Module #10. Answers are NOT Correct.",
                        life: 3000
                    })
                });

        },
        submitQuestionnaireCourse3Module11() {
            console.log(this.course3Module11);

            var newCourseAssessmentDto = {
                userId: this.userStore.user.id,
                answer1: this.course3Module11.answer1,
                answer2: this.course3Module11.answer2,
                answer3: this.course3Module11.answer3,
                answer4: this.course3Module11.answer4,
                answer5: this.course3Module11.answer5,
            };

            console.log(newCourseAssessmentDto);

            CourseAssessmentService.processCourseModuleAssessment(this.userStore.user.id, 100, newCourseAssessmentDto)
                .then(data => {
                    console.log("[CpdOverview][mounted] Data = ", data);
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Course Module Assessment',
                        detail: "Submitted Questionnaire for Course #3 Module #11. Answers are Correct.",
                        life: 3000
                    })
                })
                .catch(e => {
                    console.log("[CpdOverview][mounted] Error = ", e);
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Course Module Assessment',
                        detail: "Submitted Questionnaire for Course #3 Module #11. Answers are NOT Correct.",
                        life: 3000
                    })
                });

        },
        submitQuestionnaireCourse3Module12() {
            console.log(this.course3Module12);

            var newCourseAssessmentDto = {
                userId: this.userStore.user.id,
                answer1: this.course3Module12.answer1,
                answer2: this.course3Module12.answer2,
                answer3: this.course3Module12.answer3,
                answer4: this.course3Module12.answer4,
                answer5: this.course3Module12.answer5,
            };

            console.log(newCourseAssessmentDto);

            CourseAssessmentService.processCourseModuleAssessment(this.userStore.user.id, 100, newCourseAssessmentDto)
                .then(data => {
                    console.log("[CpdOverview][mounted] Data = ", data);
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Course Module Assessment',
                        detail: "Submitted Questionnaire for Course #3 Module #12. Answers are Correct.",
                        life: 3000
                    })
                })
                .catch(e => {
                    console.log("[CpdOverview][mounted] Error = ", e);
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Course Module Assessment',
                        detail: "Submitted Questionnaire for Course #3 Module #12. Answers are NOT Correct.",
                        life: 3000
                    })
                });

        },
        submitQuestionnaireCourse3Module13() {
            console.log(this.course3Module13);

            var newCourseAssessmentDto = {
                userId: this.userStore.user.id,
                answer1: this.course3Module13.answer1,
                answer2: this.course3Module13.answer2,
                answer3: this.course3Module13.answer3,
                answer4: this.course3Module13.answer4,
                answer5: this.course3Module13.answer5,
            };

            console.log(newCourseAssessmentDto);

            CourseAssessmentService.processCourseModuleAssessment(this.userStore.user.id, 100, newCourseAssessmentDto)
                .then(data => {
                    console.log("[CpdOverview][mounted] Data = ", data);
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Course Module Assessment',
                        detail: "Submitted Questionnaire for Course #3 Module #13. Answers are Correct.",
                        life: 3000
                    })
                })
                .catch(e => {
                    console.log("[CpdOverview][mounted] Error = ", e);
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Course Module Assessment',
                        detail: "Submitted Questionnaire for Course #3 Module #13. Answers are NOT Correct.",
                        life: 3000
                    })
                });

        },
        submitQuestionnaireCourse3Module14() {
            console.log(this.course3Module14);

            var newCourseAssessmentDto = {
                userId: this.userStore.user.id,
                answer1: this.course3Module14.answer1,
                answer2: this.course3Module14.answer2,
                answer3: this.course3Module14.answer3,
                answer4: this.course3Module14.answer4,
                answer5: this.course3Module14.answer5,
            };

            console.log(newCourseAssessmentDto);

            CourseAssessmentService.processCourseModuleAssessment(this.userStore.user.id, 100, newCourseAssessmentDto)
                .then(data => {
                    console.log("[CpdOverview][mounted] Data = ", data);
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Course Module Assessment',
                        detail: "Submitted Questionnaire for Course #3 Module #14. Answers are Correct.",
                        life: 3000
                    })
                })
                .catch(e => {
                    console.log("[CpdOverview][mounted] Error = ", e);
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Course Module Assessment',
                        detail: "Submitted Questionnaire for Course #3 Module #14. Answers are NOT Correct.",
                        life: 3000
                    })
                });

        },
        submitQuestionnaireCourse4() {
            console.log(this.course4);

            var newCourseAssessmentDto = {
                userId: this.userStore.user.id,
                answer1: this.course4.answer1,
                answer2: this.course4.answer2,
                answer3: this.course4.answer3,
                answer4: this.course4.answer4,
                answer5: this.course4.answer5,
            };

            console.log(newCourseAssessmentDto);

            CourseAssessmentService.processCourseModuleAssessment(this.userStore.user.id, 125, newCourseAssessmentDto)
                .then(data => {
                    console.log("[CpdModule4][submitQuestionnaireModule1] Data = ", data);
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Course Module Assessment',
                        detail: "Submitted Questionnaire for Course 4. Answers are Correct.",
                        life: 3000
                    })
                })
                .catch(e => {
                    console.log("[CpdModule4][submitQuestionnaireModule1] Error = ", e);
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Course Module Assessment',
                        detail: "Submitted Questionnaire for Course 4. Answers are NOT Correct.",
                        life: 3000
                    })
                });
        },
    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
